export const Home = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.85L6 1L11 4.85V10.9C11 11.1917 10.8829 11.4715 10.6746 11.6778C10.4662 11.8841 10.1836 12 9.88889 12H2.11111C1.81643 12 1.53381 11.8841 1.32544 11.6778C1.11706 11.4715 1 11.1917 1 10.9V4.85Z"
        stroke="#3D734A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33398 12V6.5H7.66732V12"
        stroke="#3D734A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDown = ({ color = "#666666" }) => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.92908 1.2186L9.78644 1.07258C9.6919 0.975808 9.53862 0.975808 9.44406 1.07258L5.49999 5.10967L1.55593 1.07258C1.46139 0.975807 1.3081 0.975807 1.21354 1.07258L1.0709 1.2186C0.976365 1.31537 0.976365 1.47227 1.0709 1.56904L5.32881 5.92742C5.42335 6.02419 5.57664 6.02419 5.6712 5.92742L9.92908 1.56904C10.0236 1.47227 10.0236 1.31537 9.92908 1.2186Z"
        stroke={color}
      />
    </svg>
  );
};

export const ChevronLeft = ({ color = "#8f8f8f" }) => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11L1 6L6 1"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRight = ({ color = "#3D734A" }) => {
  return (
    <svg
      width="7"
      height="11"
      viewBox="0 0 7 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2186 1.07092L1.07258 1.21356C0.975808 1.3081 0.975808 1.46138 1.07258 1.55594L5.10967 5.50001L1.07258 9.44407C0.975808 9.53861 0.975808 9.6919 1.07258 9.78646L1.2186 9.9291C1.31537 10.0236 1.47227 10.0236 1.56904 9.9291L5.92742 5.67119C6.02419 5.57665 6.02419 5.42336 5.92742 5.3288L1.56904 1.07092C1.47227 0.97636 1.31537 0.97636 1.2186 1.07092Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export const WhatsApp = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2027 1.74375C9.08036 0.61875 7.58571 0 5.99732 0C2.71875 0 0.0508929 2.66786 0.0508929 5.94643C0.0508929 6.99375 0.324107 8.01696 0.84375 8.91964L0 12L3.15268 11.1723C4.02054 11.6464 4.99821 11.8955 5.99464 11.8955H5.99732C9.27321 11.8955 12 9.22768 12 5.94911C12 4.36071 11.325 2.86875 10.2027 1.74375ZM5.99732 10.8938C5.10804 10.8938 4.2375 10.6554 3.47946 10.2054L3.3 10.0982L1.43036 10.5884L1.92857 8.76429L1.81071 8.57679C1.31518 7.78929 1.05536 6.88125 1.05536 5.94643C1.05536 3.22232 3.27321 1.00446 6 1.00446C7.32054 1.00446 8.56071 1.51875 9.49286 2.45357C10.425 3.38839 10.9982 4.62857 10.9955 5.94911C10.9955 8.67589 8.72143 10.8938 5.99732 10.8938ZM8.70804 7.19196C8.56071 7.11696 7.82946 6.75804 7.69286 6.70982C7.55625 6.65893 7.45714 6.63482 7.35804 6.78482C7.25893 6.93482 6.975 7.26696 6.88661 7.36875C6.80089 7.46786 6.7125 7.48125 6.56518 7.40625C5.69196 6.96964 5.11875 6.62679 4.54286 5.63839C4.39018 5.37589 4.69554 5.39464 4.97946 4.82679C5.02768 4.72768 5.00357 4.64196 4.96607 4.56696C4.92857 4.49196 4.63125 3.76071 4.50804 3.46339C4.3875 3.17411 4.26429 3.21429 4.17321 3.20893C4.0875 3.20357 3.98839 3.20357 3.88929 3.20357C3.79018 3.20357 3.62946 3.24107 3.49286 3.38839C3.35625 3.53839 2.97321 3.89732 2.97321 4.62857C2.97321 5.35982 3.50625 6.06696 3.57857 6.16607C3.65357 6.26518 4.62589 7.76518 6.11786 8.41071C7.06071 8.81786 7.43036 8.85268 7.90179 8.78304C8.18839 8.74018 8.78036 8.42411 8.90357 8.07589C9.02679 7.72768 9.02679 7.43036 8.98929 7.36875C8.95446 7.30179 8.85536 7.26429 8.70804 7.19196Z"
        fill="#999999"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const Instagram = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00134 2.92335C4.29872 2.92335 2.92538 4.297 2.92538 6C2.92538 7.703 4.29872 9.07665 6.00134 9.07665C7.70396 9.07665 9.0773 7.703 9.0773 6C9.0773 4.297 7.70396 2.92335 6.00134 2.92335ZM6.00134 8.00022C4.90106 8.00022 4.00156 7.1032 4.00156 6C4.00156 4.8968 4.89838 3.99978 6.00134 3.99978C7.10429 3.99978 8.00112 4.8968 8.00112 6C8.00112 7.1032 7.10162 8.00022 6.00134 8.00022ZM9.92058 2.7975C9.92058 3.19647 9.59933 3.51512 9.20312 3.51512C8.80424 3.51512 8.48567 3.1938 8.48567 2.7975C8.48567 2.40121 8.80692 2.07988 9.20312 2.07988C9.59933 2.07988 9.92058 2.40121 9.92058 2.7975ZM11.9578 3.52583C11.9123 2.56454 11.6928 1.71304 10.9887 1.01149C10.2873 0.309941 9.43603 0.0903715 8.47496 0.0421734C7.48444 -0.0140578 4.51556 -0.0140578 3.52504 0.0421734C2.56665 0.0876939 1.71534 0.307263 1.01127 1.00881C0.307195 1.71036 0.0903514 2.56187 0.042164 3.52315C-0.0140547 4.51389 -0.0140547 7.48343 0.042164 8.47417C0.0876743 9.43546 0.307195 10.287 1.01127 10.9885C1.71534 11.6901 2.56397 11.9096 3.52504 11.9578C4.51556 12.0141 7.48444 12.0141 8.47496 11.9578C9.43603 11.9123 10.2873 11.6927 10.9887 10.9885C11.6901 10.287 11.9096 9.43546 11.9578 8.47417C12.0141 7.48343 12.0141 4.51657 11.9578 3.52583ZM10.6782 9.53721C10.4694 10.062 10.0651 10.4664 9.53776 10.6779C8.74802 10.9912 6.87407 10.9189 6.00134 10.9189C5.12861 10.9189 3.25198 10.9885 2.46492 10.6779C1.94021 10.469 1.53597 10.0647 1.32448 9.53721C1.01127 8.74729 1.08355 6.87292 1.08355 6C1.08355 5.12708 1.01394 3.25003 1.32448 2.46279C1.5333 1.93797 1.93753 1.53364 2.46492 1.3221C3.25466 1.00881 5.12861 1.08111 6.00134 1.08111C6.87407 1.08111 8.7507 1.01149 9.53776 1.3221C10.0625 1.53096 10.4667 1.93529 10.6782 2.46279C10.9914 3.25271 10.9191 5.12708 10.9191 6C10.9191 6.87292 10.9914 8.74997 10.6782 9.53721Z"
        fill="#999999"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const Twitter = () => {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2834 2.99061C13.2928 3.12186 13.2928 3.25313 13.2928 3.38437C13.2928 7.38748 10.2397 12 4.65952 12C2.94038 12 1.34337 11.5031 0 10.6406C0.244258 10.6687 0.479089 10.6781 0.732744 10.6781C2.15124 10.6781 3.45706 10.2 4.49981 9.38439C3.16584 9.35625 2.04792 8.48438 1.66276 7.28437C1.85066 7.31248 2.03853 7.33124 2.23582 7.33124C2.50825 7.33124 2.7807 7.29372 3.03432 7.22813C1.64399 6.94686 0.601203 5.72812 0.601203 4.25624V4.21876C1.00514 4.44376 1.47489 4.58438 1.97274 4.60311C1.15545 4.05935 0.619999 3.13124 0.619999 2.08123C0.619999 1.51874 0.770278 1.00311 1.03333 0.553111C2.52701 2.39061 4.77224 3.59059 7.28985 3.72186C7.24289 3.49686 7.2147 3.26251 7.2147 3.02813C7.2147 1.35936 8.56747 0 10.249 0C11.1227 0 11.9118 0.365624 12.4661 0.95625C13.1518 0.825006 13.8094 0.571868 14.3919 0.225002C14.1664 0.928142 13.6873 1.51877 13.0579 1.89374C13.6685 1.82815 14.2604 1.65936 14.8052 1.42501C14.3919 2.02499 13.8752 2.55934 13.2834 2.99061Z"
        fill="#999999"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const Facebook = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.82512 6.75L7.15918 4.57828H5.07047V3.16898C5.07047 2.57484 5.36225 1.9957 6.29772 1.9957H7.24728V0.146719C7.24728 0.146719 6.38558 0 5.5617 0C3.84158 0 2.71723 1.04016 2.71723 2.92313V4.57828H0.805176V6.75H2.71723V12H5.07047V6.75H6.82512Z"
        fill="#999999"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const Gift = ({ color = "#737373" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4.30586L9.46562 1.96277C9.84023 1.36395 10.4965 1 11.202 1H11.2812C12.3695 1 13.25 1.88156 13.25 2.96875C13.25 3.58727 12.9656 4.13906 12.5199 4.5H13.6875C14.4121 4.5 15 5.08789 15 5.8125V6.6875C15 7.25898 14.6336 7.7457 14.125 7.92617V13.25C14.125 14.2152 13.3402 15 12.375 15H3.625C2.6584 15 1.875 14.2152 1.875 13.25V7.92617C1.36531 7.7457 1 7.25898 1 6.6875V5.8125C1 5.08789 1.58762 4.5 2.3125 4.5H3.48117C3.0352 4.13906 2.75 3.58727 2.75 2.96875C2.75 1.88156 3.63156 1 4.71875 1H4.79805C5.50352 1 6.1625 1.36395 6.53437 1.96277L8 4.30586ZM11.202 1.4375C10.6469 1.4375 10.1301 1.72352 9.83477 2.19465L8.39375 4.5H11.2812C12.1262 4.5 12.8125 3.81367 12.8125 2.96875C12.8125 2.12301 12.1262 1.4375 11.2812 1.4375H11.202ZM7.60625 4.5L6.16523 2.19465C5.86992 1.72352 5.35312 1.4375 4.79805 1.4375H4.71875C3.87383 1.4375 3.1875 2.12301 3.1875 2.96875C3.1875 3.81367 3.87383 4.5 4.71875 4.5H7.60625ZM2.3125 4.9375C1.82934 4.9375 1.4375 5.32852 1.4375 5.8125V6.6875C1.4375 7.17148 1.82934 7.5625 2.3125 7.5625H7.78125V4.9375H2.3125ZM8.21875 7.5625H13.6875C14.1715 7.5625 14.5625 7.17148 14.5625 6.6875V5.8125C14.5625 5.32852 14.1715 4.9375 13.6875 4.9375H8.21875V7.5625ZM7.78125 8H2.3125V13.25C2.3125 13.9746 2.90012 14.5625 3.625 14.5625H7.78125V8ZM12.375 14.5625C13.0996 14.5625 13.6875 13.9746 13.6875 13.25V8H8.21875V14.5625H12.375Z"
        fill={color}
        fillOpacity="1"
      />
      <path
        d="M9.38085 1.90974L9.46471 1.9622L9.38084 1.90974L8 4.11729L6.61933 1.91002C6.6193 1.90997 6.61927 1.90992 6.61924 1.90988C6.22897 1.28153 5.53778 0.9 4.79805 0.9H4.71875C3.57633 0.9 2.65 1.82633 2.65 2.96875C2.65 3.5242 2.86897 4.02848 3.225 4.4H2.3125C1.53238 4.4 0.9 5.03268 0.9 5.8125V6.6875C0.9 7.27744 1.26167 7.7832 1.775 7.99492V13.25C1.775 14.2704 2.60312 15.1 3.625 15.1H12.375C13.3955 15.1 14.225 14.2705 14.225 13.25V7.99487C14.7373 7.78315 15.1 7.2775 15.1 6.6875V5.8125C15.1 5.03266 14.4673 4.4 13.6875 4.4H12.7759C13.1317 4.02844 13.35 3.52414 13.35 2.96875C13.35 1.82637 12.4248 0.9 11.2812 0.9H11.202C10.462 0.9 9.7737 1.28175 9.38085 1.90974ZM8.57419 4.4L9.9195 2.24776C10.1965 1.80577 10.6813 1.5375 11.202 1.5375H11.2812C12.071 1.5375 12.7125 2.17827 12.7125 2.96875C12.7125 3.75844 12.0709 4.4 11.2812 4.4H8.57419ZM4.79805 1.5375C5.31866 1.5375 5.80346 1.80577 6.0805 2.24776L7.42581 4.4H4.71875C3.92906 4.4 3.2875 3.75844 3.2875 2.96875C3.2875 2.17827 3.92902 1.5375 4.71875 1.5375H4.79805ZM1.5375 5.8125C1.5375 5.38381 1.8845 5.0375 2.3125 5.0375H7.68125V7.4625H2.3125C1.8845 7.4625 1.5375 7.11619 1.5375 6.6875V5.8125ZM13.6875 7.4625H8.31875V5.0375H13.6875C14.1163 5.0375 14.4625 5.38374 14.4625 5.8125V6.6875C14.4625 7.11626 14.1163 7.4625 13.6875 7.4625ZM2.4125 13.25V8.1H7.68125V14.4625H3.625C2.95536 14.4625 2.4125 13.9194 2.4125 13.25ZM13.5875 13.25C13.5875 13.9194 13.0444 14.4625 12.375 14.4625H8.31875V8.1H13.5875V13.25Z"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const GiftB = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.325 2.10031C8.09893 3.3376 9.90107 3.3376 10.675 2.10031C11.1031 1.41594 11.8531 1 12.6594 1H12.75C13.9937 1 15 2.0075 15 3.25C15 3.47983 14.9656 3.70161 14.9018 3.91044C14.7715 4.33624 15.0547 5 15.5 5C16.3281 5 17 5.67188 17 6.5V7.5C17 7.64893 16.9782 7.79281 16.9377 7.92867C16.6958 8.74009 16 9.4814 16 10.3281V15C16 16.1031 15.1031 17 14 17H4C2.89531 17 2 16.1031 2 15V10.3291C2 9.48191 1.30315 8.74014 1.06192 7.92798C1.02163 7.79233 1 7.64867 1 7.5V6.5C1 5.67188 1.67156 5 2.5 5C2.94555 5 3.22874 4.33579 3.09828 3.90977C3.03438 3.70113 3 3.47959 3 3.25C3 2.0075 4.0075 1 5.25 1H5.34062C6.14687 1 6.9 1.41594 7.325 2.10031ZM12.6594 1.5C12.025 1.5 11.4344 1.82687 11.0969 2.36531C10.38 3.51222 11.2045 5 12.5571 5H12.75C13.7156 5 14.5 4.21563 14.5 3.25C14.5 2.28344 13.7156 1.5 12.75 1.5H12.6594ZM5.44295 5C6.79548 5 7.62003 3.51222 6.90312 2.36531C6.56562 1.82687 5.975 1.5 5.34062 1.5H5.25C4.28437 1.5 3.5 2.28344 3.5 3.25C3.5 4.21563 4.28437 5 5.25 5H5.44295ZM2.5 5.5C1.94781 5.5 1.5 5.94688 1.5 6.5V7.5C1.5 8.05312 1.94781 8.5 2.5 8.5H7.25C8.07843 8.5 8.75 7.82843 8.75 7C8.75 6.17157 8.07843 5.5 7.25 5.5H2.5ZM9.25 7C9.25 7.82843 9.92157 8.5 10.75 8.5H15.5C16.0531 8.5 16.5 8.05312 16.5 7.5V6.5C16.5 5.94688 16.0531 5.5 15.5 5.5H10.75C9.92157 5.5 9.25 6.17157 9.25 7ZM8.75 11C8.75 9.89543 7.85457 9 6.75 9H4.5C3.39543 9 2.5 9.89543 2.5 11V15C2.5 15.8281 3.17156 16.5 4 16.5H6.75C7.85457 16.5 8.75 15.6046 8.75 14.5V11ZM14 16.5C14.8281 16.5 15.5 15.8281 15.5 15V11C15.5 9.89543 14.6046 9 13.5 9H11.25C10.1454 9 9.25 9.89543 9.25 11V14.5C9.25 15.6046 10.1454 16.5 11.25 16.5H14Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export const GiftC = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.46484 1.6125L5.28047 3H5.25H3.5625C3.04453 3 2.625 2.58047 2.625 2.0625C2.625 1.54453 3.04453 1.125 3.5625 1.125H3.61406C3.96328 1.125 4.28906 1.31016 4.46484 1.6125ZM1.5 2.0625C1.5 2.4 1.58203 2.71875 1.725 3H0.75C0.335156 3 0 3.33516 0 3.75V5.25C0 5.66484 0.335156 6 0.75 6H11.25C11.6648 6 12 5.66484 12 5.25V3.75C12 3.33516 11.6648 3 11.25 3H10.275C10.418 2.71875 10.5 2.4 10.5 2.0625C10.5 0.923438 9.57656 0 8.4375 0H8.38594C7.63828 0 6.94453 0.396094 6.56484 1.04063L6 2.00391L5.43516 1.04297C5.05547 0.396094 4.36172 0 3.61406 0H3.5625C2.42344 0 1.5 0.923438 1.5 2.0625ZM9.375 2.0625C9.375 2.58047 8.95547 3 8.4375 3H6.75H6.71953L7.53516 1.6125C7.71328 1.31016 8.03672 1.125 8.38594 1.125H8.4375C8.95547 1.125 9.375 1.54453 9.375 2.0625ZM0.75 6.75V10.875C0.75 11.4961 1.25391 12 1.875 12H5.25V6.75H0.75ZM6.75 12H10.125C10.7461 12 11.25 11.4961 11.25 10.875V6.75H6.75V12Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const Bag = ({ size = 16, color = "#3d734a" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.84257 1L0.861084 3.8V13.6C0.861084 13.9713 1.00026 14.3274 1.24799 14.5899C1.49573 14.8525 1.83172 15 2.18207 15H11.429C11.7793 15 12.1153 14.8525 12.3631 14.5899C12.6108 14.3274 12.75 13.9713 12.75 13.6V3.8L10.7685 1H2.84257Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.861084 3.79999H12.75"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.44753 6.6001C9.44753 7.3427 9.16917 8.05489 8.67371 8.58C8.17824 9.1051 7.50625 9.4001 6.80555 9.4001C6.10485 9.4001 5.43286 9.1051 4.93739 8.58C4.44192 8.05489 4.16357 7.3427 4.16357 6.6001"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const User = ({ size = 13, color = "#3D734A" }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.47119 7.875C7.69592 7.875 7.32315 8.3125 6.05085 8.3125C4.77855 8.3125 4.40847 7.875 3.63051 7.875C1.62617 7.875 0 9.52109 0 11.55V12.6875C0 13.4121 0.580773 14 1.29661 14H10.8051C11.5209 14 12.1017 13.4121 12.1017 12.6875V11.55C12.1017 9.52109 10.4755 7.875 8.47119 7.875ZM11.2373 12.6875C11.2373 12.9281 11.0428 13.125 10.8051 13.125H1.29661C1.0589 13.125 0.864407 12.9281 0.864407 12.6875V11.55C0.864407 10.0051 2.10429 8.75 3.63051 8.75C4.15996 8.75 4.68671 9.1875 6.05085 9.1875C7.41229 9.1875 7.94174 8.75 8.47119 8.75C9.99741 8.75 11.2373 10.0051 11.2373 11.55V12.6875ZM6.05085 7C7.96065 7 9.50847 5.4332 9.50847 3.5C9.50847 1.5668 7.96065 0 6.05085 0C4.14105 0 2.59322 1.5668 2.59322 3.5C2.59322 5.4332 4.14105 7 6.05085 7ZM6.05085 0.875C7.47982 0.875 8.64407 2.05352 8.64407 3.5C8.64407 4.94648 7.47982 6.125 6.05085 6.125C4.62187 6.125 3.45763 4.94648 3.45763 3.5C3.45763 2.05352 4.62187 0.875 6.05085 0.875Z"
        fill={color}
      />
    </svg>
  );
};

export const Star = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.57084 0.278289L2.5944 2.34678L0.409726 2.67955C0.017951 2.73892 -0.139058 3.24355 0.145054 3.53257L1.72561 5.14175L1.35178 7.41491C1.28449 7.82579 1.6987 8.13357 2.04561 7.9414L4 6.8681L5.95439 7.9414C6.30131 8.132 6.71551 7.82579 6.64822 7.41491L6.27439 5.14175L7.85495 3.53257C8.13906 3.24355 7.98205 2.73892 7.59027 2.67955L5.40561 2.34678L4.42916 0.278289C4.25421 -0.0904157 3.74729 -0.0951027 3.57084 0.278289Z"
        fill="#F2B950"
      />
    </svg>
  );
};

export const TicketA = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1202 2.4423L10.1764 0.79221C9.91576 0.336545 9.34242 0.169846 8.89578 0.419873L0.808707 4.94695C0.362065 5.19698 0.211278 5.76904 0.47191 6.2247L1.41573 7.87479C1.86237 7.62477 2.43572 7.79147 2.69635 8.24713C2.95698 8.7028 2.80619 9.27486 2.35955 9.52488L3.30337 11.175C3.564 11.6306 4.13735 11.7973 4.58399 11.5473L12.6711 7.02024C13.1177 6.77021 13.2685 6.19815 13.0079 5.74248L12.064 4.09239C11.6174 4.34242 11.044 4.17572 10.7834 3.72005C10.5228 3.26439 10.6736 2.69233 11.1202 2.4423Z"
        fill="#99BDCC"
      />
    </svg>
  );
};

export const TicketB = () => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.01567 11.5306C5.71606 11.0116 5.90401 10.3441 6.43625 10.0368L14.1343 5.59236C14.6665 5.28507 15.3386 5.45606 15.6382 5.975L17.8048 9.72778C18.1044 10.2467 17.9165 10.9142 17.3843 11.2215L9.68625 15.666C9.15401 15.9733 8.48194 15.8023 8.18234 15.2833L6.01567 11.5306ZM9.14459 14.7278L16.8426 10.2833L14.6759 6.53055L6.97792 10.975L9.14459 14.7278ZM18.4038 1.87639L19.758 4.22187C18.9611 4.68194 18.6786 5.68556 19.1271 6.4625C19.5757 7.23944 20.5861 7.49652 21.383 7.03646L22.7372 9.38194C23.3347 10.4169 22.9575 11.7566 21.896 12.3694L8.4245 20.1472C7.36151 20.7609 6.01419 20.4169 5.41667 19.3819L4.0625 17.0365C4.85966 16.5762 5.14194 15.5728 4.69338 14.7958C4.24481 14.0189 3.23466 13.7616 2.4375 14.2219L1.08333 11.8764C0.484961 10.84 0.861515 9.5026 1.9245 8.88889L15.396 1.11111C16.4575 0.498263 17.8055 0.839977 18.4038 1.87639ZM2.9715 12.9246C4.02919 12.7947 5.10042 13.2786 5.65563 14.2403C6.21083 15.2019 6.07906 16.3452 5.45301 17.2227L6.37892 18.8264C6.67853 19.3453 7.35149 19.5158 7.88283 19.209L21.3543 11.4312C21.8866 11.124 22.0745 10.4564 21.7749 9.9375L20.849 8.33377C19.7746 8.43809 18.7201 7.9797 18.1649 7.01805C17.6097 6.0564 17.7247 4.88761 18.3675 4.03567L17.4416 2.43194C17.142 1.91301 16.4699 1.74201 15.9377 2.0493L2.46617 9.82708C1.93482 10.1339 1.74597 10.8019 2.04558 11.3208L2.9715 12.9246Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const Check = ({ color = "#999", size = 12 }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1L4.125 8L1 4.81818"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmptyOrders = () => {
  return (
    <svg
      width="82"
      height="81"
      viewBox="0 0 82 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.742459 17.5863C0.482919 17.6593 0.262929 17.8322 0.130751 18.0672C-0.0014268 18.3022 -0.0350025 18.58 0.037391 18.8397L17.0379 79.5541C17.1109 79.8136 17.2839 80.0336 17.5189 80.1658C17.7539 80.298 18.0317 80.3316 18.2914 80.2592L80.964 62.7103C81.2235 62.6373 81.4435 62.4643 81.5757 62.2294C81.7079 61.9944 81.7415 61.7166 81.6691 61.4569L64.6685 0.742457C64.5955 0.482918 64.4226 0.262932 64.1876 0.130753C63.9526 -0.00142597 63.6748 -0.035002 63.4151 0.0373892L0.742459 17.5863Z"
        fill="#E6E6E6"
      />
      <path
        d="M18.5397 75.4663C18.8375 76.53 19.9412 77.1508 21.0049 76.853L76.8761 61.2086C77.9397 60.9107 78.5606 59.807 78.2627 58.7434L63.1666 4.83034C62.8688 3.76669 61.7651 3.14586 60.7014 3.44369L4.83022 19.0881C3.76656 19.3859 3.14574 20.4896 3.44357 21.5533L18.5397 75.4663Z"
        fill="#FCFCFC"
      />
      <path
        d="M10.8006 27.3406C10.4021 27.4521 10.2378 28.114 10.4344 28.816C10.6309 29.5179 11.115 29.9982 11.5135 29.8866L38.7523 22.2596C39.1508 22.148 39.315 21.4861 39.1185 20.7842C38.9219 20.0822 38.4378 19.6019 38.0394 19.7135L10.8006 27.3406Z"
        fill="#E6E6E6"
      />
      <path
        d="M12.9942 35.1747C12.5957 35.2863 12.4314 35.9481 12.628 36.6501C12.8245 37.352 13.3086 37.8323 13.7071 37.7208L40.9459 30.0937C41.3444 29.9821 41.5086 29.3202 41.3121 28.6183C41.1155 27.9164 40.6314 27.436 40.233 27.5476L12.9942 35.1747Z"
        fill="#E6E6E6"
      />
      <path
        d="M15.1624 42.9185C14.7639 43.03 14.5996 43.6919 14.7962 44.3938C14.9927 45.0958 15.4769 45.5761 15.8753 45.4645L43.1141 37.8374C43.5126 37.7259 43.6769 37.064 43.4803 36.3621C43.2838 35.6601 42.7997 35.1798 42.4012 35.2914L15.1624 42.9185Z"
        fill="#E6E6E6"
      />
      <path
        d="M17.356 50.7526C16.9575 50.8641 16.7932 51.526 16.9898 52.2279C17.1863 52.9299 17.6705 53.4102 18.0689 53.2986L45.3077 45.6715C45.7062 45.56 45.8705 44.8981 45.6739 44.1962C45.4774 43.4942 44.9933 43.0139 44.5948 43.1255L17.356 50.7526Z"
        fill="#E6E6E6"
      />
      <path
        d="M51.8628 15.9332C51.6954 15.9798 51.5389 16.059 51.4021 16.1662C51.2654 16.2734 51.1512 16.4065 51.0659 16.5579C50.9806 16.7092 50.926 16.8759 50.9053 17.0484C50.8845 17.2209 50.8979 17.3958 50.9447 17.5631C50.9916 17.7304 51.0709 17.8868 51.1783 18.0234C51.2856 18.16 51.4188 18.2742 51.5703 18.3592C51.7218 18.4443 51.8885 18.4987 52.061 18.5193C52.2336 18.5399 52.4084 18.5263 52.5757 18.4793L57.6678 17.0534C58.0055 16.9589 58.2917 16.7341 58.4636 16.4285C58.6355 16.1229 58.679 15.7616 58.5844 15.4239C58.4899 15.0863 58.2651 14.8 57.9595 14.6282C57.6539 14.4563 57.2925 14.4128 56.9549 14.5073L51.8628 15.9332Z"
        fill="#E6E6E6"
      />
      <path
        d="M54.0139 23.6154C53.8465 23.6621 53.69 23.7413 53.5533 23.8485C53.4165 23.9556 53.3023 24.0887 53.217 24.2401C53.1318 24.3915 53.0772 24.5582 53.0564 24.7307C53.0356 24.9032 53.049 25.078 53.0958 25.2454C53.1427 25.4127 53.222 25.5691 53.3294 25.7057C53.4367 25.8423 53.57 25.9564 53.7214 26.0415C53.8729 26.1266 54.0397 26.181 54.2122 26.2016C54.3847 26.2222 54.5596 26.2085 54.7268 26.1615L59.819 24.7357C60.1566 24.6411 60.4428 24.4163 60.6147 24.1108C60.7866 23.8052 60.8301 23.4438 60.7355 23.1062C60.641 22.7685 60.4162 22.4823 60.1106 22.3104C59.805 22.1385 59.4437 22.0951 59.106 22.1896L54.0139 23.6154Z"
        fill="#E6E6E6"
      />
      <path
        d="M56.1649 31.2977C55.9977 31.3445 55.8414 31.4238 55.7048 31.531C55.5683 31.6382 55.4542 31.7713 55.3691 31.9226C55.284 32.0739 55.2295 32.2405 55.2088 32.4129C55.1881 32.5853 55.2015 32.76 55.2483 32.9272C55.2951 33.0944 55.3744 33.2507 55.4816 33.3872C55.5888 33.5238 55.7219 33.6378 55.8732 33.723C56.0245 33.8081 56.1911 33.8625 56.3635 33.8833C56.5359 33.904 56.7106 33.8906 56.8778 33.8438L61.9699 32.4179C62.3076 32.3234 62.5938 32.0986 62.7657 31.793C62.9376 31.4874 62.9811 31.1261 62.8865 30.7884C62.792 30.4508 62.5672 30.1645 62.2616 29.9927C61.956 29.8208 61.5947 29.7773 61.257 29.8718L56.1649 31.2977Z"
        fill="#E6E6E6"
      />
      <path
        d="M58.316 38.9799C57.9787 39.0748 57.6929 39.2996 57.5213 39.6051C57.3498 39.9105 57.3064 40.2716 57.4009 40.609C57.4954 40.9464 57.7199 41.2325 58.0252 41.4044C58.3304 41.5763 58.6915 41.6201 59.0289 41.526L64.1211 40.1001C64.4584 40.0053 64.7442 39.7804 64.9158 39.475C65.0874 39.1695 65.1307 38.8084 65.0362 38.471C64.9417 38.1337 64.7172 37.8476 64.4119 37.6756C64.1067 37.5037 63.7457 37.46 63.4082 37.5541L58.316 38.9799Z"
        fill="#E6E6E6"
      />
      <path
        d="M60.3711 52.2959C60.1578 52.3553 59.9584 52.4562 59.7842 52.5928C59.6099 52.7294 59.4644 52.8989 59.3557 53.0918C59.2471 53.2847 59.1775 53.4971 59.151 53.7169C59.1245 53.9367 59.1416 54.1595 59.2013 54.3727C59.261 54.5859 59.3621 54.7852 59.4989 54.9593C59.6357 55.1333 59.8054 55.2787 59.9984 55.3872C60.1914 55.4956 60.4039 55.5649 60.6237 55.5911C60.8436 55.6174 61.0664 55.6 61.2795 55.5401L67.768 53.7233C68.1982 53.6028 68.5629 53.3164 68.782 52.927C69.001 52.5376 69.0564 52.0772 68.9359 51.6469C68.8154 51.2167 68.529 50.852 68.1396 50.633C67.7502 50.4139 67.2898 50.3586 66.8596 50.479L60.3711 52.2959Z"
        fill="#3D734A"
        fillOpacity="0.29"
      />
      <path
        d="M67.0488 45.7438L19.0349 59.1881L19.1544 59.6149L67.1683 46.1706L67.0488 45.7438Z"
        fill="#E6E6E6"
      />
    </svg>
  );
};

export const TicketEmpty = () => {
  return (
    <svg
      width="74"
      height="91"
      viewBox="0 0 74 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.5962 76.9819L54.5031 80.2223C52.9802 76.7476 49.0337 74.8699 45.2116 75.894C41.3895 76.9181 38.9106 80.5175 39.3291 84.2882L27.236 87.5285C24.1939 88.3436 21.1483 86.606 20.3799 83.7382L3.33499 20.1257C2.56656 17.2579 4.33532 14.2302 7.37736 13.4151L19.4704 10.1748C20.9934 13.6495 24.9399 15.5272 28.762 14.5031C32.5841 13.479 35.0629 9.87955 34.6445 6.1089L46.7376 2.86857C49.7796 2.05346 52.8253 3.79109 53.5937 6.65889L70.6386 70.2714C71.407 73.1392 69.6383 76.1668 66.5962 76.9819Z"
        fill="#FCFCFC"
        stroke="#E6E6E6"
        strokeWidth="2.3"
      />
      <line
        x1="54.3133"
        y1="55.7084"
        x2="27.5571"
        y2="62.8777"
        stroke="#3D734A"
        strokeOpacity="0.29"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeDasharray="4.6 4.6"
      />
      <line
        x1="46.5486"
        y1="26.7306"
        x2="19.7925"
        y2="33.8999"
        stroke="#3D734A"
        strokeOpacity="0.29"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeDasharray="4.6 4.6"
      />
    </svg>
  );
};

export const TicketGreen = () => {
  return (
    <svg
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5874 5.98189L24.3308 1.99396C23.7076 0.89271 22.3368 0.489834 21.269 1.0941L1.93354 12.0351C0.865662 12.6394 0.505146 14.0219 1.12829 15.1232L3.38488 19.1111C4.45275 18.5068 5.82356 18.9097 6.44671 20.011C7.06986 21.1122 6.70934 22.4948 5.64146 23.099L7.89804 27.087C8.52119 28.1882 9.892 28.5911 10.9599 27.9868L30.2953 17.0458C31.3632 16.4415 31.7237 15.059 31.1005 13.9577L28.844 9.96982C27.7761 10.5741 26.4053 10.1712 25.7821 9.06995C25.159 7.9687 25.5195 6.58615 26.5874 5.98189Z"
        fill="url(#paint0_linear_177_763)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_177_763"
          x1="26.9007"
          y1="8.51766"
          x2="8.32079e-07"
          y2="24.6581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3D734A" />
          <stop offset="1" stopColor="#3D734A" stopOpacity="0.55" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const TicketWhite = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9479 3.35631C18.8722 3.49605 18.8115 3.64164 18.7657 3.79078L19.2437 3.93752C19.093 4.42828 19.1462 4.96829 19.3916 5.43258L18.9495 5.66619C19.0953 5.94207 19.295 6.19565 19.5459 6.41029C19.7968 6.62493 20.0783 6.78291 20.3734 6.88419L20.5357 6.41126C21.0324 6.58171 21.5741 6.55059 22.0356 6.32571L22.2546 6.77518C22.3949 6.70684 22.5293 6.62433 22.6556 6.52789L23.0729 6.88478L23.3979 6.50482L24.912 7.79994L24.5869 8.17989L25.344 8.82745C25.4979 8.95912 25.6186 9.113 25.7063 9.27885L26.1483 9.04525C26.3937 9.50954 26.4469 10.0496 26.2962 10.5403L25.8182 10.3936C25.7641 10.5697 25.6744 10.7371 25.5472 10.8858L24.9193 11.6199L25.2993 11.9449L24.0434 13.4131L23.6634 13.0881L22.4076 14.5563L22.7875 14.8813L21.5316 16.3495L21.1517 16.0245L19.8958 17.4927L20.2758 17.8177L19.0199 19.2859L18.6399 18.9609L17.3841 20.4291L17.764 20.7541L16.5082 22.2223L16.1282 21.8973L14.8723 23.3654L15.2523 23.6905L13.9964 25.1587L13.6165 24.8336L12.9885 25.5677C12.8613 25.7164 12.7099 25.831 12.5442 25.9117L12.7633 26.3612C12.3018 26.5861 11.76 26.6172 11.2633 26.4468L11.4256 25.9738C11.2482 25.9129 11.0775 25.8175 10.9235 25.6859L10.1665 25.0383L9.84149 25.4183L8.32741 24.1231L8.65242 23.7432L8.2352 23.3863C8.3109 23.2466 8.37159 23.101 8.41738 22.9518L7.93939 22.8051C8.09005 22.3143 8.03686 21.7743 7.79151 21.31L8.23358 21.0764C8.0878 20.8005 7.88811 20.547 7.63718 20.3323C7.38626 20.1177 7.1048 19.9597 6.80966 19.8584L6.64737 20.3313C6.15066 20.1609 5.60894 20.192 5.14744 20.4169L4.92842 19.9674C4.78817 20.0358 4.65375 20.1183 4.52742 20.2147L4.1102 19.8578L3.78519 20.2378L2.27111 18.9427L2.59612 18.5627L1.83909 17.9152C1.68516 17.7835 1.56445 17.6296 1.47681 17.4638L1.03474 17.6974C0.789388 17.2331 0.736202 16.6931 0.886858 16.2023L1.36484 16.349C1.41892 16.1729 1.50865 16.0055 1.63583 15.8568L2.26377 15.1227L1.88381 14.7977L3.13968 13.3295L3.51964 13.6545L4.77551 12.1863L4.39555 11.8613L5.65142 10.3931L6.03138 10.7181L7.28725 9.24994L6.9073 8.92493L8.16317 7.45674L8.54313 7.78175L9.799 6.31355L9.41904 5.98854L10.6749 4.52035L11.0549 4.84536L12.3107 3.37717L11.9308 3.05216L13.1867 1.58396L13.5666 1.90897L14.1946 1.17487C14.3217 1.02619 14.4732 0.911613 14.6388 0.830892L14.4198 0.381416C14.8813 0.156539 15.423 0.125412 15.9197 0.29586L15.7574 0.76879C15.9349 0.829674 16.1056 0.925082 16.2595 1.05675L17.0166 1.7043L17.3416 1.32435L18.8557 2.61946L18.5306 2.99942L18.9479 3.35631Z"
        fill="#F7F7F7"
        stroke="#EAEAEA"
        strokeDasharray="2 2"
      />
    </svg>
  );
};

export const Home2 = ({ color = "#C4C4C4" }) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7.56125C1 6.95368 1.27618 6.37906 1.75061 5.99951L6.75061 1.99951C7.48105 1.41516 8.51895 1.41516 9.24939 1.99951L14.2494 5.99951C14.7238 6.37906 15 6.95368 15 7.56125V15.4C15 15.8243 14.8361 16.2313 14.5444 16.5314C14.2527 16.8314 13.857 17 13.4444 17H2.55556C2.143 17 1.74733 16.8314 1.45561 16.5314C1.16389 16.2313 1 15.8243 1 15.4V7.56125Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.6665 17V11C5.6665 9.89543 6.56193 9 7.6665 9H8.33317C9.43774 9 10.3332 9.89543 10.3332 11V17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Orders = ({ color = "#C4C4C4" }) => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.04293 1H15.9571C16.5351 1 17 1.46911 17 2.04293V3.43351C17 4.01152 16.5309 4.47644 15.9571 4.47644H14.5665V3.78115H15.9571C16.1497 3.78115 16.3047 3.62618 16.3047 3.43351V2.04293C16.3047 1.85026 16.1497 1.69529 15.9571 1.69529H2.04293C1.85026 1.69529 1.69529 1.85026 1.69529 2.04293V3.43351C1.69529 3.62618 1.85026 3.78115 2.04293 3.78115H3.43351V4.47644H2.04293C1.46492 4.47644 1 4.00733 1 3.43351V2.04293C1 1.46492 1.46492 1 2.04293 1Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M15.6095 2.39062H2.39062V3.08591H15.6095V2.39062Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M3.43359 2.39062H14.5666V14.4116L12.7404 15.2325L11.4252 14.5372L9.90061 15.2325L8.63988 14.5372L7.21579 15.2325L5.87548 14.5372L4.65244 15.2618L3.43359 14.3194V2.39062V2.39062ZM13.8671 3.08591H4.12888V13.9802L4.70689 14.4283L5.8671 13.754L7.23673 14.4493L8.6692 13.754L9.93412 14.4493L11.4503 13.754L12.7697 14.4493L13.8671 13.9634V3.08591V3.08591Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.4766 4.8241H6.91016V5.51938H12.4766V4.8241Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M6.21482 4.8241H5.51953V5.51938H6.21482V4.8241Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.4766 6.4325H6.91016V7.12778H12.4766V6.4325Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M6.21482 6.4325H5.51953V7.12778H6.21482V6.4325Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.4766 8.00317H6.91016V8.69846H12.4766V8.00317Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M6.21482 8.00317H5.51953V8.69846H6.21482V8.00317Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.4766 9.6073H6.91016V10.3026H12.4766V9.6073Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M6.21482 9.6073H5.51953V10.3026H6.21482V9.6073Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.4766 11.2157H6.91016V11.911H12.4766V11.2157Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M6.21482 11.2157H5.51953V11.911H6.21482V11.2157Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Profile = ({ color = "#C4C4C4" }) => {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0254 17C13.3269 17 13.5608 16.7245 13.5348 16.4126C13.2489 13.0546 10.5562 10.4243 7.27098 10.4243C3.98573 10.4243 1.28787 13.0546 1.00197 16.4126C0.975983 16.7245 1.2099 17 1.5114 17H13.0254Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.27094 8.22547C9.2662 8.22547 10.8837 6.60799 10.8837 4.61274C10.8837 2.61748 9.2662 1 7.27094 1C5.27568 1 3.6582 2.61748 3.6582 4.61274C3.6582 6.60799 5.27568 8.22547 7.27094 8.22547Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const MapMarker = ({ size = 10 }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0C2.23706 0 0 2.18395 0 4.875C0 6.68071 0.624766 7.24499 3.93935 12.4268C4.42854 13.1915 5.572 13.1906 6.06062 12.4268C9.37695 7.24227 10 6.68035 10 4.875C10 2.18113 7.76005 0 5 0ZM5 11.7813C1.68167 6.59359 1.25 6.2661 1.25 4.875C1.25 2.85571 2.92893 1.21875 5 1.21875C7.07107 1.21875 8.75 2.85571 8.75 4.875C8.75 6.26014 8.35505 6.53619 5 11.7813ZM2.91667 4.875C2.91667 3.75317 3.8494 2.84375 5 2.84375C6.1506 2.84375 7.08333 3.75317 7.08333 4.875C7.08333 5.99684 6.1506 6.90625 5 6.90625C3.8494 6.90625 2.91667 5.99684 2.91667 4.875Z"
        fill="#999999"
      />
    </svg>
  );
};

export const MapMarkerB = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4327 6.72727C12.4327 9.95355 9.43414 12.846 7.78052 14.1958C7.15405 14.7072 6.27868 14.7072 5.65221 14.1958C3.99859 12.846 1 9.95355 1 6.72727C1 5.20831 1.60226 3.75155 2.67428 2.67748C3.74631 1.60341 5.20029 1 6.71637 1C8.23244 1 9.68642 1.60341 10.7584 2.67748C11.8305 3.75155 12.4327 5.20831 12.4327 6.72727Z"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.71649 8.6363C7.76884 8.6363 8.62195 7.78157 8.62195 6.72721C8.62195 5.67284 7.76884 4.81812 6.71649 4.81812C5.66414 4.81812 4.81104 5.67284 4.81104 6.72721C4.81104 7.78157 5.66414 8.6363 6.71649 8.6363Z"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SavesLifes = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.09961C11.0028 1.09971 12.8321 1.84527 14.2275 3.0752L14.5801 3.38574L14.9121 3.05371L15.2832 2.68164L15.2842 2.68066C15.2863 2.67859 15.288 2.67757 15.29 2.67676C15.2925 2.67578 15.2959 2.6748 15.2998 2.6748C15.3036 2.67483 15.3072 2.67579 15.3096 2.67676L15.3154 2.68066L15.3184 2.68359C15.3271 2.69222 15.327 2.70431 15.3184 2.71387L14.9297 3.07617L14.5693 3.41211L14.8984 3.77734C16.1534 5.16953 16.8994 6.99751 16.8994 9C16.8993 11.0023 16.1535 12.8298 14.8984 14.2236L14.582 14.5752L14.2236 14.8984C12.8298 16.1535 11.0023 16.8993 9 16.8994C6.99751 16.8994 5.16953 16.1534 3.77734 14.8984L3.41211 14.5693L3.07617 14.9297L2.71387 15.3184C2.70934 15.3226 2.7047 15.3253 2.69922 15.3252L2.68359 15.3184L2.68066 15.3154L2.67676 15.3096C2.67579 15.3072 2.67483 15.3036 2.6748 15.2998C2.6748 15.2959 2.67578 15.2925 2.67676 15.29L2.68066 15.2842L2.68164 15.2832L3.05371 14.9121L3.38574 14.5801L3.0752 14.2275C1.84527 12.8321 1.09971 11.0028 1.09961 9C1.09961 6.997 1.84539 5.16716 3.0752 3.77344L3.38574 3.42188L3.05371 3.08984L2.68262 2.71777L2.68164 2.7168L2.6748 2.69922L2.68164 2.68262L2.68262 2.68164C2.68716 2.6772 2.6931 2.67489 2.69922 2.6748L2.7168 2.68164L2.71777 2.68262L3.08984 3.05371L3.42188 3.38574L3.77344 3.0752C5.16716 1.84539 6.997 1.09961 9 1.09961ZM10.5352 11.1602C10.1008 11.4672 9.57125 11.6493 9 11.6494C8.4286 11.6494 7.8983 11.4673 7.46387 11.1602L7.12012 10.917L6.82227 11.2148L3.83301 14.2012L3.45312 14.5801L3.8584 14.9326C5.23556 16.1275 7.0346 16.8496 9 16.8496C10.9652 16.8495 12.7636 16.1274 14.1406 14.9326L14.5469 14.5801L14.167 14.2012L11.1777 11.2148L10.8789 10.917L10.5352 11.1602ZM14.9307 14.9248L15.3193 15.2842V15.2852C15.3217 15.2875 15.3235 15.2893 15.3242 15.291C15.3251 15.2931 15.3252 15.2964 15.3252 15.2998C15.3252 15.3029 15.325 15.3056 15.3242 15.3076L15.3193 15.3145L15.3145 15.3193C15.3121 15.3217 15.3094 15.3235 15.3076 15.3242C15.3056 15.325 15.3029 15.3252 15.2998 15.3252C15.2964 15.3252 15.2931 15.3251 15.291 15.3242L15.2852 15.3193L14.9248 14.9307L14.8525 14.8525L14.9307 14.9248ZM3.06641 3.8584C1.87234 5.23541 1.14941 7.03448 1.14941 9C1.14951 10.9653 1.87248 12.7637 3.06641 14.1406L3.41895 14.5469L3.79785 14.167L6.78418 11.1777L7.08203 10.8789L6.83887 10.5352C6.5318 10.1008 6.34969 9.57124 6.34961 9C6.34961 8.4286 6.53172 7.8983 6.83887 7.46387L7.08203 7.12012L6.78418 6.82227L3.79785 3.83301L3.41895 3.45312L3.06641 3.8584ZM14.2012 3.83301L11.2148 6.82227L10.917 7.12012L11.1602 7.46387C11.4673 7.8983 11.6494 8.4286 11.6494 9C11.6493 9.57125 11.4672 10.1008 11.1602 10.5352L10.917 10.8789L11.2148 11.1777L14.2012 14.167L14.5801 14.5469L14.9326 14.1406C16.1274 12.7636 16.8495 10.9652 16.8496 9C16.8496 7.0346 16.1275 5.23556 14.9326 3.8584L14.5801 3.45312L14.2012 3.83301ZM9 6.39941C7.56558 6.39941 6.39941 7.56558 6.39941 9C6.39963 10.4342 7.56571 11.5996 9 11.5996C10.4341 11.5994 11.5994 10.4341 11.5996 9C11.5996 7.56571 10.4342 6.39963 9 6.39941ZM9 1.14941C7.03448 1.14941 5.23541 1.87234 3.8584 3.06641L3.45312 3.41895L3.83301 3.79785L6.82227 6.78418L7.12012 7.08203L7.46387 6.83887C7.91131 6.52252 8.4429 6.32031 9 6.32031C9.55695 6.32041 10.0878 6.5226 10.5352 6.83887L10.8789 7.08203L11.1777 6.78418L14.167 3.79785L14.5469 3.41895L14.1406 3.06641C12.7637 1.87248 10.9653 1.14951 9 1.14941Z"
        fill="#A0A0A0"
        stroke="#A0A0A0"
      />
    </svg>
  );
};

export const Exit = ({ size }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1179 8.59643L13.975 3.45357C13.7518 3.23036 13.39 3.23036 13.1671 3.45357C12.9443 3.67679 12.9439 4.03857 13.1671 4.26143L17.3357 8.42857H7.28571C6.97143 8.42857 6.71429 8.68571 6.71429 9C6.71429 9.31429 6.96986 9.57143 7.28571 9.57143H17.3357L13.1679 13.7393C12.9446 13.9625 12.9446 14.3243 13.1679 14.5471C13.3911 14.77 13.7529 14.7704 13.9757 14.5471L19.1186 9.40429C19.2286 9.29286 19.2857 9.14643 19.2857 9C19.2857 8.85357 19.2286 8.70714 19.1179 8.59643ZM7.28571 15.8571H3.85714C2.91179 15.8571 2.14286 15.0893 2.14286 14.1429V3.85714C2.14286 2.91179 2.91179 2.14286 3.85714 2.14286H7.28571C7.6 2.14286 7.85714 1.88714 7.85714 1.57143C7.85714 1.25571 7.6 1 7.28571 1H3.85714C2.28143 1 1 2.28143 1 3.85714V14.1429C1 15.7179 2.28143 17 3.85714 17H7.28571C7.6 17 7.85714 16.7429 7.85714 16.4286C7.85714 16.1143 7.6 15.8571 7.28571 15.8571Z"
        fill="black"
        fillOpacity="0.45"
        stroke="black"
        strokeOpacity="0.1"
      />
    </svg>
  );
};

export const UserTwo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 15.9375C17.3303 15.9375 19.2188 14.0484 19.2188 11.7188C19.2188 9.38906 17.332 7.5 15 7.5C12.668 7.5 10.7812 9.38672 10.7812 11.7188C10.7812 14.0508 12.668 15.9375 15 15.9375ZM16.875 18.75H13.125C10.3395 18.75 7.9957 20.5008 7.04883 22.9518C9.08789 24.9902 11.9004 26.25 15 26.25C18.0996 26.25 20.9121 24.9885 22.9512 22.9518C22.002 20.502 19.6582 18.75 16.875 18.75Z"
        fill="#3D734A"
        fillOpacity="0.65"
      />
      <path
        opacity="0.2"
        d="M15 0C6.71484 0 0 6.71484 0 15C0 23.2852 6.71484 30 15 30C23.2852 30 30 23.2852 30 15C30 6.71484 23.2852 0 15 0ZM15 7.5C17.3303 7.5 19.2188 9.38906 19.2188 11.7188C19.2188 14.0484 17.332 15.9375 15 15.9375C12.6703 15.9375 10.7812 14.0484 10.7812 11.7188C10.7812 9.38906 12.668 7.5 15 7.5ZM15 26.25C11.8986 26.25 9.08789 24.9885 7.04883 22.9518C7.99805 20.502 10.3418 18.75 13.125 18.75H16.875C19.6605 18.75 22.0043 20.5008 22.9512 22.9518C20.9121 24.9902 18.0996 26.25 15 26.25Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const UserRegular = ({ color = "#a0a0a0" }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.60934C10.2094 8.60934 12 6.911 12 4.81614C12 2.72129 10.2094 1.02295 8 1.02295C5.79063 1.02295 4 2.72129 4 4.81614C4 6.911 5.79063 8.60934 8 8.60934ZM8 1.4971C9.93 1.4971 11.5 2.98593 11.5 4.81614C11.5 6.64636 9.93 8.13519 8 8.13519C6.07 8.13519 4.5 6.64755 4.5 4.81614C4.5 2.98593 6.06875 1.4971 8 1.4971ZM9.58438 10.0318H6.41563C3.42531 10.0318 1 12.3314 1 15.1674C1 15.7346 1.485 16.1948 2.08312 16.1948H13.9175C14.5156 16.1957 15 15.7364 15 15.1674C15 12.3314 12.575 10.0318 9.58438 10.0318ZM13.9156 15.7216H2.08344C1.76156 15.7216 1.5 15.4727 1.5 15.1674C1.5 12.5981 3.70563 10.5059 6.41563 10.5059H9.58125C12.2938 10.5059 14.5 12.5981 14.5 15.1674C14.5 15.4727 14.2375 15.7216 13.9156 15.7216Z"
        fill={color}
        fillOpacity="0.75"
        stroke={color}
      />
    </svg>
  );
};

export const ChevronUp = () => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73903 0.84707L9.90088 4.88956C10.033 5.01898 10.033 5.22827 9.90088 5.35769L9.34409 5.90293C9.21192 6.03236 8.9982 6.03236 8.86604 5.90293L5.5 2.63975L2.13396 5.90293C2.0018 6.03236 1.78808 6.03236 1.65591 5.90293L1.09913 5.35769C0.966958 5.22827 0.966958 5.01898 1.09913 4.88956L5.26097 0.84707C5.39314 0.717644 5.60686 0.717644 5.73903 0.84707Z"
        fill="#3D734A"
        stroke="#3D734A"
      />
    </svg>
  );
};

export const Times = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.78484 6L11.8244 1.96056C12.058 1.72694 12.058 1.34782 11.8244 1.11383L10.8858 0.175216C10.6521 -0.0584053 10.273 -0.0584053 10.039 0.175216L5.99981 4.21503L1.96025 0.175591C1.72662 -0.0580303 1.34749 -0.0580303 1.11349 0.175591L0.175221 1.11383C-0.0584072 1.34745 -0.0584072 1.72657 0.175221 1.96056L4.21478 6L0.175221 10.0394C-0.0584072 10.2731 -0.0584072 10.6522 0.175221 10.8862L1.11386 11.8248C1.34749 12.0584 1.72662 12.0584 1.96062 11.8248L5.99981 7.78497L10.0394 11.8244C10.273 12.058 10.6521 12.058 10.8861 11.8244L11.8248 10.8858C12.0584 10.6522 12.0584 10.2731 11.8248 10.0391L7.78484 6Z"
        fill="#8f8f8f"
        fillOpacity="1"
      />
    </svg>
  );
};

export const Search = () => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.11033 11.6663C8.93269 11.6663 11.2207 9.27854 11.2207 6.33313C11.2207 3.38772 8.93269 1 6.11033 1C3.28797 1 1 3.38772 1 6.33313C1 9.27854 3.28797 11.6663 6.11033 11.6663Z"
        stroke="#A0A0A0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0004 13.0015L11.2217 10.1016"
        stroke="#A0A0A0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchTwo = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88894 18.7779C14.7982 18.7779 18.7779 14.7982 18.7779 9.88894C18.7779 4.97971 14.7982 1 9.88894 1C4.97971 1 1 4.97971 1 9.88894C1 14.7982 4.97971 18.7779 9.88894 18.7779Z"
        stroke="#999"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9974 20.9999L16.1641 16.1665"
        stroke="#999"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Phone = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4232 11.5641L11.9857 9.12662C12.0466 8.86178 11.9083 8.58991 11.6599 8.4821L9.03496 7.35713C8.80528 7.25869 8.53576 7.32431 8.37873 7.51884L7.21625 8.93912C5.41863 8.09539 3.92335 6.6212 3.06322 4.78608L4.4835 3.62361C4.67803 3.46424 4.74365 3.19705 4.64521 2.96737L3.52024 0.342424C3.41008 0.0916482 3.13822 -0.0466303 2.87338 0.0143059L0.435928 0.576794C0.182808 0.635387 -3.76085e-08 0.860382 -4.9185e-08 1.12522C-3.1155e-07 7.12744 4.86318 12 10.8748 12C11.1373 12 11.3646 11.8195 11.4232 11.5641Z"
        fill="#C2C2C2"
      />
    </svg>
  );
};

export const Clock = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.82984 0C2.16174 0 0 2.01411 0 4.5C0 6.98589 2.16174 9 4.82984 9C7.49794 9 9.65969 6.98589 9.65969 4.5C9.65969 2.01411 7.49794 0 4.82984 0ZM6.6311 5.67944L6.2416 6.13306C6.21604 6.16284 6.18443 6.18763 6.14859 6.20603C6.11274 6.22442 6.07336 6.23606 6.03268 6.24027C5.99201 6.24448 5.95085 6.24119 5.91154 6.23058C5.87223 6.21997 5.83556 6.20225 5.8036 6.17843L4.49876 5.27625C4.40759 5.20824 4.334 5.122 4.28344 5.02391C4.23287 4.92582 4.20662 4.81839 4.20664 4.70958V1.8871C4.20664 1.8101 4.23947 1.73625 4.2979 1.68181C4.35634 1.62736 4.4356 1.59677 4.51824 1.59677H5.14145C5.22409 1.59677 5.30335 1.62736 5.36178 1.68181C5.42022 1.73625 5.45305 1.8101 5.45305 1.8871V3.1323C5.45305 3.98809 5.87582 4.78863 6.58261 5.27117C6.61458 5.295 6.6412 5.32447 6.66094 5.35789C6.68068 5.39131 6.69316 5.42802 6.69766 5.46594C6.70217 5.50385 6.69861 5.54223 6.68719 5.57886C6.67576 5.61549 6.65671 5.64967 6.6311 5.67944Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const Clock2 = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
      stroke="#3D734A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 5V11L15 13"
      stroke="#3D734A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookOpen = ({ color = "#a0a0a0" }) => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9859 1.91657C19.2463 1.28551 17.628 0.992297 16.2056 1.00015C13.6846 1.0398 11.9592 1.873 11.4615 2.14407C10.9639 1.873 9.23846 1.0398 6.72115 1.00015C5.32083 0.992339 3.68004 1.28533 1.94081 1.91657C1.37741 2.11979 1 2.65871 1 3.25835V14.9082C1 15.2732 1.17196 15.6075 1.47113 15.8247C1.77081 16.0412 2.14423 16.102 2.4984 15.9954C7.53301 14.4612 11.2599 16.9258 11.2963 16.9508C11.3011 16.9541 11.3075 16.9528 11.3124 16.9557C11.318 16.9591 11.3205 16.9656 11.3263 16.9686C11.3707 16.9893 11.4143 17 11.4288 17C11.4434 17 11.5217 16.9888 11.5643 16.9671C11.5701 16.9641 11.5726 16.9575 11.5782 16.9542C11.5832 16.9512 11.5896 16.9525 11.5944 16.9492C11.6318 16.9247 15.3576 14.4592 20.3922 15.9939C20.7442 16.1005 21.1195 16.0396 21.4195 15.8231C21.7523 15.575 21.9231 15.2714 21.9231 14.9072V3.25835C21.9231 2.65871 21.5453 2.11979 20.9859 1.91657ZM11.1709 16.2072C10.3398 15.7561 8.43677 14.9086 5.87115 14.9086C4.79558 14.9086 3.60376 15.0576 2.32549 15.4472C1.96951 15.5572 1.5812 15.2964 1.5812 14.9072V3.25835C1.5812 2.89728 1.80539 2.57371 2.13987 2.45264C3.8119 1.84657 5.35135 1.55693 6.70953 1.57193C9.04957 1.60872 10.7023 2.38943 11.1709 2.63942V16.2072ZM21.3419 14.9072C21.3419 15.3022 20.9488 15.5586 20.5972 15.4486C16.2709 14.13 12.9327 15.568 11.7521 16.2086V2.63942C12.2222 2.38943 13.8739 1.60872 16.2128 1.57193C17.5899 1.55519 19.1115 1.8465 20.7825 2.45264C21.1167 2.57335 21.3419 2.89728 21.3419 3.25835V14.9072Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export const Invoice = ({ color = "#a0a0a0" }) => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5.72175C10.1375 5.72175 10.25 5.86237 10.25 5.97174C10.25 6.13736 10.1375 6.22174 10 6.22174H4C3.86187 6.22174 3.75 6.13736 3.75 5.97174C3.75 5.86237 3.86187 5.72175 4 5.72175H10ZM3.75 11.9997C3.75 11.8622 3.86187 11.7497 4 11.7497H10C10.1375 11.7497 10.25 11.8622 10.25 11.9997C10.25 12.1372 10.1375 12.2497 10 12.2497H4C3.86187 12.2497 3.75 12.1372 3.75 11.9997ZM10 8.72167C10.1375 8.72167 10.25 8.86229 10.25 8.97166C10.25 9.13728 10.1375 9.22165 10 9.22165H4C3.86187 9.22165 3.75 9.13728 3.75 8.97166C3.75 8.86229 3.86187 8.72167 4 8.72167H10ZM3.25 2.66777L5.08437 1.06184C5.18437 0.975191 5.33437 0.980159 5.42812 1.07322L7.0125 2.65777L8.83437 1.06188C8.93437 0.9752 9.08438 0.980169 9.17813 1.07325L10.7625 2.65777L12.5844 1.06188C12.6594 0.997281 12.7625 0.981831 12.8531 1.02237C12.9437 1.06291 13 1.15194 13 1.25003V16.7496C13 16.8464 12.9437 16.9089 12.8531 16.9777C12.7625 17.0183 12.6594 17.0027 12.5844 16.9371L10.7625 15.3152L9.17813 16.9277C9.08438 17.0183 8.93437 17.0246 8.83437 16.9371L7 15.3309L5.16563 16.9371C5.06563 17.0246 4.91563 17.0183 4.82188 16.9277L3.23875 15.3152L1.41469 16.9371C1.34094 17.0027 1.23603 17.0183 1.14669 16.9777C1.05737 16.9089 1 16.8464 1 16.7496V1.25003C1 1.15194 1.05737 1.06291 1.14669 1.02237C1.23603 0.981841 1.34094 0.99729 1.41469 1.06188L3.25 2.66777ZM3.08531 14.784C3.18438 14.7246 3.33375 14.7309 3.42688 14.8215L5.0125 16.4058L6.83437 14.784C6.92812 14.7278 7.07188 14.7278 7.16563 14.784L8.9875 16.4058L10.5719 14.8215C10.6656 14.7309 10.8156 14.7246 10.9156 14.784L12.5 16.1996V1.80092L10.9156 3.18807C10.8156 3.27463 10.6656 3.26963 10.5719 3.17682L8.9875 1.59217L7.16563 3.18807C7.06563 3.27463 6.91563 3.26963 6.82188 3.17682L5.2375 1.59217L3.41469 3.18807C3.32031 3.27057 3.17969 3.27057 3.08531 3.18807L1.5 1.80092V16.1996L3.08531 14.784Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
};

export const CheckCircle = ({ size = 14 }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14ZM10.0898 5.71484L6.58984 9.21484C6.33281 9.47188 5.91719 9.47188 5.66289 9.21484L3.91289 7.46484C3.65586 7.20781 3.65586 6.79219 3.91289 6.53789C4.16992 6.28359 4.58555 6.28086 4.83984 6.53789L6.125 7.82305L9.16016 4.78516C9.41719 4.52812 9.83281 4.52812 10.0871 4.78516C10.3414 5.04219 10.3441 5.45781 10.0871 5.71211L10.0898 5.71484Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const ErrorCircle = ({ size = 18, color = "#da827a" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill={color}
      />
      <path
        d="M11 7L7 11"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7L11 11"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EllipsisVertical = () => {
  return (
    <svg
      width="4"
      height="18"
      viewBox="0 0 4 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PenCircle = ({ color = "black" }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.5H20C25.2467 0.5 29.5 4.7533 29.5 10V20C29.5 25.2467 25.2467 29.5 20 29.5H10C4.7533 29.5 0.5 25.2467 0.5 20V10C0.5 4.7533 4.7533 0.5 10 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
      <path
        d="M18.0779 9.50136C18.2368 9.34241 18.4255 9.21632 18.6332 9.1303C18.8409 9.04428 19.0635 9 19.2883 9C19.513 9 19.7356 9.04428 19.9433 9.1303C20.151 9.21632 20.3397 9.34241 20.4986 9.50136C20.6576 9.66031 20.7837 9.84901 20.8697 10.0567C20.9557 10.2644 21 10.487 21 10.7117C21 10.9365 20.9557 11.1591 20.8697 11.3668C20.7837 11.5745 20.6576 11.7632 20.4986 11.9221L12.3286 20.0922L9 21L9.90779 17.6714L18.0779 9.50136Z"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrashCircle = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.5H20C25.2467 0.5 29.5 4.7533 29.5 10V20C29.5 25.2467 25.2467 29.5 20 29.5H10C4.7533 29.5 0.5 25.2467 0.5 20V10C0.5 4.7533 4.7533 0.5 10 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
      <path
        d="M10 11.4004H11.2222H21"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7763 11.4V19.8C19.7763 20.1183 19.6475 20.4235 19.4183 20.6485C19.1891 20.8736 18.8782 21 18.554 21H12.4429C12.1188 21 11.8079 20.8736 11.5787 20.6485C11.3495 20.4235 11.2207 20.1183 11.2207 19.8V11.4M13.054 11.4V10.2C13.054 9.88174 13.1828 9.57652 13.412 9.35147C13.6412 9.12643 13.9521 9 14.2763 9H16.7207C17.0449 9 17.3557 9.12643 17.5849 9.35147C17.8142 9.57652 17.9429 9.88174 17.9429 10.2V11.4"
        stroke="#A0A0A0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PhoneCircle = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="29"
        height="29"
        rx="14.5"
        fill="#3D734A"
        fillOpacity="0.15"
      />
      <path
        d="M11.8647 9.57707C11.6842 9.14115 11.2085 8.90913 10.7538 9.03334L8.69138 9.59581C8.28358 9.70831 8 10.0786 8 10.5005C8 16.2986 12.7014 21 18.4995 21C18.9214 21 19.2917 20.7164 19.4042 20.3086L19.9667 18.2462C20.0909 17.7915 19.8589 17.3158 19.4229 17.1353L17.173 16.1979C16.791 16.0385 16.3481 16.1487 16.0879 16.4697L15.1411 17.6251C13.4912 16.8447 12.1553 15.5088 11.3749 13.8589L12.5303 12.9144C12.8513 12.6519 12.9615 12.2113 12.8021 11.8293L11.8647 9.57941V9.57707Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const PhoneGreen = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4232 11.5641L11.9857 9.12662C12.0466 8.86178 11.9083 8.58991 11.6599 8.4821L9.03496 7.35713C8.80528 7.25869 8.53576 7.32431 8.37873 7.51884L7.21625 8.93912C5.41863 8.09539 3.92335 6.6212 3.06322 4.78608L4.4835 3.62361C4.67803 3.46424 4.74365 3.19705 4.64521 2.96737L3.52024 0.342424C3.41008 0.0916482 3.13822 -0.0466303 2.87338 0.0143059L0.435928 0.576794C0.182808 0.635387 -3.76085e-08 0.860382 -4.9185e-08 1.12522C-3.1155e-07 7.12744 4.86318 12 10.8748 12C11.1373 12 11.3646 11.8195 11.4232 11.5641Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const EnvelopeGreen = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 0C0.671875 0 0 0.671875 0 1.5C0 1.97188 0.221875 2.41562 0.6 2.7L7.4 7.8C7.75625 8.06563 8.24375 8.06563 8.6 7.8L15.4 2.7C15.7781 2.41562 16 1.97188 16 1.5C16 0.671875 15.3281 0 14.5 0H1.5ZM0 3.5V10C0 11.1031 0.896875 12 2 12H14C15.1031 12 16 11.1031 16 10V3.5L9.2 8.6C8.4875 9.13438 7.5125 9.13438 6.8 8.6L0 3.5Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const InfoIcon = ({ color = "#000", size = 15 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.8899 98.7797C77.7864 98.7797 98.7797 77.7864 98.7797 51.8899C98.7797 25.9933 77.7864 5 51.8899 5C25.9933 5 5 25.9933 5 51.8899C5 77.7864 25.9933 98.7797 51.8899 98.7797Z"
        stroke={color}
        strokeWidth="9.37797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.8896 33.1339V51.8899"
        stroke={color}
        strokeWidth="9.37797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.8896 70.6458H51.9365"
        stroke={color}
        strokeWidth="9.37797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CautionIcon = ({ color = "#000", size = 15 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 104 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.2155 9.32072L6.20285 72.7799C5.41911 74.1371 5.00442 75.6759 5.00004 77.2432C4.99565 78.8105 5.40171 80.3516 6.17783 81.7132C6.95396 83.0748 8.07308 84.2095 9.42386 85.0043C10.7746 85.7991 12.31 86.2264 13.8772 86.2437H89.9025C91.4697 86.2264 93.0051 85.7991 94.3559 85.0043C95.7066 84.2095 96.8258 83.0748 97.6019 81.7132C98.378 80.3516 98.7841 78.8105 98.7797 77.2432C98.7753 75.6759 98.3606 74.1371 97.5769 72.7799L59.5642 9.32072C58.7641 8.00175 57.6376 6.91124 56.2934 6.15442C54.9491 5.39759 53.4325 5 51.8899 5C50.3472 5 48.8306 5.39759 47.4863 6.15442C46.1421 6.91124 45.0156 8.00175 44.2155 9.32072V9.32072Z"
        stroke={color}
        strokeWidth="8.97584"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.8906 32.3888V50.3405"
        stroke={color}
        strokeWidth="8.97584"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.8906 68.2922H51.9355"
        stroke={color}
        strokeWidth="8.97584"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ErrorIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.05" width="34" height="34" rx="17" fill="#D91604" />
      <path
        d="M17 13V17"
        stroke="#D91604"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21H17.01"
        stroke="#D91604"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SuccessIcon = ({ color = "#000", size = 15 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.7797 47.6028V51.9167C98.7739 62.0281 95.4998 71.8668 89.4455 79.9654C83.3912 88.064 74.8813 93.9885 65.1848 96.8555C55.4883 99.7224 45.1249 99.3781 35.64 95.874C26.1552 92.3698 18.0572 85.8935 12.5538 77.411C7.05034 68.9285 4.43634 58.8942 5.10164 48.8047C5.76694 38.7152 9.67589 29.111 16.2455 21.4246C22.8151 13.7381 31.6934 8.38126 41.5562 6.15288C51.419 3.9245 61.738 4.94402 70.974 9.05937"
        stroke={color}
        strokeWidth="9.37797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.7796 14.4049L51.8897 61.3416L37.8228 47.2747"
        stroke={color}
        strokeWidth="9.37797"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeClosed = ({ color = "#666", size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 113 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84.3672 84.3673C76.3582 90.4721 66.6061 93.8542 56.5371 94.0188C23.7408 94.0188 5 56.5373 5 56.5373C10.8279 45.6765 18.911 36.1876 28.7071 28.7072M46.6982 20.1802C49.9232 19.4253 53.225 19.0479 56.5371 19.0557C89.3335 19.0557 108.074 56.5373 108.074 56.5373C105.23 61.8578 101.839 66.8669 97.9542 71.483M66.4697 66.4699C65.1829 67.8508 63.6312 68.9584 61.9071 69.7267C60.1829 70.4949 58.3217 70.908 56.4345 70.9413C54.5472 70.9746 52.6726 70.6274 50.9224 69.9205C49.1723 69.2135 47.5824 68.1614 46.2477 66.8267C44.913 65.492 43.8608 63.9021 43.1539 62.1519C42.447 60.4018 42.0998 58.5272 42.1331 56.6399C42.1664 54.7527 42.5795 52.8915 43.3477 51.1673C44.1159 49.4432 45.2236 47.8914 46.6045 46.6047"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5L108.074 108.074"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeOpen = ({ color = "#666", size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 113 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 42.4815C5 42.4815 23.7408 5 56.5371 5C89.3335 5 108.074 42.4815 108.074 42.4815C108.074 42.4815 89.3335 79.9631 56.5371 79.9631C23.7408 79.9631 5 42.4815 5 42.4815Z"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.5371 56.5371C64.2998 56.5371 70.5927 50.2442 70.5927 42.4815C70.5927 34.7189 64.2998 28.426 56.5371 28.426C48.7744 28.426 42.4815 34.7189 42.4815 42.4815C42.4815 50.2442 48.7744 56.5371 56.5371 56.5371Z"
        stroke={color}
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Plus = ({ size = 12 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1V11"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 6H11"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Minus = () => {
  return (
    <svg
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1H11"
        stroke="#808080"
        strokeOpacity="0.65"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Interrogation = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 12C9.53757 12 12 9.53757 12 6.5C12 3.46243 9.53757 1 6.5 1C3.46243 1 1 3.46243 1 6.5C1 9.53757 3.46243 12 6.5 12Z"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.89844 4.85051C5.02774 4.48293 5.28297 4.17297 5.61891 3.97553C5.95485 3.7781 6.34983 3.70592 6.73388 3.7718C7.11794 3.83768 7.46629 4.03735 7.71723 4.33545C7.96817 4.63355 8.10552 5.01085 8.10494 5.40051C8.10494 6.50051 6.45494 7.05051 6.45494 7.05051"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 9.25H6.506"
        stroke="#3D734A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Location = ({ color = "#999" }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 10C13.75 12.0703 12.0703 13.75 10 13.75C7.89453 13.75 6.25 12.0703 6.25 10C6.25 7.89453 7.89453 6.25 10 6.25C12.0703 6.25 13.75 7.89453 13.75 10ZM10 7.5C8.62109 7.5 7.5 8.62109 7.5 10C7.5 11.3789 8.62109 12.5 10 12.5C11.3789 12.5 12.5 11.3789 12.5 10C12.5 8.62109 11.3789 7.5 10 7.5ZM10 0C10.3438 0 10.625 0.279844 10.625 0.625V2.52578C14.2695 2.82617 17.1719 5.73047 17.4727 9.375H19.375C19.7188 9.375 20 9.65625 20 10C20 10.3438 19.7188 10.625 19.375 10.625H17.4727C17.1719 14.2695 14.2695 17.1719 10.625 17.4727V19.375C10.625 19.7188 10.3438 20 10 20C9.65625 20 9.375 19.7188 9.375 19.375V17.4727C5.73047 17.1719 2.82617 14.2695 2.52578 10.625H0.625C0.279844 10.625 0 10.3438 0 10C0 9.65625 0.279844 9.375 0.625 9.375H2.52578C2.82617 5.73047 5.73047 2.82617 9.375 2.52578V0.625C9.375 0.279844 9.65625 0 10 0ZM3.75 10C3.75 13.4531 6.54688 16.25 10 16.25C13.4531 16.25 16.25 13.4531 16.25 10C16.25 6.54688 13.4531 3.75 10 3.75C6.54688 3.75 3.75 6.54688 3.75 10Z"
        fill={color}
      />
    </svg>
  );
};

export const Info = () => {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 23.1562C19.8356 23.1562 20.1094 22.8837 20.1094 22.5469V9.14062C20.1094 8.80379 19.8356 8.53125 19.5 8.53125C19.1644 8.53125 18.8906 8.80547 18.8906 9.14062V22.5469C18.8906 22.882 19.1648 23.1562 19.5 23.1562ZM19.5 26.8125C18.8269 26.8125 18.2812 27.3582 18.2812 28.0312C18.2812 28.7043 18.8297 29.25 19.5 29.25C20.1703 29.25 20.7188 28.7043 20.7188 28.0312C20.7188 27.3582 20.1703 26.8125 19.5 26.8125ZM19.5 0C8.7293 0 0 8.7293 0 19.5C0 30.2707 8.7293 39 19.5 39C30.2707 39 39 30.2707 39 19.5C39 8.7293 30.2707 0 19.5 0ZM19.5 37.7812C9.42246 37.7812 1.21875 29.5775 1.21875 19.5C1.21875 9.42246 9.42246 1.21875 19.5 1.21875C29.5775 1.21875 37.7812 9.42246 37.7812 19.5C37.7812 29.5775 29.5775 37.7812 19.5 37.7812Z"
        fill="black"
        fillOpacity="0.4"
      />
    </svg>
  );
};

export const CreditCard = ({ color = "#000" }) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.40741 12.7143C4.40741 12.5571 4.53448 12.4286 4.69136 12.4286H7.53086C7.68704 12.4286 7.81482 12.5571 7.81482 12.7143C7.81482 12.8714 7.68704 13 7.53086 13H4.69136C4.53448 13 4.40741 12.8714 4.40741 12.7143ZM8.95062 12.7143C8.95062 12.5571 9.07839 12.4286 9.23457 12.4286H14.3457C14.5019 12.4286 14.6296 12.5571 14.6296 12.7143C14.6296 12.8714 14.5019 13 14.3457 13H9.23457C9.07839 13 8.95062 12.8714 8.95062 12.7143ZM1 3.28571C1 2.02321 2.0169 1 3.27161 1H19.1728C20.4258 1 21.4444 2.02321 21.4444 3.28571V14.7143C21.4444 15.975 20.4258 17 19.1728 17H3.27161C2.0169 17 1 15.975 1 14.7143V3.28571ZM1.5679 3.28571V4.42857H20.8765V3.28571C20.8765 2.33893 20.1134 1.57143 19.1728 1.57143H3.27161C2.33066 1.57143 1.5679 2.33893 1.5679 3.28571ZM1.5679 5V8.42857H20.8765V5H1.5679ZM1.5679 14.7143C1.5679 15.6607 2.33066 16.4286 3.27161 16.4286H19.1728C20.1134 16.4286 20.8765 15.6607 20.8765 14.7143V9H1.5679V14.7143Z"
        fill="black"
        fillOpacity="0.25"
        stroke={color}
        strokeOpacity="0.25"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const CreditCardGreen = () => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 1C1.44687 1 1 1.44687 1 2V3H17V2C17 1.44687 16.5531 1 16 1H2ZM1 4V6H17V4H1ZM1 7V12C1 12.5531 1.44687 13 2 13H16C16.5531 13 17 12.5531 17 12V7H1ZM0 2C0 0.896875 0.896875 0 2 0H16C17.1031 0 18 0.896875 18 2V12C18 13.1031 17.1031 14 16 14H2C0.896875 14 0 13.1031 0 12V2ZM3 10.5C3 10.225 3.225 10 3.5 10H5.5C5.775 10 6 10.225 6 10.5C6 10.775 5.775 11 5.5 11H3.5C3.225 11 3 10.775 3 10.5ZM7 10.5C7 10.225 7.225 10 7.5 10H11.5C11.775 10 12 10.225 12 10.5C12 10.775 11.775 11 11.5 11H7.5C7.225 11 7 10.775 7 10.5Z"
      fill="#3D734A"
    />
  </svg>
);

export const DebitCard = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33333 12.7143C4.33333 12.5571 4.45764 12.4286 4.61111 12.4286H7.38889C7.54167 12.4286 7.66667 12.5571 7.66667 12.7143C7.66667 12.8714 7.54167 13 7.38889 13H4.61111C4.45764 13 4.33333 12.8714 4.33333 12.7143ZM8.77778 12.7143C8.77778 12.5571 8.90278 12.4286 9.05556 12.4286H14.0556C14.2083 12.4286 14.3333 12.5571 14.3333 12.7143C14.3333 12.8714 14.2083 13 14.0556 13H9.05556C8.90278 13 8.77778 12.8714 8.77778 12.7143ZM1 3.28571C1 2.02321 1.99479 1 3.22222 1H18.7778C20.0035 1 21 2.02321 21 3.28571V14.7143C21 15.975 20.0035 17 18.7778 17H3.22222C1.99479 17 1 15.975 1 14.7143V3.28571ZM1.55556 3.28571V14.7143C1.55556 15.6607 2.30174 16.4286 3.22222 16.4286H18.7778C19.6979 16.4286 20.4444 15.6607 20.4444 14.7143V3.28571C20.4444 2.33893 19.6979 1.57143 18.7778 1.57143H3.22222C2.30174 1.57143 1.55556 2.33893 1.55556 3.28571Z"
        fill="black"
        fillOpacity="0.25"
        stroke="black"
        strokeOpacity="0.25"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const Voucher = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.373 16.5989C18.6334 16.8626 18.7792 17.2211 18.7792 17.5938C18.7792 17.9664 18.6334 18.325 18.373 18.5887C18.1125 18.8523 17.7583 19 17.3902 19C17.0221 19 16.6679 18.8523 16.4075 18.5887L11.7855 13.9095L12.1501 13.5123L16.7999 18.1598C16.8763 18.2723 16.97 18.3391 17.0707 18.3848C17.1749 18.4305 17.2548 18.4551 17.3972 18.4586C17.5083 18.4621 17.6194 18.441 17.7236 18.3988C17.8278 18.3531 17.9215 18.2899 18.0014 18.2125C18.0778 18.1317 18.1403 18.0367 18.1854 17.9313C18.2271 17.8258 18.2445 17.7133 18.2445 17.6008C18.241 17.4567 18.2167 17.3758 18.1715 17.2704C18.1264 17.1684 18.0604 17.0735 17.9493 16.9962L13.3586 12.2889L13.751 11.9197L18.373 16.5989ZM6.30581 12.2994L2.87874 8.83312C1.9724 7.91557 1.35811 6.74139 1.11576 5.46877C0.873303 4.19405 1.01366 2.87538 1.51854 1.68221C1.59007 1.51346 1.70154 1.36476 1.84288 1.24959C1.98456 1.13435 2.15159 1.05592 2.32973 1.02117C2.50822 0.986432 2.69192 0.996433 2.86555 1.05033C3.03917 1.10419 3.19717 1.2003 3.32566 1.33027L10.2333 8.32337L9.84087 8.72063L2.93326 1.72861C2.88256 1.67553 2.82144 1.63369 2.75442 1.60557C2.68706 1.57709 2.61483 1.56268 2.54225 1.56303C2.43356 1.56268 2.32695 1.59432 2.23597 1.65408C2.14499 1.7142 2.07345 1.79998 2.0297 1.90052C1.56368 2.98963 1.43277 4.1958 1.65432 5.35979C1.87552 6.52694 2.43911 7.59918 3.27114 8.43587L6.69821 11.9022L6.30581 12.2994ZM20.9947 4.76567C21.0086 4.87113 20.9947 4.94496 20.9565 4.9766L18.0326 9.46943C17.8069 9.83856 17.5013 10.155 17.1402 10.387C16.779 10.6225 16.3693 10.7702 15.9422 10.8194C15.199 10.8967 14.4559 10.6753 13.876 10.2042L5.59393 18.5887C5.33349 18.8523 4.97929 19 4.57995 19C4.24276 19 3.88926 18.8523 3.62881 18.5887C3.36837 18.325 3.22183 17.9664 3.22183 17.5938C3.22183 17.2211 3.36837 16.8626 3.62881 16.5989L11.9105 8.21439C11.6292 7.898 11.4764 7.53238 11.3757 7.14216C11.275 6.75194 11.2577 6.34062 11.3271 5.94337C11.3966 5.5426 11.5494 5.16292 11.7751 4.82895C12.0008 4.49568 12.296 4.21444 12.6398 4.00526L17.0117 1.04787C17.0742 1.0272 17.1055 1.0128 17.1437 1.0055C17.1784 0.998209 17.1853 0.998163 17.2201 1.00539C17.286 1.01261 17.2895 1.02694 17.352 1.04755C17.3798 1.06819 17.4076 1.09466 17.4284 1.12549C17.4666 1.18765 17.484 1.26355 17.4666 1.33667C17.4527 1.40976 17.4111 1.47409 17.3485 1.51592L12.9419 4.47564C12.6432 4.62505 12.3585 4.90629 12.1987 5.20159C12.0112 5.46877 11.8932 5.8379 11.855 6.18945C11.8202 6.52343 11.8584 6.86443 11.9661 7.18435C12.0737 7.50426 12.2196 7.79956 12.48 8.04213L14.0461 9.62763C14.2892 9.86317 14.5774 10.0389 14.8969 10.1479C15.2129 10.2569 15.5498 10.2956 15.8831 10.2569C16.2304 10.2218 16.5603 10.1022 16.852 9.91239C17.1437 9.72255 17.359 9.46592 17.5673 9.16358L20.4912 4.69887C20.5329 4.6356 20.5989 4.59341 20.6683 4.57935C20.7412 4.56177 20.8176 4.57935 20.8767 4.61802C20.9392 4.6602 20.9808 4.72348 20.9947 4.76567ZM13.4593 9.82802L12.2821 8.63625L4.02225 16.9962C3.87502 17.1579 3.7948 17.3688 3.79862 17.5868C3.80244 17.8047 3.88995 17.984 4.04274 18.1703C4.19519 18.325 4.40146 18.4129 4.61815 18.4164C4.83344 18.4199 5.0418 18.3391 5.17028 18.1598L13.4593 9.82802ZM14.185 6.55507C14.1712 6.52343 14.1642 6.48476 14.1642 6.41796C14.1642 6.41093 14.1712 6.37578 14.185 6.34062C14.1989 6.30547 14.2198 6.27734 14.2441 6.24922L18.175 2.27282C18.2271 2.22149 18.2966 2.19336 18.3695 2.19372C18.4424 2.19442 18.5119 2.2236 18.5639 2.27598C18.616 2.32801 18.6438 2.39832 18.6438 2.47215C18.6438 2.54597 18.616 2.61698 18.5674 2.67007L14.6365 6.64647C14.5844 6.6992 14.5149 6.6992 14.442 6.6992C14.3378 6.6992 14.2962 6.6992 14.2441 6.64647C14.2198 6.62186 14.1989 6.59022 14.185 6.55507ZM15.3414 7.64136C15.3414 7.56754 15.3727 7.49723 15.4247 7.44449L19.3522 3.46528C19.4043 3.4143 19.4738 3.38618 19.5467 3.38688C19.6196 3.38759 19.6891 3.41712 19.7411 3.4695C19.7932 3.52153 19.821 3.59219 19.8245 3.66602C19.8245 3.73984 19.7967 3.81085 19.7446 3.86359L15.8171 7.84175C15.7651 7.89448 15.6921 7.9226 15.6192 7.9226C15.5463 7.9226 15.4768 7.89448 15.4247 7.84175C15.3727 7.78901 15.3414 7.71519 15.3414 7.64136Z"
        fill="black"
        fillOpacity="0.25"
        stroke="black"
        strokeOpacity="0.25"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const List = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="white" fillOpacity="0.1" />
      <path
        d="M16.8433 15.7642L18.2867 14.3137C18.4867 14.1128 18.76 14 19.0433 14H25.8C26.39 14 26.8667 14.4798 26.8667 15.0714V17.2143C26.8667 17.8069 26.39 18.2857 25.8 18.2857H19.0433C18.76 18.2857 18.4867 18.1719 18.2867 17.971L16.8433 16.5212C16.6367 16.3136 16.6367 15.9734 16.8433 15.7642ZM25.2667 16.6484V15.577H19.2633L18.73 16.1127L19.2633 16.6484H25.2667ZM14.0667 15.0413C14.6557 15.0413 15.1333 15.5512 15.1333 16.1127C15.1333 16.7355 14.6557 17.1842 14.0667 17.1842C13.4777 17.1842 13 16.7355 13 16.1127C13 15.5512 13.4777 15.0413 14.0667 15.0413ZM14.0667 20.3984C14.6557 20.3984 15.1333 20.9074 15.1333 21.4699C15.1333 22.0926 14.6557 22.5413 14.0667 22.5413C13.4777 22.5413 13 22.0926 13 21.4699C13 20.9074 13.4777 20.3984 14.0667 20.3984ZM14.0667 27.9286C13.4777 27.9286 13 27.4498 13 26.8571C13 26.2645 13.4777 25.7857 14.0667 25.7857C14.6557 25.7857 15.1333 26.2645 15.1333 26.8571C15.1333 27.4498 14.6557 27.9286 14.0667 27.9286ZM16.8433 26.4788L18.2867 25.029C18.4867 24.8281 18.76 24.7143 19.0433 24.7143H25.8C26.39 24.7143 26.8667 25.1931 26.8667 25.7857V27.9286C26.8667 28.5212 26.39 29 25.8 29H19.0433C18.76 29 18.4867 28.8862 18.2867 28.6853L16.8433 27.2355C16.6367 27.0279 16.6367 26.6864 16.8433 26.4788ZM25.2667 27.3929V26.3214H19.2633L18.73 26.8571L19.2633 27.3929H25.2667ZM18.2867 23.3281L16.8433 21.8783C16.6367 21.6708 16.6367 21.3292 16.8433 21.1217L18.2867 19.6719C18.4867 19.471 18.76 19.3571 19.0433 19.3571H27.9333C28.5233 19.3571 29 19.8359 29 20.4286V22.5714C29 23.1641 28.5233 23.6429 27.9333 23.6429H19.0433C18.76 23.6429 18.4867 23.529 18.2867 23.3281ZM18.73 21.4699L19.2633 22.0056H27.4V20.9342H19.2633L18.73 21.4699Z"
        fill="white"
      />
    </svg>
  );
};

export const ListB = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="#E6E6E6" />
      <path
        d="M19.5735 13H26.327C26.9167 13 27.3931 13.4798 27.3931 14.0714V16.2143C27.3931 16.8069 26.9167 17.2857 26.327 17.2857H19.5735C19.2903 17.2857 19.0171 17.1719 18.8172 16.971L17.3746 15.5212C17.168 15.3136 17.168 14.9734 17.3746 14.7642L18.8172 13.3137C19.0171 13.1128 19.2903 13 19.5735 13ZM19.1937 16.5926C19.2937 16.6931 19.4303 16.75 19.5735 16.75H26.327C26.6201 16.75 26.86 16.5089 26.86 16.2143V14.0714C26.86 13.7754 26.6201 13.5357 26.327 13.5357H19.5735C19.4303 13.5357 19.2937 13.5923 19.1937 13.6927L17.7511 15.1429L19.1937 16.5926ZM14.5992 16.75C13.716 16.75 13 16.0301 13 15.1429C13 14.2552 13.716 13.5357 14.5992 13.5357C15.4825 13.5357 16.1985 14.2552 16.1985 15.1429C16.1985 16.0301 15.4825 16.75 14.5992 16.75ZM15.6654 15.1429C15.6654 14.5512 15.188 14.0714 14.5992 14.0714C14.0105 14.0714 13.5331 14.5512 13.5331 15.1429C13.5331 15.7355 14.0105 16.2143 14.5992 16.2143C15.188 16.2143 15.6654 15.7355 15.6654 15.1429ZM14.5992 22.1071C13.716 22.1071 13 21.3873 13 20.5C13 19.6127 13.716 18.8929 14.5992 18.8929C15.4825 18.8929 16.1985 19.6127 16.1985 20.5C16.1985 21.3873 15.4825 22.1071 14.5992 22.1071ZM15.6654 20.5C15.6654 19.9074 15.188 19.4286 14.5992 19.4286C14.0105 19.4286 13.5331 19.9074 13.5331 20.5C13.5331 21.0926 14.0105 21.5714 14.5992 21.5714C15.188 21.5714 15.6654 21.0926 15.6654 20.5ZM14.5992 24.25C15.4825 24.25 16.1985 24.9699 16.1985 25.8571C16.1985 26.7444 15.4825 27.4643 14.5992 27.4643C13.716 27.4643 13 26.7444 13 25.8571C13 24.9699 13.716 24.25 14.5992 24.25ZM13.5331 25.8571C13.5331 26.4498 14.0105 26.9286 14.5992 26.9286C15.188 26.9286 15.6654 26.4498 15.6654 25.8571C15.6654 25.2645 15.188 24.7857 14.5992 24.7857C14.0105 24.7857 13.5331 25.2645 13.5331 25.8571ZM19.5735 23.7143H26.327C26.9167 23.7143 27.3931 24.1931 27.3931 24.7857V26.9286C27.3931 27.5212 26.9167 28 26.327 28H19.5735C19.2903 28 19.0171 27.8862 18.8172 27.6853L17.3746 26.2355C17.168 26.0279 17.168 25.6864 17.3746 25.4788L18.8172 24.029C19.0171 23.8281 19.2903 23.7143 19.5735 23.7143ZM19.1937 27.3069C19.2937 27.4074 19.4303 27.4643 19.5735 27.4643H26.327C26.6201 27.4643 26.86 27.2232 26.86 26.9286V24.7857C26.86 24.4911 26.6201 24.25 26.327 24.25H19.5735C19.4303 24.25 19.2937 24.3069 19.1937 24.4074L17.7511 25.8571L19.1937 27.3069ZM17.3746 20.1217L18.8172 18.6719C19.0171 18.471 19.2903 18.3571 19.5735 18.3571H28.4593C29.049 18.3571 29.5254 18.8359 29.5254 19.4286V21.5714C29.5254 22.1641 29.049 22.6429 28.4593 22.6429H19.5735C19.2903 22.6429 19.0171 22.529 18.8172 22.3281L17.3746 20.8783C17.168 20.6708 17.168 20.3292 17.3746 20.1217ZM19.1937 19.0502L17.7511 20.5L19.1937 21.9498C19.2937 22.0502 19.4303 22.1071 19.5735 22.1071H28.4593C28.7525 22.1071 28.9923 21.8661 28.9923 21.5714V19.4286C28.9923 19.1339 28.7525 18.8929 28.4593 18.8929H19.5735C19.4303 18.8929 19.2937 18.9498 19.1937 19.0502Z"
        fill="black"
        fillOpacity="0.65"
      />
    </svg>
  );
};

export const TicketIcon = () => {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.89473 10.5795C5.59637 10.0627 5.77283 9.40416 6.2896 9.10581L13.7638 4.79057C14.2806 4.49221 14.9391 4.66867 15.2375 5.18544L17.3951 8.92255C17.6935 9.43932 17.517 10.0979 17.0002 10.3962L9.52603 14.7115C9.00926 15.0098 8.35071 14.8334 8.05235 14.3166L5.89473 10.5795ZM8.98663 13.7772L16.4608 9.46195L14.3032 5.72484L6.82901 10.0401L8.98663 13.7772ZM17.8958 1.15926L19.2443 3.49496C18.4706 3.94165 18.2053 4.93178 18.652 5.70548C19.0987 6.47918 20.0888 6.74448 20.8625 6.29779L22.211 8.63348C22.8061 9.6641 22.4519 10.9858 21.4213 11.5808L8.34142 19.1325C7.30933 19.7284 5.98908 19.3734 5.39405 18.3428L4.04554 16.0071C4.81953 15.5602 5.08454 14.5703 4.63785 13.7966C4.19115 13.0229 3.20131 12.7574 2.42732 13.2042L1.07881 10.8686C0.482936 9.83647 0.83647 8.51706 1.86855 7.92119L14.9484 0.369518C15.9791 -0.225513 17.2999 0.127179 17.8958 1.15926ZM2.93513 11.9262C3.96726 11.8091 5.01923 12.2995 5.57212 13.2572C6.12501 14.2148 6.00857 15.3448 5.40628 16.2063L6.32833 17.8034C6.62669 18.3201 7.28611 18.4961 7.80201 18.1982L20.8819 10.6466C21.3987 10.3482 21.5751 9.68966 21.2768 9.17288L20.3547 7.57585C19.306 7.6675 18.2706 7.20252 17.7177 6.24488C17.1648 5.28725 17.2646 4.13185 17.8836 3.2957L16.9615 1.69867C16.6632 1.1819 16.0046 1.00544 15.4878 1.3038L2.40796 8.85547C1.89206 9.15332 1.71473 9.81238 2.01309 10.3291L2.93513 11.9262Z"
        fill="#3D734A"
      />
    </svg>
  );
};

export const Copy = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 8H10C8.89543 8 8 8.89543 8 10V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V10C21 8.89543 20.1046 8 19 8Z"
        stroke="#3D734A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 14H3C2.46957 14 1.96086 13.7893 1.58579 13.4142C1.21071 13.0391 1 12.5304 1 12V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V4"
        stroke="#3D734A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CreditCardB = () => {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 8.78571C2.5 8.66786 2.59323 8.57143 2.70833 8.57143H4.79167C4.90625 8.57143 5 8.66786 5 8.78571C5 8.90357 4.90625 9 4.79167 9H2.70833C2.59323 9 2.5 8.90357 2.5 8.78571ZM5.83333 8.78571C5.83333 8.66786 5.92708 8.57143 6.04167 8.57143H9.79167C9.90625 8.57143 10 8.66786 10 8.78571C10 8.90357 9.90625 9 9.79167 9H6.04167C5.92708 9 5.83333 8.90357 5.83333 8.78571ZM0 1.71429C0 0.767411 0.746094 0 1.66667 0H13.3333C14.2526 0 15 0.767411 15 1.71429V10.2857C15 11.2312 14.2526 12 13.3333 12H1.66667C0.746094 12 0 11.2312 0 10.2857V1.71429ZM0.416667 1.71429V2.57143H14.5833V1.71429C14.5833 1.0042 14.0234 0.428571 13.3333 0.428571H1.66667C0.976302 0.428571 0.416667 1.0042 0.416667 1.71429ZM0.416667 3V5.57143H14.5833V3H0.416667ZM0.416667 10.2857C0.416667 10.9955 0.976302 11.5714 1.66667 11.5714H13.3333C14.0234 11.5714 14.5833 10.9955 14.5833 10.2857V6H0.416667V10.2857Z"
        fill="#8C8C8C"
      />
    </svg>
  );
};

export const CreditCardC = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13C4 12.6857 4.225 12.4286 4.5 12.4286H6.5C6.775 12.4286 7 12.6857 7 13C7 13.3143 6.775 13.5714 6.5 13.5714H4.5C4.225 13.5714 4 13.3143 4 13ZM8 13C8 12.6857 8.225 12.4286 8.5 12.4286H12.5C12.775 12.4286 13 12.6857 13 13C13 13.3143 12.775 13.5714 12.5 13.5714H8.5C8.225 13.5714 8 13.3143 8 13ZM1 3.28571C1 2.02321 1.89531 1 3 1H17C18.1031 1 19 2.02321 19 3.28571V14.7143C19 15.975 18.1031 17 17 17H3C1.89531 17 1 15.975 1 14.7143V3.28571ZM2 3.28571V4.42857H18V3.28571C18 2.65464 17.5531 2.14286 17 2.14286H3C2.44781 2.14286 2 2.65464 2 3.28571ZM2 7.85714H18V5.57143H2V7.85714ZM2 9V14.7143C2 15.3464 2.44781 15.8571 3 15.8571H17C17.5531 15.8571 18 15.3464 18 14.7143V9H2Z"
        fill="black"
        fillOpacity="0.45"
        stroke="black"
        strokeOpacity="0.1"
      />
    </svg>
  );
};

export const Salads = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2406 14.5H1.75891C1.33127 14.5 0.967195 14.8633 1.00235 15.2913C1.30263 18.6901 3.49346 21.5245 6.51592 22.7857C6.80668 22.907 7.00704 23.1849 7.00704 23.5V23.5C7.0129 24.332 7.67922 25 8.51126 25H17.5206C18.3466 25 18.9963 24.3259 18.9963 23.5V23.5C18.9963 23.1769 19.2012 22.8917 19.4989 22.766C22.5015 21.4978 24.7008 18.6734 24.9541 15.2922C25.0328 14.8656 24.6672 14.5 24.2406 14.5ZM18.5172 21.55L18.1266 21.6847C17.7502 21.8145 17.4977 22.1687 17.4977 22.5669V22.5669C17.4977 23.0822 17.0799 23.5 16.5645 23.5H9.43338C8.91789 23.5 8.50001 23.0821 8.50001 22.5666V22.5666C8.50001 22.1709 8.25045 21.8182 7.87728 21.6865L7.50391 21.5547C5.59001 20.8868 4.06304 19.4898 3.21385 17.7366C2.79998 16.8822 3.51409 16 4.46348 16H21.5354C22.4857 16 23.2 16.8839 22.7846 17.7386C21.9374 19.4817 20.4212 20.8725 18.5172 21.55ZM4.96985 7.97031C4.67688 8.26328 4.67688 8.73813 4.96985 9.03063L8.71985 12.7806C8.86563 12.925 9.05782 13 9.25001 13C9.44219 13 9.63382 12.9268 9.78016 12.7802C10.0731 12.4873 10.0731 12.0124 9.78016 11.7199L6.03016 7.96994C5.73907 7.675 5.26282 7.675 4.96985 7.97031ZM11.5 6.25V12.25C11.5 12.6625 11.8375 13 12.25 13C12.6625 13 13 12.6625 13 12.25V6.25C13 5.8375 12.6625 5.5 12.25 5.5C11.8375 5.5 11.5 5.8375 11.5 6.25ZM14.5 12.25C14.5 12.6625 14.8375 13 15.25 13C15.6625 13 16 12.6625 16 12.25C16 10.1828 17.6828 8.5 19.75 8.5C21.8172 8.5 23.5 10.1828 23.5 12.25C23.5 12.6625 23.8375 13 24.25 13C24.6625 13 25 12.6661 25 12.2514C25 9.35781 22.6469 7 19.75 7C16.8531 7 14.5 9.35781 14.5 12.25ZM2.26001 13C2.36838 13 2.47826 12.9766 2.58227 12.9275C2.95563 12.7516 3.11548 12.3016 2.93641 11.9266C2.64673 11.3172 2.50001 10.6656 2.50001 9.98594C2.50001 7.49641 4.51844 5.47047 7.00001 5.47047C7.19632 5.47047 7.38527 5.50123 7.64172 5.53858V5.53858C7.98339 5.58778 8.31495 5.39662 8.44465 5.07672V5.07672C9.07657 3.51156 10.5719 2.5 12.25 2.5C13.9281 2.5 15.4216 3.51156 16.0544 5.07672L16.0632 5.0931C16.2311 5.40543 16.5766 5.57918 16.9275 5.52775V5.52775C17.7595 5.40325 18.6487 5.53068 19.4264 5.90275C19.8028 6.08219 20.2481 5.92399 20.4267 5.54898C20.6054 5.17544 20.4472 4.72773 20.0737 4.54914C19.4751 4.2631 18.8474 4.06579 18.1952 3.99334C17.5941 3.92656 17.0284 3.62245 16.656 3.1459C15.6111 1.80882 14.0045 1 12.25 1C10.2565 1 8.45384 2.04427 7.44776 3.72101C7.35404 3.8772 7.18216 3.96906 7.00001 3.96906V3.96906C3.6911 3.96906 1.00001 6.66719 1.00001 9.98312C1.00001 10.8883 1.19632 11.7587 1.58313 12.5706C1.71063 12.8406 1.98016 13 2.26001 13Z"
        fill="#3D734A"
        stroke="#3D734A"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const Pizza = () => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.96782 1.00659C7.92095 1.0022 7.87408 1 7.82252 1C7.4288 1 6.98352 1.17531 6.70229 1.45619C6.5148 1.64406 6.37888 1.87844 6.30857 2.13531L5.68986 4.49078C5.57737 4.91359 5.61487 5.36359 5.90547 5.725C6.15347 6.08519 6.54621 6.31891 6.98118 6.36578C13.7635 7.09234 18.3054 11.5502 19.1209 18.2908C19.1735 18.7245 19.4125 19.1134 19.7753 19.3567C20.0246 19.5237 20.3157 19.6103 20.6096 19.6103C20.7435 19.6103 20.8781 19.5924 21.0098 19.5558L23.4003 18.894C24.1108 18.6972 24.573 18.0132 24.4905 17.281C23.5386 8.8 16.4328 1.80531 7.96782 1.00659ZM21.9287 17.7261C21.2129 17.9276 20.4893 17.4416 20.3429 16.7126C19.1072 10.5589 14.8354 6.30921 8.6599 5.10641C7.84365 4.94743 7.28701 4.14745 7.49903 3.34335L7.69808 2.58839C7.70968 2.5444 7.81646 2.5 7.77096 2.5C15.1941 3.20023 21.5027 9.08205 22.7731 16.4332C22.8739 17.0162 22.4983 17.5658 21.9287 17.7261ZM9.45834 12.625C9.45834 12.0034 8.95447 11.5 8.33342 11.5C7.71237 11.5 7.2085 12.0034 7.2085 12.625C7.2085 13.2461 7.71237 13.75 8.33342 13.75C8.95447 13.75 9.45834 13.2484 9.45834 12.625ZM14.708 16.375C14.708 15.7534 14.2041 15.25 13.583 15.25C12.962 15.25 12.4581 15.7534 12.4581 16.375C12.4581 16.9961 12.962 17.5 13.583 17.5C14.2041 17.5 14.708 16.9984 14.708 16.375ZM4.95867 19.375C4.95867 19.9961 5.46254 20.5 6.08358 20.5C6.70463 20.5 7.2085 19.9961 7.2085 19.375C7.2085 18.7534 6.70463 18.25 6.08358 18.25C5.46254 18.25 4.95867 18.7516 4.95867 19.375ZM17.5531 19.0281L4.8524 22.4909C3.73272 22.7962 2.70538 21.7688 3.01067 20.6491L6.47403 7.94687C6.58042 7.54844 6.34607 7.13594 5.94766 7.02813C5.54456 6.92031 5.13537 7.15469 5.0271 7.55313L0.525078 24.0484C0.454771 24.3077 0.53561 24.5894 0.726017 24.7797C0.868132 24.9203 1.05848 25 1.2544 25C1.3203 25 1.39248 24.9891 1.45839 24.9715L17.9478 20.4739C18.3477 20.3647 18.582 19.9526 18.4737 19.5532C18.3655 19.1539 17.9562 18.9203 17.5531 19.0281Z"
        fill="#3D734A"
        stroke="#3D734A"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const Snack = () => {
  return (
    <svg
      width="31"
      height="26"
      viewBox="0 0 31 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4703 13.5504C7.32967 13.4095 7.24999 13.2169 7.24999 12.9774V2.45762C7.24999 2.24394 7.31561 1.99269 7.44217 1.76961C7.56405 1.54607 7.74686 1.35859 7.96248 1.22418C8.17811 1.08982 8.42655 1.01319 8.67967 1.00156C8.8953 0.989923 9.19061 1.0437 9.42029 1.15773L10.9203 1.90909C11.1687 2.03261 11.3797 2.22375 11.525 2.46091C11.675 2.69855 11.75 2.97187 11.75 3.20904V12.9774C11.75 13.2169 11.6703 13.4095 11.5297 13.5504C11.389 13.6912 11.1969 13.7288 11 13.7288C10.8031 13.7288 10.6109 13.6912 10.4703 13.5504C10.3297 13.4095 10.25 13.2169 10.25 12.9774V3.67217C10.25 3.38829 10.0897 3.12875 9.8359 3.0016C9.33719 2.75178 8.74998 3.11439 8.74998 3.67217V12.9774C8.74998 13.2169 8.6703 13.4095 8.52967 13.5504C8.38905 13.6912 8.19686 13.7288 7.99999 13.7288C7.80311 13.7288 7.61092 13.6912 7.4703 13.5504ZM4.51671 10.5917C4.38124 10.479 4.28984 10.3193 4.25937 10.1455L3.13437 3.75757C3.10718 3.60541 3.12781 3.44808 3.19343 3.30813C3.25906 3.16818 3.36593 3.05171 3.49999 2.97469L5.37968 1.89876C5.54843 1.81 5.7078 1.79168 5.9328 1.84757C6.1203 1.90299 6.27499 2.02791 6.37343 2.19651C6.46718 2.36511 6.4953 2.56423 6.44843 2.75208C6.40155 2.93994 6.27968 3.10196 6.11561 3.20481L5.6126 3.49367C5.06487 3.80821 4.77286 4.43215 4.88224 5.05422L5.73124 9.88252C5.76405 10.0798 5.72187 10.2817 5.60936 10.4414C5.50214 10.598 5.33957 10.6694 5.15775 10.7449C5.13987 10.7523 5.12316 10.7574 5.10383 10.7585C5.03459 10.7628 4.9591 10.7361 4.88973 10.7366C4.75302 10.7375 4.62374 10.6807 4.51671 10.5917ZM13.0109 3.96139C13.0109 3.95914 13.0095 3.95715 13.0074 3.95643C12.8215 3.89298 12.6682 3.75785 12.5797 3.58099C12.4906 3.40252 12.4719 3.19589 12.5375 3.00709C12.5984 2.81783 12.7344 2.66144 12.9125 2.57221C13.0906 2.48298 13.2968 2.46843 13.4843 2.53136L15.7343 3.28277C15.8594 3.32358 15.9692 3.39585 16.056 3.49098C16.1365 3.57913 16.1799 3.69375 16.2086 3.80962C16.2388 3.9317 16.258 4.06062 16.2265 4.18446L14.7265 10.1972C14.6843 10.3568 14.5906 10.5024 14.4593 10.6058C14.3799 10.6683 14.2901 10.6981 14.1943 10.712C14.0687 10.73 13.936 10.7705 13.8125 10.7419C13.6203 10.695 13.4562 10.5729 13.3531 10.3991C13.25 10.23 13.2218 10.0234 13.2687 9.83086L14.3718 5.4114C14.5006 4.89532 14.2109 4.36696 13.7065 4.19807L13.0145 3.96634C13.0123 3.96563 13.0109 3.96363 13.0109 3.96139ZM17.3515 8.39378C17.343 8.38855 17.3346 8.38275 17.3263 8.37649C17.1863 8.27034 17.0714 8.12132 17.0257 7.95163C17.0232 7.94255 17.0209 7.93339 17.0187 7.92415C16.9953 7.83022 16.9953 7.7316 17.0093 7.63298L17.375 5.46327C17.3798 5.44287 17.3819 5.41789 17.3861 5.39028C17.4059 5.26236 17.4964 5.1556 17.5877 5.06384C17.6137 5.0377 17.6414 5.01345 17.6703 4.99129C17.7547 4.93024 17.8484 4.88656 17.9468 4.86308C18.0453 4.83913 18.1484 4.83584 18.2468 4.85322C18.35 4.8706 18.4437 4.90817 18.5281 4.96405C18.6125 5.01947 18.6875 5.09226 18.7437 5.17727C18.8 5.2618 18.8375 5.35761 18.8562 5.45811C18.858 5.46781 18.8593 5.47755 18.8601 5.48731C18.8745 5.66714 18.8359 5.85023 18.8053 6.02803L18.4859 7.88658C18.4578 8.06034 18.3687 8.22002 18.2328 8.33273C18.1321 8.41965 18.0135 8.45252 17.8864 8.46372C17.7993 8.47141 17.7103 8.51147 17.6234 8.5018C17.525 8.48301 17.4359 8.45014 17.3515 8.39378ZM1.54906 9.84495C1.41547 9.73693 1.32359 9.58195 1.28937 9.41289L0.51515 5.65582C0.475372 5.46046 0.514658 5.2571 0.624359 5.09085C0.734094 4.9246 0.905234 4.80908 1.1 4.76916C1.295 4.72924 1.49797 4.76869 1.6639 4.87858C1.82984 4.98847 1.94515 5.15989 1.985 5.35526L2.7575 9.11232C2.77718 9.21094 2.77765 9.2673 2.75937 9.40349C2.74062 9.50212 2.70265 9.59604 2.64828 9.67588C2.59437 9.76041 2.52406 9.83086 2.4425 9.88721C2.36093 9.93887 2.26906 9.98114 2.1725 9.99993C2.12328 10.0093 2.07312 9.97175 2.0225 9.97175C1.85 9.97175 1.68265 9.95296 1.54906 9.84495ZM29.7721 20.4781C29.758 20.4928 29.7499 20.5119 29.7499 20.4915V22.5579C29.7078 23.2483 29.4921 23.8259 29.0374 24.3237C28.5781 24.784 27.9593 25 27.3124 25H15.6875C15.0406 25 14.4218 24.784 13.9672 24.3237C13.5078 23.8259 13.25 23.2483 13.25 22.5579V20.4915C13.25 20.5122 13.2495 20.4911 13.2352 20.4762C12.7615 19.9858 12.4578 19.3341 12.4578 18.6553C12.4578 17.9902 12.7492 17.3513 13.2064 16.8645C13.2376 16.8313 13.25 16.7801 13.25 16.7345V14.8559C13.2593 14.3112 13.3484 13.7382 13.6297 13.2028C13.864 12.6674 14.2109 12.1884 14.6375 11.7892C16.5265 10.1173 18.9265 9.22034 21.4859 9.22034H21.5187C24.0359 9.22034 26.4781 10.122 28.3624 11.7892C28.789 12.1884 29.1359 12.6674 29.3703 13.2028C29.6093 13.7382 29.7406 14.3112 29.7499 14.8559V16.7345C29.7499 16.7826 29.769 16.8287 29.8018 16.864C30.2522 17.3508 30.5045 17.9885 30.4999 18.613C30.5046 19.3344 30.241 19.9874 29.7721 20.4781ZM14.75 15.7284C14.75 15.9019 14.9099 16.0495 15.076 15.9995C15.1074 15.99 15.1418 15.983 15.1746 15.983H27.8254C27.8582 15.983 27.8926 15.99 27.924 15.9995C28.0901 16.0495 28.2499 15.9019 28.2499 15.7284V14.8559C28.2406 14.5084 28.1468 14.128 27.9874 13.7758C27.8234 13.4236 27.5515 13.1089 27.3031 12.8506C25.6953 11.4276 23.6375 10.7279 21.5187 10.7232H21.4859C19.3672 10.7279 17.3047 11.4276 15.6968 12.8506C15.4062 13.1089 15.1765 13.4236 15.0125 13.7758C14.8531 14.128 14.7593 14.5084 14.75 14.8559V15.7284ZM28.2499 21.5858C28.2499 21.4104 28.0869 21.2912 27.9156 21.2534C27.8893 21.2476 27.8613 21.2429 27.8344 21.2429H15.1655C15.1386 21.2429 15.1106 21.2476 15.0843 21.2534C14.913 21.2912 14.75 21.4104 14.75 21.5858V22.5579C14.75 22.8491 14.8484 23.0886 15.0265 23.2624C15.2 23.4408 15.439 23.4972 15.6875 23.4972H27.3124C27.5609 23.4972 27.7999 23.4408 27.9734 23.2624C28.1515 23.0886 28.2499 22.8491 28.2499 22.5579V21.5858ZM28.4141 19.6163C28.5843 19.5152 28.7303 19.3653 28.841 19.2012C28.9488 19.0415 28.9999 18.8395 28.9999 18.613C28.9999 18.3953 28.9167 18.1575 28.7389 17.9616C28.6712 17.887 28.6005 17.8144 28.5259 17.7467C28.3558 17.5925 28.1201 17.4859 27.8749 17.4859H15.125C14.825 17.4859 14.539 17.6455 14.3281 17.8569C14.1172 18.0682 14 18.3547 14 18.613C14 18.8921 14.0776 19.1338 14.2203 19.3053C14.2847 19.3827 14.3576 19.4538 14.4342 19.5193C14.6304 19.687 14.8727 19.7401 15.125 19.7401H27.8749C28.0701 19.7401 28.2592 19.7083 28.4141 19.6163ZM17.2203 14.3018C17.0797 14.1609 17 13.9683 17 13.7288C17 13.6208 17.0422 13.4752 17.1265 13.3531C17.2109 13.231 17.2859 13.1324 17.464 13.076C17.6 13.0197 17.75 13.0056 17.8953 13.0338C18.0406 13.0619 18.1765 13.1324 18.2797 13.2404C18.3875 13.3437 18.4578 13.4799 18.4859 13.6255C18.5007 13.68 18.4921 13.7594 18.4785 13.8423C18.4552 13.985 18.4233 14.1319 18.3318 14.2439C18.2845 14.3017 18.2289 14.3529 18.1672 14.3957C18.0453 14.4802 17.9 14.4802 17.75 14.4802C17.5531 14.4802 17.3609 14.4427 17.2203 14.3018ZM20.9703 13.5504C20.8296 13.4095 20.75 13.2169 20.75 12.9774C20.75 12.8694 20.7921 12.7238 20.8765 12.6017C20.9609 12.4796 21.0359 12.381 21.214 12.3246C21.35 12.2683 21.5 12.2542 21.6453 12.2823C21.7906 12.3105 21.9265 12.381 22.0296 12.489C22.1375 12.5923 22.2078 12.7285 22.2359 12.8741C22.2507 12.9286 22.2421 13.008 22.2285 13.0909C22.2052 13.2336 22.1733 13.3804 22.0818 13.4924C22.0345 13.5503 21.9788 13.6015 21.9171 13.6443C21.7953 13.7288 21.65 13.7288 21.5 13.7288C21.3031 13.7288 21.1109 13.6912 20.9703 13.5504ZM24.7203 14.3018C24.5796 14.1609 24.5 13.9683 24.5 13.7288C24.5 13.6208 24.5421 13.4752 24.6265 13.3531C24.7109 13.231 24.7859 13.1324 24.964 13.076C25.1 13.0197 25.25 13.0056 25.3953 13.0338C25.5406 13.0619 25.6765 13.1324 25.7796 13.2404C25.8874 13.3437 25.9578 13.4799 25.9859 13.6255C26.0007 13.68 25.9921 13.7594 25.9785 13.8423C25.9551 13.985 25.9233 14.1319 25.8318 14.2439C25.7845 14.3017 25.7288 14.3529 25.6671 14.3957C25.5453 14.4802 25.4 14.4802 25.25 14.4802C25.0531 14.4802 24.8609 14.4427 24.7203 14.3018ZM12.2797 23.7602C12.4203 23.9011 12.5 24.0936 12.5 24.2486C12.5 24.4881 12.4203 24.6806 12.2797 24.8215C12.139 24.9624 11.9469 25 11.75 25H4.24999C4.08265 25 3.92046 24.9859 3.78874 24.8826C3.65656 24.7793 3.56328 24.6337 3.52249 24.474L0.522664 12.4514C0.495472 12.3387 0.494033 12.179 0.51845 12.1086C0.542872 11.9959 0.592531 11.8879 0.663687 11.7986C0.733203 11.7094 0.822312 11.6389 0.923984 11.5873C1.02594 11.5403 1.1375 11.4746 1.25 11.4746H2.45565C2.65003 11.4746 2.84567 11.5042 3.02593 11.577C3.05519 11.5888 3.08388 11.6014 3.11187 11.6155C3.22437 11.6765 3.32281 11.7564 3.40109 11.8597L4.43609 12.8929C5.58593 13.9683 6.99686 14.7103 8.52967 15.0532C9.30311 15.1377 10.0906 15.1706 10.8172 15.025C10.9578 14.9968 11.0656 14.9874 11.1687 15.0015C11.2719 15.0156 11.3703 15.0532 11.4594 15.1048C11.5484 15.1612 11.6281 15.2316 11.689 15.3162C11.7453 15.4054 11.7875 15.4993 11.8062 15.6026C11.8297 15.706 11.825 15.814 11.8015 15.9126C11.7781 16.0159 11.7359 16.1145 11.675 16.1944C11.6094 16.2789 11.5344 16.3494 11.4406 16.401C11.3515 16.4527 11.2484 16.4856 11.1453 16.4949C10.0906 16.7016 9.00311 16.6969 7.94842 16.4762C6.27968 16.1474 4.74874 15.3303 3.50468 14.128L2.47907 13.0199C2.45396 12.9928 2.41867 12.9774 2.38171 12.9774C2.29542 12.9774 2.2321 13.0585 2.25299 13.1422L4.55319 22.3603C4.71989 23.0284 5.32002 23.4972 6.00857 23.4972H11.75C11.9469 23.4972 12.139 23.6193 12.2797 23.7602Z"
        fill="#3D734A"
        stroke="#3D734A"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const Soap = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5 13C27.6751 13 27.0049 12.1938 26.3144 11.7424C26.0798 11.589 25.8001 11.5 25.5 11.5C25.4565 11.5 25.4197 11.4679 25.4128 11.425C25.0118 8.92543 22.863 7 20.25 7C18.0686 7 16.2108 8.34058 15.4228 10.2149C15.1347 10.9002 14.5245 11.4578 13.7812 11.4578H4.5C4.19152 11.4578 3.90457 11.5579 3.66606 11.7267C2.99284 12.2032 2.32479 13 1.5 13C1.08562 13 0.75 13.3375 0.75 13.75C0.75 14.1625 1.08562 14.5 1.5 14.5H1.77158C2.52982 14.5 3.15896 15.0691 3.33036 15.8077C4.02478 18.8 5.79713 21.3606 8.26872 23.04C8.7116 23.3409 8.95153 23.8695 9.24397 24.318C9.51163 24.7286 9.97488 25 10.5014 25H19.4592C19.9877 25 20.4524 24.7265 20.7196 24.3134C21.0088 23.8663 21.2458 23.3406 21.6849 23.0393C24.1308 21.3608 25.9281 18.7991 26.6288 15.8075C26.8018 15.0692 27.4309 14.5 28.1892 14.5H28.5C28.9142 14.5 29.25 14.1642 29.25 13.75C29.25 13.3375 28.9125 13 28.5 13ZM20.25 8.5C21.3972 8.5 22.4254 9.01771 23.1136 9.82099C23.7329 10.5438 23.0302 11.4578 22.0784 11.4578H18.4189C17.4674 11.4578 16.7649 10.5442 17.3841 9.82178C18.0733 9.01775 19.1033 8.5 20.25 8.5ZM25.4789 13.0094C25.4673 13.0094 25.4578 13.0189 25.4578 13.0305C25.4503 16.7955 23.4371 20.3114 20.1984 22.2062L19.7266 22.4826C19.5592 22.5806 19.4564 22.7599 19.4564 22.9539C19.4564 23.2555 19.2119 23.5 18.9103 23.5H11.0465C10.7447 23.5 10.5 23.2553 10.5 22.9535C10.5 22.7595 10.3972 22.58 10.2298 22.482L9.75937 22.2062C6.94828 20.5596 5.0591 17.6931 4.60553 14.4952C4.4892 13.675 5.17157 13 6 13H15.6424C15.6785 13 15.7139 13 15.75 13C15.7922 13 15.7505 12.9998 15.7509 12.9998H24.6437C24.6794 12.9998 24.7143 13 24.75 13C24.7922 13 24.7505 12.9998 24.7509 12.9998H25.4952C25.4978 12.9998 25.5 13.002 25.5 13.0046C25.5 13.0072 25.4978 13.0094 25.4952 13.0094H25.4789ZM10.9125 6.17031C11.5828 6.50781 12 7.17813 12 7.92813V9.25C12 9.6625 12.3375 10 12.75 10C13.1625 10 13.5 9.6625 13.5 9.25V7.92813C13.5 6.60813 12.7659 5.42125 11.5856 4.83016C10.9172 4.49453 10.5 3.82141 10.5 3.07281V1.75C10.5 1.33544 10.1625 1 9.75 1C9.3375 1 9 1.33544 9 1.75V3.07281C9 4.39281 9.73594 5.57969 10.9125 6.17031ZM6.4125 6.17031C7.08281 6.50781 7.5 7.17813 7.5 7.92813V9.25C7.5 9.6625 7.8375 10 8.25 10C8.6625 10 9 9.6625 9 9.25V7.92813C9 6.60813 8.26594 5.42125 7.08563 4.83016C6.41719 4.49453 6 3.82141 6 3.07281V1.75C6 1.33544 5.6625 1 5.25 1C4.8375 1 4.5 1.33544 4.5 1.75V3.07281C4.5 4.39281 5.23594 5.57969 6.4125 6.17031Z"
        fill="#3D734A"
        stroke="#3D734A"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const QrCodeFilled = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#3D734A" />
      <path
        d="M15.8507 14.7869C16.1443 14.7869 16.3845 15.0275 16.3845 15.3215V15.8562C16.3845 16.1503 16.1443 16.3909 15.8507 16.3909H15.3168C15.0218 16.3909 14.7829 16.1503 14.7829 15.8562V15.3215C14.7829 15.0275 15.0218 14.7869 15.3168 14.7869H15.8507ZM17.1853 12.3809C18.0695 12.3809 18.7868 13.099 18.7868 13.9849V17.1929C18.7868 18.0784 18.0695 18.7969 17.1853 18.7969H13.9822C13.0976 18.7969 12.3806 18.0784 12.3806 17.1929V13.9849C12.3806 13.099 13.0976 12.3809 13.9822 12.3809H17.1853ZM17.1853 13.4502H13.9822C13.6872 13.4502 13.4483 13.6895 13.4483 13.9849V17.1929C13.4483 17.487 13.6872 17.7276 13.9822 17.7276H17.1853C17.4789 17.7276 17.7191 17.487 17.7191 17.1929V13.9849C17.7191 13.6895 17.4789 13.4502 17.1853 13.4502ZM14.7829 23.8763C14.7829 23.5822 15.0218 23.3416 15.3168 23.3416H15.8507C16.1443 23.3416 16.3845 23.5822 16.3845 23.8763V24.4109C16.3845 24.705 16.1443 24.9456 15.8507 24.9456H15.3168C15.0218 24.9456 14.7829 24.705 14.7829 24.4109V23.8763ZM17.1853 20.9356C18.0695 20.9356 18.7868 21.654 18.7868 22.5396V25.7476C18.7868 26.6332 18.0695 27.3516 17.1853 27.3516H13.9822C13.0976 27.3516 12.3806 26.6332 12.3806 25.7476V22.5396C12.3806 21.654 13.0976 20.9356 13.9822 20.9356H17.1853ZM17.1853 22.0049H13.9822C13.6872 22.0049 13.4483 22.2455 13.4483 22.5396V25.7476C13.4483 26.0417 13.6872 26.2823 13.9822 26.2823H17.1853C17.4789 26.2823 17.7191 26.0417 17.7191 25.7476V22.5396C17.7191 22.2455 17.4789 22.0049 17.1853 22.0049ZM24.3923 14.7869C24.6859 14.7869 24.9261 15.0275 24.9261 15.3215V15.8562C24.9261 16.1503 24.6859 16.3909 24.3923 16.3909H23.8584C23.5648 16.3909 23.3246 16.1503 23.3246 15.8562V15.3215C23.3246 15.0275 23.5648 14.7869 23.8584 14.7869H24.3923ZM20.9222 13.9849C20.9222 13.099 21.6396 12.3809 22.5238 12.3809H25.7269C26.6111 12.3809 27.3285 13.099 27.3285 13.9849V17.1929C27.3285 18.0784 26.6111 18.7969 25.7269 18.7969H22.5238C21.6396 18.7969 20.9222 18.0784 20.9222 17.1929V13.9849ZM21.9899 13.9849V17.1929C21.9899 17.487 22.2302 17.7276 22.5238 17.7276H25.7269C26.0205 17.7276 26.2608 17.487 26.2608 17.1929V13.9849C26.2608 13.6895 26.0205 13.4502 25.7269 13.4502H22.5238C22.2302 13.4502 21.9899 13.6895 21.9899 13.9849ZM20.9222 21.4702C20.9222 21.1762 21.1625 20.9356 21.4561 20.9356H23.5915C23.8851 20.9356 24.1254 21.1762 24.1254 21.4702V23.7426H26.2608V21.4702C26.2608 21.1762 26.501 20.9356 26.7946 20.9356C27.0882 20.9356 27.3285 21.1762 27.3285 21.4702V24.2773C27.3285 24.5713 27.0882 24.8119 26.7946 24.8119H23.5915C23.2979 24.8119 23.0576 24.5713 23.0576 24.2773V22.0049H21.9899V27.0843C21.9899 27.3784 21.7497 27.619 21.4561 27.619C21.1625 27.619 20.9222 27.3784 20.9222 27.0843V21.4702ZM23.0576 26.2823C23.0576 25.9882 23.2979 25.7476 23.5915 25.7476H24.1254C24.419 25.7476 24.6592 25.9882 24.6592 26.2823V26.8169C24.6592 27.111 24.419 27.3516 24.1254 27.3516H23.5915C23.2979 27.3516 23.0576 27.111 23.0576 26.8169V26.2823ZM26.7946 25.7476C27.0882 25.7476 27.3285 25.9882 27.3285 26.2823V26.8169C27.3285 27.111 27.0882 27.3516 26.7946 27.3516H26.2608C25.9671 27.3516 25.7269 27.111 25.7269 26.8169V26.2823C25.7269 25.9882 25.9671 25.7476 26.2608 25.7476H26.7946Z"
        fill="white"
      />
    </svg>
  );
};

export const ArrowLeft = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8.5H1"
        stroke="#8F8F8F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 16L1 8.5L8.5 1"
        stroke="#8F8F8F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoImage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M144 288C144 226.1 194.1 176 256 176C317.9 176 368 226.1 368 288C368 349.9 317.9 400 256 400C194.1 400 144 349.9 144 288zM256 192C202.1 192 160 234.1 160 288C160 341 202.1 384 256 384C309 384 352 341 352 288C352 234.1 309 192 256 192zM362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82H362.9zM64 112C37.49 112 16 133.5 16 160V416C16 442.5 37.49 464 64 464H448C474.5 464 496 442.5 496 416V160C496 133.5 474.5 112 448 112H361.8L347.8 69.88C343.4 56.81 331.2 48 317.4 48H194.6C180.8 48 168.6 56.81 164.2 69.88L150.2 112H64z" />
  </svg>
);

export const EmptyCards = () => (
  <svg
    width="93"
    height="86"
    viewBox="0 0 93 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M79.4268 8.72314L3.17578 31.207L5.19545 38.2224L81.4465 15.7385L79.4268 8.72314Z"
      fill="#E6E6E6"
    />
    <path
      d="M12.2836 63.4314L1.04483 24.3932C0.961514 24.1038 0.995215 23.7927 1.13852 23.5285C1.28182 23.2642 1.52299 23.0683 1.80898 22.984L76.2115 1.04513C76.4975 0.961093 76.8047 0.995315 77.0658 1.14029C77.3269 1.28527 77.5204 1.52916 77.604 1.81842L87.5607 36.4035L87.2526 36.4943L77.2959 1.90928C77.2361 1.70275 77.0978 1.52865 76.9114 1.42511C76.7249 1.32157 76.5055 1.29703 76.3013 1.35689L1.89874 23.2957C1.69447 23.356 1.5222 23.4959 1.41984 23.6847C1.31748 23.8734 1.29341 24.0956 1.35292 24.3024L12.5917 63.3406L12.2836 63.4314Z"
      fill="#E6E6E6"
      stroke="#E6E6E6"
      strokeWidth="1.5"
    />
    <path
      d="M71.0941 36.5643C70.8684 36.564 70.6488 36.4898 70.4682 36.3527C70.2877 36.2157 70.1558 36.0231 70.0924 35.8038L68.2074 29.2562C68.1303 28.9874 68.1618 28.6987 68.2948 28.4534C68.4278 28.2081 68.6515 28.0262 68.9169 27.9476L75.3867 26.0399C75.6523 25.9619 75.9375 25.9937 76.1799 26.1284C76.4223 26.263 76.6021 26.4895 76.6797 26.7581L78.5647 33.3057C78.6417 33.5745 78.6103 33.8632 78.4773 34.1085C78.3443 34.3538 78.1205 34.5357 77.8552 34.6143L71.3854 36.522C71.2908 36.55 71.1927 36.5642 71.0941 36.5643Z"
      fill="#D6E1D8"
    />
    <path
      d="M12.1085 24.5142C12.0891 24.4469 12.0661 24.3808 12.0395 24.3161C11.8586 23.8718 11.5218 23.5107 11.0939 23.3024C10.6659 23.0941 10.177 23.0532 9.72112 23.1875C9.26519 23.3219 8.8744 23.622 8.62384 24.0302C8.37327 24.4385 8.28061 24.926 8.36367 25.3992C8.37533 25.4682 8.39087 25.5365 8.4102 25.6038C8.52736 26.0085 8.77093 26.364 9.10442 26.6169C9.43791 26.8698 9.84339 27.0066 10.2601 27.0067C10.4421 27.0071 10.6231 26.9809 10.7976 26.9288C11.2875 26.7839 11.7006 26.4484 11.9463 25.9958C12.192 25.5431 12.2504 25.0103 12.1085 24.5142ZM10.7078 26.617C10.2993 26.737 9.86043 26.6881 9.48748 26.4812C9.11452 26.2742 8.83789 25.9259 8.71825 25.5128C8.69947 25.4456 8.68445 25.3772 8.67328 25.3082C8.6131 24.9184 8.69529 24.5197 8.90448 24.1867C9.11367 23.8537 9.43554 23.6093 9.8099 23.499C10.1843 23.3888 10.5855 23.4203 10.9385 23.5877C11.2916 23.7552 11.5723 24.047 11.7282 24.4087C11.7573 24.4722 11.7814 24.5379 11.8004 24.6051C11.9188 25.0186 11.8703 25.4626 11.6654 25.8399C11.4605 26.2171 11.1161 26.4966 10.7078 26.617Z"
      fill="#D6E1D8"
    />
    <path
      d="M7.3885 25.9053C7.28582 25.5484 7.29569 25.168 7.41672 24.8171C7.53775 24.4661 7.76392 24.1621 8.06372 23.9474C7.78284 23.9336 7.50275 23.9879 7.24679 24.1057C6.99084 24.2236 6.76642 24.4017 6.59223 24.6251C6.41804 24.8485 6.29913 25.1109 6.2454 25.3902C6.19167 25.6696 6.20469 25.9579 6.28335 26.2311C6.36201 26.5044 6.50405 26.7546 6.69764 26.9611C6.89122 27.1675 7.13075 27.3241 7.39625 27.4179C7.66176 27.5117 7.94557 27.5399 8.22403 27.5002C8.5025 27.4605 8.76756 27.354 8.99713 27.1897C8.6303 27.1715 8.27818 27.0381 7.98984 26.8078C7.7015 26.5776 7.49129 26.2621 7.3885 25.9053Z"
      fill="#D6E1D8"
    />
    <path
      d="M57.2661 33.9536C57.232 33.8294 57.1739 33.7131 57.0954 33.6116C57.0168 33.51 56.9192 33.4252 56.8082 33.3618C56.6972 33.2985 56.5749 33.2579 56.4484 33.2424C56.3218 33.227 56.1935 33.2369 56.0708 33.2716L45.4187 36.287L44.2715 36.6118H51.4756L52.6228 36.287L56.5938 35.1634C56.8414 35.093 57.0512 34.9261 57.1773 34.6992C57.3033 34.4724 57.3353 34.2043 57.2661 33.9536Z"
      fill="#E6E6E6"
    />
    <path
      d="M49.7272 31.7011C49.6578 31.4505 49.4929 31.238 49.2687 31.1104C49.0446 30.9828 48.7795 30.9506 48.5319 31.0207L32.5481 35.5446C32.3248 35.6086 32.1314 35.7513 32.0028 35.9469C31.8742 36.1425 31.819 36.3782 31.8469 36.6114H35.9849L37.1336 36.2867L49.055 32.9124C49.3027 32.8418 49.5126 32.6746 49.6387 32.4475C49.7647 32.2204 49.7966 31.9519 49.7272 31.7011Z"
      fill="#E6E6E6"
    />
    <path
      d="M90.8773 36.2861H13.3809C13.0832 36.2865 12.7977 36.4063 12.5871 36.6194C12.3766 36.8325 12.2581 37.1214 12.2578 37.4228V83.8634C12.2581 84.1647 12.3766 84.4537 12.5871 84.6668C12.7977 84.8799 13.0832 84.9997 13.3809 85H90.8773C91.175 84.9997 91.4605 84.8798 91.6711 84.6667C91.8816 84.4537 92.0001 84.1647 92.0004 83.8634V37.4228C92 37.1214 91.8816 36.8325 91.6711 36.6194C91.4605 36.4064 91.175 36.2865 90.8773 36.2861ZM91.6795 83.8634C91.6794 84.0787 91.5949 84.2851 91.4445 84.4374C91.294 84.5896 91.09 84.6752 90.8773 84.6753H13.3809C13.1682 84.6752 12.9642 84.5896 12.8138 84.4374C12.6633 84.2851 12.5788 84.0787 12.5787 83.8634V37.4228C12.5788 37.2075 12.6633 37.001 12.8138 36.8488C12.9642 36.6966 13.1682 36.611 13.3809 36.6109H90.8773C91.09 36.611 91.294 36.6966 91.4444 36.8488C91.5949 37.001 91.6794 37.2075 91.6795 37.4228V83.8634Z"
      fill="#E6E6E6"
      stroke="#E6E6E6"
      strokeWidth="1.5"
    />
    <path
      d="M20.9215 42.6193C20.5407 42.6193 20.1684 42.505 19.8518 42.2909C19.5352 42.0768 19.2884 41.7725 19.1427 41.4164C18.9969 41.0604 18.9588 40.6686 19.0331 40.2906C19.1074 39.9126 19.2908 39.5654 19.56 39.2929C19.8293 39.0204 20.1724 38.8348 20.5458 38.7596C20.9193 38.6844 21.3065 38.723 21.6583 38.8705C22.0101 39.018 22.3108 39.2677 22.5224 39.5882C22.7339 39.9086 22.8468 40.2853 22.8468 40.6707C22.8463 41.1873 22.6432 41.6826 22.2823 42.0479C21.9213 42.4132 21.4319 42.6187 20.9215 42.6193ZM20.9215 39.0469C20.6041 39.0469 20.2939 39.1422 20.0301 39.3206C19.7662 39.499 19.5606 39.7526 19.4391 40.0493C19.3177 40.346 19.2859 40.6725 19.3478 40.9875C19.4097 41.3025 19.5625 41.5918 19.7869 41.8189C20.0113 42.046 20.2972 42.2007 20.6084 42.2633C20.9197 42.326 21.2423 42.2938 21.5355 42.1709C21.8287 42.048 22.0792 41.8399 22.2555 41.5729C22.4318 41.3058 22.5259 40.9919 22.5259 40.6707C22.5255 40.2402 22.3563 39.8275 22.0555 39.5231C21.7547 39.2186 21.3469 39.0474 20.9215 39.0469Z"
      fill="#D6E1D8"
    />
    <path
      d="M17.9265 40.6709C17.9266 40.2992 18.0412 39.9368 18.2544 39.6342C18.4676 39.3315 18.7687 39.1037 19.1159 38.9824C18.8501 38.8896 18.5662 38.8624 18.2878 38.9031C18.0095 38.9439 17.7448 39.0513 17.5158 39.2165C17.2869 39.3817 17.1002 39.5999 16.9714 39.8529C16.8426 40.1059 16.7754 40.3863 16.7754 40.6709C16.7754 40.9555 16.8426 41.236 16.9714 41.489C17.1002 41.742 17.2869 41.9602 17.5158 42.1254C17.7448 42.2906 18.0095 42.398 18.2878 42.4387C18.5662 42.4795 18.8501 42.4523 19.1159 42.3595C18.7687 42.2382 18.4676 42.0104 18.2544 41.7077C18.0412 41.4051 17.9266 41.0426 17.9265 40.6709Z"
      fill="#D6E1D8"
    />
    <path
      d="M28.7272 63.6928C28.3444 63.6924 27.9773 63.5383 27.7066 63.2643C27.4359 62.9903 27.2836 62.6189 27.2832 62.2314V57.8472C27.2832 57.4596 27.4353 57.0879 27.7061 56.8138C27.977 56.5397 28.3443 56.3857 28.7272 56.3857C29.1102 56.3857 29.4775 56.5397 29.7483 56.8138C30.0191 57.0879 30.1713 57.4596 30.1713 57.8472V62.2314C30.1708 62.6189 30.0185 62.9903 29.7478 63.2643C29.4771 63.5383 29.1101 63.6924 28.7272 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M32.5768 63.6928C32.194 63.6924 31.827 63.5383 31.5562 63.2643C31.2855 62.9903 31.1333 62.6189 31.1328 62.2314V57.8472C31.1328 57.4596 31.2849 57.0879 31.5558 56.8138C31.8266 56.5397 32.1939 56.3857 32.5768 56.3857C32.9598 56.3857 33.3271 56.5397 33.5979 56.8138C33.8687 57.0879 34.0209 57.4596 34.0209 57.8472V62.2314C34.0204 62.6189 33.8682 62.9903 33.5974 63.2643C33.3267 63.5383 32.9597 63.6924 32.5768 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M36.4265 63.6928C36.0436 63.6924 35.6766 63.5383 35.4059 63.2643C35.1351 62.9903 34.9829 62.6189 34.9824 62.2314V57.8472C34.9824 57.4596 35.1346 57.0879 35.4054 56.8138C35.6762 56.5397 36.0435 56.3857 36.4265 56.3857C36.8094 56.3857 37.1767 56.5397 37.4475 56.8138C37.7183 57.0879 37.8705 57.4596 37.8705 57.8472V62.2314C37.87 62.6189 37.7178 62.9903 37.4471 63.2643C37.1763 63.5383 36.8093 63.6924 36.4265 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M42.364 63.6928C41.9811 63.6924 41.6141 63.5383 41.3434 63.2643C41.0726 62.9903 40.9204 62.6189 40.9199 62.2314V57.8472C40.9199 57.4596 41.0721 57.0879 41.3429 56.8138C41.6137 56.5397 41.981 56.3857 42.364 56.3857C42.7469 56.3857 43.1142 56.5397 43.385 56.8138C43.6558 57.0879 43.808 57.4596 43.808 57.8472V62.2314C43.8075 62.6189 43.6553 62.9903 43.3846 63.2643C43.1138 63.5383 42.7468 63.6924 42.364 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M46.2155 63.6928C45.8327 63.6924 45.4656 63.5383 45.1949 63.2643C44.9242 62.9903 44.7719 62.6189 44.7715 62.2314V57.8472C44.7715 57.4596 44.9236 57.0879 45.1944 56.8138C45.4652 56.5397 45.8325 56.3857 46.2155 56.3857C46.5985 56.3857 46.9658 56.5397 47.2366 56.8138C47.5074 57.0879 47.6595 57.4596 47.6595 57.8472V62.2314C47.6591 62.6189 47.5068 62.9903 47.2361 63.2643C46.9654 63.5383 46.5984 63.6924 46.2155 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M50.0671 63.6928C49.6842 63.6924 49.3172 63.5383 49.0465 63.2643C48.7758 62.9903 48.6235 62.6189 48.623 62.2314V57.8472C48.623 57.4596 48.7752 57.0879 49.046 56.8138C49.3168 56.5397 49.6841 56.3857 50.0671 56.3857C50.4501 56.3857 50.8174 56.5397 51.0882 56.8138C51.359 57.0879 51.5111 57.4596 51.5111 57.8472V62.2314C51.5107 62.6189 51.3584 62.9903 51.0877 63.2643C50.817 63.5383 50.4499 63.6924 50.0671 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M56.0026 63.6928C55.6198 63.6924 55.2527 63.5383 54.982 63.2643C54.7113 62.9903 54.559 62.6189 54.5586 62.2314V57.8472C54.5586 57.4596 54.7107 57.0879 54.9815 56.8138C55.2523 56.5397 55.6196 56.3857 56.0026 56.3857C56.3856 56.3857 56.7529 56.5397 57.0237 56.8138C57.2945 57.0879 57.4467 57.4596 57.4467 57.8472V62.2314C57.4462 62.6189 57.2939 62.9903 57.0232 63.2643C56.7525 63.5383 56.3855 63.6924 56.0026 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M59.8522 63.6928C59.4694 63.6924 59.1024 63.5383 58.8316 63.2643C58.5609 62.9903 58.4086 62.6189 58.4082 62.2314V57.8472C58.4082 57.4596 58.5603 57.0879 58.8312 56.8138C59.102 56.5397 59.4693 56.3857 59.8522 56.3857C60.2352 56.3857 60.6025 56.5397 60.8733 56.8138C61.1441 57.0879 61.2963 57.4596 61.2963 57.8472V62.2314C61.2958 62.6189 61.1435 62.9903 60.8728 63.2643C60.6021 63.5383 60.2351 63.6924 59.8522 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M63.7038 63.6928C63.3209 63.6924 62.9539 63.5383 62.6832 63.2643C62.4125 62.9903 62.2602 62.6189 62.2598 62.2314V57.8472C62.2598 57.4596 62.4119 57.0879 62.6827 56.8138C62.9535 56.5397 63.3208 56.3857 63.7038 56.3857C64.0868 56.3857 64.4541 56.5397 64.7249 56.8138C64.9957 57.0879 65.1478 57.4596 65.1478 57.8472V62.2314C65.1474 62.6189 64.9951 62.9903 64.7244 63.2643C64.4537 63.5383 64.0866 63.6924 63.7038 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M69.6393 63.6928C69.2565 63.6924 68.8895 63.5383 68.6187 63.2643C68.348 62.9903 68.1958 62.6189 68.1953 62.2314V57.8472C68.1953 57.4596 68.3475 57.0879 68.6183 56.8138C68.8891 56.5397 69.2564 56.3857 69.6393 56.3857C70.0223 56.3857 70.3896 56.5397 70.6604 56.8138C70.9312 57.0879 71.0834 57.4596 71.0834 57.8472V62.2314C71.0829 62.6189 70.9307 62.9903 70.6599 63.2643C70.3892 63.5383 70.0222 63.6924 69.6393 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M73.4909 63.6928C73.1081 63.6924 72.741 63.5383 72.4703 63.2643C72.1996 62.9903 72.0473 62.6189 72.0469 62.2314V57.8472C72.0469 57.4596 72.199 57.0879 72.4698 56.8138C72.7406 56.5397 73.1079 56.3857 73.4909 56.3857C73.8739 56.3857 74.2412 56.5397 74.512 56.8138C74.7828 57.0879 74.9349 57.4596 74.9349 57.8472V62.2314C74.9345 62.6189 74.7822 62.9903 74.5115 63.2643C74.2408 63.5383 73.8738 63.6924 73.4909 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M77.3425 63.6928C76.9596 63.6924 76.5926 63.5383 76.3219 63.2643C76.0512 62.9903 75.8989 62.6189 75.8984 62.2314V57.8472C75.8984 57.4596 76.0506 57.0879 76.3214 56.8138C76.5922 56.5397 76.9595 56.3857 77.3425 56.3857C77.7254 56.3857 78.0927 56.5397 78.3635 56.8138C78.6344 57.0879 78.7865 57.4596 78.7865 57.8472V62.2314C78.7861 62.6189 78.6338 62.9903 78.3631 63.2643C78.0924 63.5383 77.7253 63.6924 77.3425 63.6928Z"
      fill="#D6E1D8"
    />
    <path
      d="M38.5141 79.9578H17.7457C17.4883 79.9578 17.2415 79.8544 17.0596 79.6702C16.8776 79.4861 16.7754 79.2363 16.7754 78.9759C16.7754 78.7154 16.8776 78.4657 17.0596 78.2815C17.2415 78.0974 17.4883 77.9939 17.7457 77.9939H38.5141C38.7714 77.9939 39.0182 78.0974 39.2002 78.2815C39.3821 78.4657 39.4844 78.7154 39.4844 78.9759C39.4844 79.2363 39.3821 79.4861 39.2002 79.6702C39.0182 79.8544 38.7714 79.9578 38.5141 79.9578Z"
      fill="#E6E6E6"
    />
    <path
      d="M31.859 75.7354H24.4078C24.1505 75.7354 23.9037 75.632 23.7217 75.4478C23.5397 75.2637 23.4375 75.0139 23.4375 74.7535C23.4375 74.493 23.5397 74.2433 23.7217 74.0591C23.9037 73.8749 24.1505 73.7715 24.4078 73.7715H31.859C32.1164 73.7715 32.3632 73.8749 32.5451 74.0591C32.7271 74.2433 32.8293 74.493 32.8293 74.7535C32.8293 75.0139 32.7271 75.2637 32.5451 75.4478C32.3632 75.632 32.1164 75.7354 31.859 75.7354Z"
      fill="#E6E6E6"
    />
    <path
      d="M91.6222 45.9937H12.5215V46.3184H91.6222V45.9937Z"
      fill="#E6E6E6"
      stroke="#E6E6E6"
      strokeWidth="1.5"
    />
  </svg>
);

export const Pix = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6586 14.3836C13.9356 14.3836 13.2555 14.1021 12.7442 13.5911L9.98011 10.8269C9.78603 10.6323 9.44779 10.6329 9.2538 10.8269L6.47958 13.6012C5.96829 14.1122 5.28825 14.3937 4.56523 14.3937H4.02051L7.52137 17.8945C8.61466 18.9878 10.3873 18.9878 11.4807 17.8945L14.9915 14.3836H14.6586Z"
      fill="#3D734A"
    />
    <path
      d="M4.56508 4.60637C5.28809 4.60637 5.96813 4.88789 6.47942 5.39893L9.25364 8.17364C9.45343 8.37352 9.77966 8.37427 9.97996 8.17341L12.7441 5.40904C13.2554 4.898 13.9354 4.61648 14.6584 4.61648H14.9913L11.4806 1.10568C10.3872 0.0123007 8.61451 0.0123007 7.52121 1.10568L4.02051 4.60638L4.56508 4.60637Z"
      fill="#3D734A"
    />
    <path
      d="M17.8941 7.52066L15.7725 5.39907C15.7258 5.41778 15.6752 5.42946 15.6218 5.42946H14.6571C14.1584 5.42946 13.6703 5.63174 13.3179 5.98438L10.5538 8.7485C10.2952 9.00717 9.95527 9.13658 9.6157 9.13658C9.27581 9.13658 8.93617 9.00717 8.67758 8.74875L5.90311 5.97428C5.55071 5.62155 5.06252 5.41936 4.56382 5.41936H3.37771C3.32712 5.41936 3.27985 5.40743 3.23522 5.39062L1.10519 7.52066C0.0118126 8.61403 0.0118126 10.3866 1.10519 11.48L3.23513 13.6099C3.27984 13.5931 3.32712 13.5812 3.37771 13.5812H4.56382C5.06252 13.5812 5.55071 13.379 5.90311 13.0264L8.67733 10.2521C9.17877 9.75113 10.0529 9.75096 10.5538 10.2524L13.3179 13.0163C13.6703 13.3689 14.1584 13.5712 14.6571 13.5712H15.6218C15.6752 13.5712 15.7258 13.5828 15.7725 13.6016L17.8941 11.48C18.9874 10.3866 18.9874 8.61402 17.8941 7.52065"
      fill="#3D734A"
    />
  </svg>
);

export const Motorcycle = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7425 1.5C10.7425 1.225 10.9619 1 11.2302 1H12.477C13.108 1 13.6658 1.4125 13.864 2.025L14.0225 2.50938L15.7509 1.625C15.9094 1.54375 16.0862 1.5 16.2661 1.5C16.7172 1.5 17.083 1.875 17.083 2.34063V4.6625C17.083 5.125 16.7172 5.50313 16.263 5.50313C16.0832 5.50313 15.9094 5.45938 15.7478 5.37813L14.7968 4.8875L15.5741 7.28125C15.7478 7.25938 15.9277 7.25 16.1075 7.25C17.3726 7.25 18.5188 7.76875 19.354 8.60938C19.5461 8.80312 19.5491 9.11875 19.3601 9.31563C19.1711 9.5125 18.8633 9.51562 18.6712 9.32187C18.0097 8.65937 17.1044 8.25 16.1075 8.25C14.3852 8.25 12.9373 9.47187 12.5501 11.1187C12.5166 11.2625 12.4892 11.4094 12.4739 11.5594C12.4465 11.8125 12.2361 12 11.9892 12H10.7425H9.27925H8.30377C8.30377 13.6562 6.99298 15 5.37736 15C3.76173 15 2.45094 13.6562 2.45094 12H1.47547C0.935914 12 0.5 11.5531 0.5 11V10C0.5 7.79063 2.2467 6 4.40189 6H7.3283C7.86786 6 8.30377 6.44688 8.30377 7V10C8.30377 10.5531 8.73969 11 9.27925 11H10.2547H10.7425H11.2302H11.5777C11.5868 10.9594 11.596 10.9219 11.6051 10.8813C11.977 9.29375 13.1293 8.01875 14.62 7.5L12.9434 2.34063C12.8763 2.1375 12.6903 2 12.48 2H11.2302C10.9619 2 10.7425 1.775 10.7425 1.5ZM14.3608 3.54688C14.3669 3.55 14.37 3.55 14.3761 3.55312L16.1075 4.44063V2.55938L14.3761 3.44688C14.3639 3.45312 14.3486 3.45938 14.3365 3.46563L14.3639 3.54688H14.3608ZM3.91415 4H7.81604C8.08429 4 8.30377 4.225 8.30377 4.5C8.30377 4.775 8.08429 5 7.81604 5H3.91415C3.6459 5 3.42641 4.775 3.42641 4.5C3.42641 4.225 3.6459 4 3.91415 4ZM7.3283 7H4.40189C2.78626 7 1.47547 8.34375 1.47547 10V11H2.6186H3.68857H7.06614H7.58741C7.4228 10.7063 7.32525 10.3656 7.32525 10V7H7.3283ZM5.37736 14C6.45343 14 7.3283 13.1031 7.3283 12H3.42641C3.42641 13.1031 4.30129 14 5.37736 14ZM16.1075 14C16.625 14 17.1212 13.7893 17.4871 13.4142C17.8529 13.0391 18.0585 12.5304 18.0585 12C18.0585 11.4696 17.8529 10.9609 17.4871 10.5858C17.1212 10.2107 16.625 10 16.1075 10C15.5901 10 15.0939 10.2107 14.728 10.5858C14.3621 10.9609 14.1566 11.4696 14.1566 12C14.1566 12.5304 14.3621 13.0391 14.728 13.4142C15.0939 13.7893 15.5901 14 16.1075 14ZM16.1075 9C16.8837 9 17.628 9.31607 18.1768 9.87868C18.7256 10.4413 19.034 11.2044 19.034 12C19.034 12.7956 18.7256 13.5587 18.1768 14.1213C17.628 14.6839 16.8837 15 16.1075 15C15.3314 15 14.5871 14.6839 14.0383 14.1213C13.4894 13.5587 13.1811 12.7956 13.1811 12C13.1811 11.2044 13.4894 10.4413 14.0383 9.87868C14.5871 9.31607 15.3314 9 16.1075 9Z"
      fill="black"
      stroke="black"
      strokeWidth="0.2"
    />
  </svg>
);

export const CalendarAlt = ({ color = "black" }) => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 1C3.73571 1 3.92857 1.19687 3.92857 1.4375V2.75H9.07143V1.4375C9.07143 1.19687 9.26429 1 9.5 1C9.73571 1 9.92857 1.19687 9.92857 1.4375V2.75H10.7857C11.7312 2.75 12.5 3.53477 12.5 4.5V5.375V6.25V13.25C12.5 14.2152 11.7312 15 10.7857 15H2.21429C1.26875 15 0.5 14.2152 0.5 13.25V6.25V5.375V4.5C0.5 3.53477 1.26875 2.75 2.21429 2.75H3.07143V1.4375C3.07143 1.19687 3.26429 1 3.5 1ZM11.6429 6.25H1.35714V13.25C1.35714 13.734 1.74018 14.125 2.21429 14.125H10.7857C11.2598 14.125 11.6429 13.734 11.6429 13.25V6.25ZM10.7857 3.625H2.21429C1.74018 3.625 1.35714 4.01602 1.35714 4.5V5.375H11.6429V4.5C11.6429 4.01602 11.2598 3.625 10.7857 3.625Z"
      fill={color}
      stroke={color}
      strokeWidth="0.2"
    />
  </svg>
);

export const UserLight = ({ color = "#3D734A" }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4C10 3.60603 9.9224 3.21593 9.77164 2.85195C9.62087 2.48797 9.3999 2.15726 9.12132 1.87868C8.84274 1.6001 8.51203 1.37913 8.14805 1.22836C7.78407 1.0776 7.39397 1 7 1C6.60603 1 6.21593 1.0776 5.85195 1.22836C5.48797 1.37913 5.15726 1.6001 4.87868 1.87868C4.6001 2.15726 4.37913 2.48797 4.22836 2.85195C4.0776 3.21593 4 3.60603 4 4C4 4.39397 4.0776 4.78407 4.22836 5.14805C4.37913 5.51203 4.6001 5.84274 4.87868 6.12132C5.15726 6.3999 5.48797 6.62087 5.85195 6.77164C6.21593 6.9224 6.60603 7 7 7C7.39397 7 7.78407 6.9224 8.14805 6.77164C8.51203 6.62087 8.84274 6.3999 9.12132 6.12132C9.3999 5.84274 9.62087 5.51203 9.77164 5.14805C9.9224 4.78407 10 4.39397 10 4ZM3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4ZM1 15H13C12.9625 12.5094 10.9313 10.5 8.42813 10.5H5.57188C3.07188 10.5 1.04062 12.5094 1 15ZM0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5H8.42813C11.5063 9.5 14 11.9937 14 15.0719C14 15.5844 13.5844 16 13.0719 16H0.928125C0.415625 16 0 15.5844 0 15.0719Z"
      fill={color}
    />
  </svg>
);

export const GiftLight = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4094 1C11.8594 1 11.35 1.28125 11.0594 1.74688L9.65312 4H10H12.5C13.3281 4 14 3.32812 14 2.5C14 1.67188 13.3281 1 12.5 1H12.4094ZM8.34688 4L6.94063 1.74688C6.65 1.28125 6.14062 1 5.59062 1H5.5C4.67188 1 4 1.67188 4 2.5C4 3.32812 4.67188 4 5.5 4H8H8.34688ZM9 3.15625L10.2125 1.21875C10.6844 0.4625 11.5156 0 12.4094 0H12.5C13.8813 0 15 1.11875 15 2.5C15 3.0625 14.8125 3.58125 14.5 4H16C17.1031 4 18 4.89687 18 6V14C18 15.1031 17.1031 16 16 16H2C0.896875 16 0 15.1031 0 14V6C0 4.89687 0.896875 4 2 4H3.5C3.1875 3.58125 3 3.0625 3 2.5C3 1.11875 4.11875 0 5.5 0H5.59062C6.48438 0 7.31562 0.459375 7.7875 1.21875L9 3.15625ZM5.5 5H2C1.44687 5 1 5.44688 1 6V9H17V6C17 5.44688 16.5531 5 16 5H12.5H10.0688L11.8844 7.18125C12.0625 7.39375 12.0312 7.70937 11.8219 7.88438C11.6125 8.05937 11.2937 8.03125 11.1187 7.82188L9 5.28125L6.88438 7.82188C6.70625 8.03438 6.39375 8.0625 6.18125 7.88438C5.96875 7.70625 5.94063 7.39375 6.11875 7.18125L7.93125 5H5.5ZM1 10V12H17V10H1ZM17 14V13H1V14C1 14.5531 1.44687 15 2 15H16C16.5531 15 17 14.5531 17 14Z"
      fill="#3D734A"
    />
  </svg>
);

export const GiftRegular = ({ color = "#a0a0a0" }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 4.54199L10.175 2.03154C10.6031 1.38994 11.3531 1 12.1594 1H12.25C13.4937 1 14.5 1.94453 14.5 3.10938C14.5 3.77207 14.175 4.36328 13.6656 4.75H15C15.8281 4.75 16.5 5.37988 16.5 6.15625V7.09375C16.5 7.70605 16.0813 8.22754 15.5 8.4209V14.125C15.5 15.1592 14.6031 16 13.5 16H3.5C2.39531 16 1.5 15.1592 1.5 14.125V8.4209C0.9175 8.22754 0.5 7.70605 0.5 7.09375V6.15625C0.5 5.37988 1.17156 4.75 2 4.75H3.33562C2.82594 4.36328 2.5 3.77207 2.5 3.10938C2.5 1.94453 3.5075 1 4.75 1H4.84062C5.64687 1 6.4 1.38994 6.825 2.03154L8.5 4.54199ZM12.1594 1.46875C11.525 1.46875 10.9344 1.7752 10.5969 2.27998L8.95 4.75H12.25C13.2156 4.75 14 4.01465 14 3.10938C14 2.20322 13.2156 1.46875 12.25 1.46875H12.1594ZM8.05 4.75L6.40312 2.27998C6.06562 1.7752 5.475 1.46875 4.84062 1.46875H4.75C3.78437 1.46875 3 2.20322 3 3.10938C3 4.01465 3.78437 4.75 4.75 4.75H8.05ZM2 5.21875C1.44781 5.21875 1 5.6377 1 6.15625V7.09375C1 7.6123 1.44781 8.03125 2 8.03125H8.25V5.21875H2ZM8.75 8.03125H15C15.5531 8.03125 16 7.6123 16 7.09375V6.15625C16 5.6377 15.5531 5.21875 15 5.21875H8.75V8.03125ZM8.25 8.5H2V14.125C2 14.9014 2.67156 15.5312 3.5 15.5312H8.25V8.5ZM13.5 15.5312C14.3281 15.5312 15 14.9014 15 14.125V8.5H8.75V15.5312H13.5Z"
      fill={color}
      stroke={color}
    />
  </svg>
);

export const StoreLight = () => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 5.80625C0.5 5.60625 0.55 5.40938 0.646875 5.23438L3.075 0.78125C3.3375 0.3 3.84063 0 4.39062 0H16.6094C17.1594 0 17.6625 0.3 17.925 0.78125L20.3531 5.23125C20.45 5.40625 20.5 5.60313 20.5 5.80312C20.5 6.4625 19.9656 6.99687 19.3062 6.99687H18.5V15.5C18.5 15.775 18.275 16 18 16C17.725 16 17.5 15.775 17.5 15.5V7H3.5V11H11.5V8.5V8H12.5V8.5V14.5C12.5 15.3281 11.8281 16 11 16H4C3.17188 16 2.5 15.3281 2.5 14.5V7H1.69375C1.03438 7 0.5 6.46563 0.5 5.80625ZM3 6H18H19.3062C19.4125 6 19.5 5.9125 19.5 5.80625C19.5 5.775 19.4906 5.74062 19.475 5.7125L17.05 1.25937C16.9625 1.1 16.7937 1 16.6125 1H4.39375C4.20937 1 4.04375 1.1 3.95625 1.25937L1.525 5.7125C1.50937 5.74062 1.5 5.77187 1.5 5.80625C1.5 5.9125 1.5875 6 1.69375 6H3ZM3.5 14.5C3.5 14.775 3.725 15 4 15H11C11.275 15 11.5 14.775 11.5 14.5V12H3.5V14.5Z"
      fill="#3D734A"
    />
  </svg>
);

export const BikeLight = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8597 0.571429C11.8597 0.257143 12.1138 0 12.4244 0H13.8681C14.5987 0 15.2446 0.471429 15.4741 1.17143L15.6576 1.725L17.6589 0.714286C17.8425 0.621429 18.0472 0.571429 18.2554 0.571429C18.7778 0.571429 19.2014 1 19.2014 1.53214V4.18571C19.2014 4.71429 18.7778 5.14643 18.2519 5.14643C18.0437 5.14643 17.8425 5.09643 17.6554 5.00357L16.5541 4.44286L17.4542 7.17857C17.6554 7.15357 17.8636 7.14286 18.0719 7.14286C19.5367 7.14286 20.8639 7.73571 21.831 8.69643C22.0534 8.91786 22.0569 9.27857 21.8381 9.50357C21.6192 9.72857 21.2627 9.73214 21.0403 9.51071C20.2744 8.75357 19.2261 8.28572 18.0719 8.28572C16.0776 8.28572 14.401 9.68214 13.9528 11.5643C13.9139 11.7286 13.8822 11.8964 13.8645 12.0679C13.8328 12.3571 13.5892 12.5714 13.3033 12.5714H11.8597H10.1654H9.03595C9.03595 14.4643 7.51819 16 5.64747 16C3.77674 16 2.25899 14.4643 2.25899 12.5714H1.12949C0.504742 12.5714 0 12.0607 0 11.4286V10.2857C0 7.76071 2.0225 5.71429 4.51797 5.71429H7.90645C8.53121 5.71429 9.03595 6.225 9.03595 6.85714V10.2857C9.03595 10.9179 9.54069 11.4286 10.1654 11.4286H11.2949H11.8597H12.4244H12.8268C12.8374 11.3821 12.848 11.3393 12.8586 11.2929C13.2892 9.47857 14.6234 8.02143 16.3494 7.42857L14.4081 1.53214C14.3304 1.3 14.1151 1.14286 13.8716 1.14286H12.4244C12.1138 1.14286 11.8597 0.885714 11.8597 0.571429ZM16.0494 2.91071C16.0565 2.91429 16.06 2.91429 16.067 2.91786L18.0719 3.93214V1.78214L16.067 2.79643C16.0529 2.80357 16.0353 2.81071 16.0212 2.81786L16.0529 2.91071H16.0494ZM3.95323 3.42857H8.4712C8.78181 3.42857 9.03595 3.68571 9.03595 4C9.03595 4.31429 8.78181 4.57143 8.4712 4.57143H3.95323C3.64262 4.57143 3.38848 4.31429 3.38848 4C3.38848 3.68571 3.64262 3.42857 3.95323 3.42857ZM7.90645 6.85714H4.51797C2.64725 6.85714 1.12949 8.39286 1.12949 10.2857V11.4286H2.45312H3.69203H7.6029H8.20648C8.01587 11.0929 7.90292 10.7036 7.90292 10.2857V6.85714H7.90645ZM5.64747 14.8571C6.89344 14.8571 7.90645 13.8321 7.90645 12.5714H3.38848C3.38848 13.8321 4.40149 14.8571 5.64747 14.8571ZM18.0719 14.8571C18.671 14.8571 19.2456 14.6163 19.6692 14.1877C20.0929 13.759 20.3309 13.1776 20.3309 12.5714C20.3309 11.9652 20.0929 11.3838 19.6692 10.9552C19.2456 10.5265 18.671 10.2857 18.0719 10.2857C17.4728 10.2857 16.8982 10.5265 16.4746 10.9552C16.0509 11.3838 15.8129 11.9652 15.8129 12.5714C15.8129 13.1776 16.0509 13.759 16.4746 14.1877C16.8982 14.6163 17.4728 14.8571 18.0719 14.8571ZM18.0719 9.14286C18.9706 9.14286 19.8325 9.50408 20.4679 10.1471C21.1034 10.79 21.4604 11.6621 21.4604 12.5714C21.4604 13.4807 21.1034 14.3528 20.4679 14.9958C19.8325 15.6388 18.9706 16 18.0719 16C17.1732 16 16.3113 15.6388 15.6759 14.9958C15.0404 14.3528 14.6834 13.4807 14.6834 12.5714C14.6834 11.6621 15.0404 10.79 15.6759 10.1471C16.3113 9.50408 17.1732 9.14286 18.0719 9.14286Z"
      fill="#3D734A"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 7L12 7"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 2L12 7L7 12"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ForkKnife = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.8067 0.00889107C2.17567 0.0704125 2.42589 0.40673 2.36652 0.763554L1.38683 6.45634C1.36987 6.56297 1.35714 6.66961 1.35714 6.78035V7.2192C1.35714 8.30608 2.26897 9.18789 3.39286 9.18789H4.75H6.10714C7.23103 9.18789 8.14286 8.30608 8.14286 7.2192V6.78035C8.14286 6.67371 8.13437 6.56297 8.11317 6.45634L7.13348 0.763554C7.06987 0.40673 7.32009 0.0663111 7.6933 0.00889107C8.06652 -0.0485289 8.41429 0.189354 8.47366 0.55028L9.45335 6.24306C9.48304 6.41942 9.5 6.59989 9.5 6.78445V7.2192C9.5 9.03203 7.9817 10.5003 6.10714 10.5003H5.42857V20.3438C5.42857 20.7047 5.12321 21 4.75 21C4.37679 21 4.07143 20.7047 4.07143 20.3438V10.5003H3.39286C1.5183 10.5003 0 9.03203 0 7.2192V6.78035C0 6.59989 0.0169643 6.41942 0.0466518 6.23896L1.02634 0.55028C1.08996 0.193455 1.43772 -0.0485289 1.8067 0.00889107ZM3.76607 0.000688213C4.13929 0.0170939 4.42768 0.328802 4.41071 0.689728L4.07143 7.25201C4.05446 7.61294 3.73214 7.89184 3.35893 7.87543C2.98571 7.85902 2.69732 7.54732 2.71429 7.18639L3.05357 0.624105C3.07478 0.26318 3.39286 -0.0157175 3.76607 0.000688213ZM5.73393 0.000688213C6.10714 -0.0157175 6.42522 0.26318 6.44643 0.624105L6.78571 7.18639C6.80268 7.54732 6.51429 7.85492 6.14107 7.87543C5.76786 7.89594 5.44978 7.61294 5.42857 7.25201L5.08929 0.689728C5.07232 0.328802 5.36071 0.0211954 5.73393 0.000688213ZM13.5714 7.2192V11.8128C13.5714 12.5388 14.1779 13.1253 14.9286 13.1253H17.6429V1.32135L17.6344 1.32545C17.5623 1.34186 17.3502 1.38697 17.0279 1.51412C16.5996 1.68227 16.0737 1.96117 15.5647 2.38772C14.5808 3.21211 13.5714 4.65581 13.5714 7.2192ZM17.6429 0.000688213C18.3935 0.000688213 19 0.587192 19 1.31315V13.1253V13.7815V14.4377V20.3438C19 20.7047 18.6946 21 18.3214 21C17.9482 21 17.6429 20.7047 17.6429 20.3438V14.4377H14.9286C13.4315 14.4377 12.2143 13.2606 12.2143 11.8128V7.2192C12.2143 1.31315 16.9643 0.000688213 17.6429 0.000688213Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const ForkKnifeRegular = ({ color = "#a0a0a0" }) => (
  <svg
    height="14"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.83333 0C6.07222 0 7.325 0.230357 8.5 0.605357C9.675 0.230357 10.9278 0 12.1667 0C13.7056 0 15.1444 0.391071 15.7472 0.578571C16.2139 0.723214 16.5 1.13839 16.5 1.58304V9.92679C16.5 10.6473 15.8028 11.1268 15.1389 11.0143C14.625 10.9286 13.7139 10.8214 12.3889 10.8214C10.7528 10.8214 9.67222 11.4723 9.3 11.7348C9.09167 11.8821 8.82222 11.992 8.51667 12C8.51111 12 8.50278 12 8.49722 12H8.49167H8.48333C8.2 12 7.93889 11.9089 7.73333 11.775C7.31944 11.5045 6.11111 10.8214 4.61111 10.8214C3.35556 10.8214 2.38611 10.9393 1.83333 11.0277C1.16667 11.1348 0.5 10.65 0.5 9.95089V1.58304C0.5 1.13839 0.786111 0.723214 1.25278 0.578571C1.85556 0.391071 3.29444 0 4.83333 0ZM8.94444 10.9286C9.50833 10.567 10.6972 9.96429 12.3889 9.96429C13.7639 9.96429 14.725 10.0768 15.2889 10.1679C15.3583 10.1786 15.4472 10.1598 15.5167 10.1062C15.5778 10.058 15.6111 9.99911 15.6111 9.92411V1.58036C15.6111 1.48661 15.5528 1.41696 15.475 1.39286C14.9056 1.21875 13.5694 0.857143 12.1667 0.857143C11.0944 0.857143 9.99722 1.04732 8.94444 1.36607V10.9286ZM8.05556 1.36607C7.00278 1.04464 5.90556 0.857143 4.83333 0.857143C3.43056 0.857143 2.09444 1.21875 1.525 1.39286C1.44722 1.41696 1.38889 1.48929 1.38889 1.58036V9.95089C1.38889 10.0232 1.41944 10.0821 1.475 10.125C1.53611 10.1732 1.61667 10.192 1.68611 10.1813C2.27778 10.0848 3.29722 9.96161 4.61111 9.96161C6.18889 9.96161 7.46667 10.5964 8.05556 10.95V1.36607Z"
      fill={color}
    />
  </svg>
);

export const ForkKnifeRegularFilled = () => (
  <svg
    height="14"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.43333 11.9737C7.73333 12.0773 8.05556 11.862 8.05556 11.5515V1.26957C8.05556 1.15515 8.01111 1.04072 7.91667 0.969886C7.37222 0.54488 6.12222 0 4.5 0C3.09722 0 1.78611 0.362345 1.00278 0.65658C0.688889 0.776454 0.5 1.08159 0.5 1.41124V11.4997C0.5 11.8239 0.855556 12.05 1.16944 11.9492C2.04444 11.6632 3.43056 11.3335 4.5 11.3335C5.44167 11.3335 6.69444 11.7149 7.43333 11.9737ZM9.56667 11.9737C10.3056 11.7149 11.5583 11.3335 12.5 11.3335C13.5694 11.3335 14.9556 11.6632 15.8306 11.9492C16.1444 12.0527 16.5 11.8239 16.5 11.4997V1.41124C16.5 1.08159 16.3111 0.776454 15.9972 0.659305C15.2139 0.362345 13.9028 0 12.5 0C10.8778 0 9.62778 0.54488 9.08333 0.969886C8.99167 1.04072 8.94444 1.15515 8.94444 1.26957V11.5515C8.94444 11.862 9.26944 12.0773 9.56667 11.9737Z"
      fill="#3D734A"
    />
  </svg>
);

export const HomeLight = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5575 0.170809C11.8075 -0.0569364 12.1867 -0.0569364 12.4408 0.170809L23.7741 10.4838C24.0491 10.733 24.0783 11.1713 23.8325 11.455C23.5866 11.7386 23.1658 11.7686 22.8908 11.5151L21.3325 10.0971V18.5623C21.3325 20.4616 19.8408 22 17.9992 22H5.99917C4.1575 22 2.66584 20.4616 2.66584 18.5623V10.0971L1.10751 11.5151C0.832508 11.7643 0.407508 11.7386 0.165842 11.455C-0.0758243 11.1713 -0.0508243 10.733 0.224175 10.4838L11.5575 0.170809ZM3.99917 8.881V18.5623C3.99917 19.7011 4.895 20.6249 5.99917 20.6249H17.9992C19.1033 20.6249 19.9991 19.7011 19.9991 18.5623V8.881L11.9992 1.60174L3.99917 8.881Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const HomeRegular = ({ color = "#a0a0a0" }) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3312 1.12422C10.1437 0.958592 9.85939 0.958592 9.66877 1.12422L1.16938 8.62459C0.963144 8.80585 0.941271 9.12462 1.12563 9.33088C1.30999 9.53714 1.6256 9.55901 1.83183 9.37463L3.0005 8.34333V14.4999C3.0005 15.8812 4.11917 17 5.50032 17H14.4997C15.8808 17 16.9995 15.8812 16.9995 14.4999V8.34333L18.1682 9.37463C18.3744 9.55589 18.69 9.53714 18.8744 9.33088C19.0587 9.12462 19.0369 8.80898 18.8306 8.62459L10.3312 1.12422ZM4.00043 14.4999V7.45891L10 2.1649L15.9996 7.45891V14.4999C15.9996 15.328 15.3277 16 14.4997 16H12.4998V10.9997C12.4998 10.4466 12.053 9.99966 11.4999 9.99966H8.50011C7.94702 9.99966 7.50018 10.4466 7.50018 10.9997V16H5.50032C4.67225 16 4.00043 15.328 4.00043 14.4999ZM8.50011 16V10.9997H11.4999V16H8.50011Z"
      fill={color}
      fillOpacity="0.75"
      stroke={color}
    />
  </svg>
);

export const Table = ({ color = "#a0a0a0", size = 24 }) => (
  <svg
    height={size}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 1.57143C2.17031 1.57143 1.5 2.27366 1.5 3.14286V6.28571H22.5V3.14286C22.5 2.27366 21.8297 1.57143 21 1.57143H3ZM1.5 7.85714V13.3571H11.25V7.85714H1.5ZM12.75 7.85714V13.3571H22.5V7.85714H12.75ZM11.25 14.9286H1.5V18.8571C1.5 19.7263 2.17031 20.4286 3 20.4286H11.25V14.9286ZM12.75 20.4286H21C21.8297 20.4286 22.5 19.7263 22.5 18.8571V14.9286H12.75V20.4286ZM0 3.14286C0 1.40937 1.34531 0 3 0H21C22.6547 0 24 1.40937 24 3.14286V18.8571C24 20.5906 22.6547 22 21 22H3C1.34531 22 0 20.5906 0 18.8571V3.14286Z"
      fill={color}
    />
  </svg>
);

export const TableRegular = ({ color = "#a0a0a0" }) => (
  <svg
    height="15"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.375 0.928571C1.85645 0.928571 1.4375 1.34353 1.4375 1.85714V3.71429H14.5625V1.85714C14.5625 1.34353 14.1436 0.928571 13.625 0.928571H2.375ZM1.4375 4.64286V7.89286H7.53125V4.64286H1.4375ZM8.46875 4.64286V7.89286H14.5625V4.64286H8.46875ZM7.53125 8.82143H1.4375V11.1429C1.4375 11.6565 1.85645 12.0714 2.375 12.0714H7.53125V8.82143ZM8.46875 12.0714H13.625C14.1436 12.0714 14.5625 11.6565 14.5625 11.1429V8.82143H8.46875V12.0714ZM0.5 1.85714C0.5 0.832812 1.34082 0 2.375 0H13.625C14.6592 0 15.5 0.832812 15.5 1.85714V11.1429C15.5 12.1672 14.6592 13 13.625 13H2.375C1.34082 13 0.5 12.1672 0.5 11.1429V1.85714Z"
      fill={color}
    />
  </svg>
);

export const TableRegularFilled = ({ color = "#a0a0a0" }) => (
  <svg
    height="15"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.375 6.5V3.71429H7.0625V6.5H2.375ZM2.375 8.35714H7.0625V11.1429H2.375V8.35714ZM8.9375 11.1429V8.35714H13.625V11.1429H8.9375ZM13.625 6.5H8.9375V3.71429H13.625V6.5ZM2.375 0C1.34082 0 0.5 0.832812 0.5 1.85714V11.1429C0.5 12.1672 1.34082 13 2.375 13H13.625C14.6592 13 15.5 12.1672 15.5 11.1429V1.85714C15.5 0.832812 14.6592 0 13.625 0H2.375Z"
      fill="#3D734A"
    />
  </svg>
);

export const PinLocation = ({ color = "#a0a0a0", size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 12C8.23768 12 9.42466 11.493 10.2998 10.5905C11.175 9.68793 11.6667 8.46385 11.6667 7.1875C11.6667 5.91115 11.175 4.68707 10.2998 3.78455C9.42466 2.88203 8.23768 2.375 7 2.375C5.76232 2.375 4.57534 2.88203 3.70017 3.78455C2.825 4.68707 2.33333 5.91115 2.33333 7.1875C2.33333 8.46385 2.825 9.68793 3.70017 10.5905C4.57534 11.493 5.76232 12 7 12ZM13 7.1875C13 10.3715 10.6667 12.9969 7.66667 13.3363V22.3125C7.66667 22.6906 7.36667 23 7 23C6.63333 23 6.33333 22.6906 6.33333 22.3125V13.3363C3.33333 12.9926 1 10.3715 1 7.1875C1 3.77148 3.6875 1 7 1C10.3125 1 13 3.77148 13 7.1875ZM5 7.1875C5 7.56563 4.7 7.875 4.33333 7.875C3.96667 7.875 3.66667 7.56563 3.66667 7.1875C3.66667 5.28828 5.15833 3.75 7 3.75C7.36667 3.75 7.66667 4.05938 7.66667 4.4375C7.66667 4.81562 7.36667 5.125 7 5.125C5.89583 5.125 5 6.04883 5 7.1875Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>
);

export const PinLocationLight = () => (
  <svg
    width="9"
    height="17"
    viewBox="0 0 9 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 8.5C5.42826 8.5 6.3185 8.13125 6.97487 7.47487C7.63125 6.8185 8 5.92826 8 5C8 4.07174 7.63125 3.1815 6.97487 2.52513C6.3185 1.86875 5.42826 1.5 4.5 1.5C3.57174 1.5 2.6815 1.86875 2.02513 2.52513C1.36875 3.1815 1 4.07174 1 5C1 5.92826 1.36875 6.8185 2.02513 7.47487C2.6815 8.13125 3.57174 8.5 4.5 8.5ZM9 5C9 7.31563 7.25 9.225 5 9.47188V16C5 16.275 4.775 16.5 4.5 16.5C4.225 16.5 4 16.275 4 16V9.47188C1.75 9.22188 0 7.31563 0 5C0 2.51562 2.01562 0.5 4.5 0.5C6.98438 0.5 9 2.51562 9 5ZM3 5C3 5.275 2.775 5.5 2.5 5.5C2.225 5.5 2 5.275 2 5C2 3.61875 3.11875 2.5 4.5 2.5C4.775 2.5 5 2.725 5 3C5 3.275 4.775 3.5 4.5 3.5C3.67188 3.5 3 4.17188 3 5Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const TargetLocation = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.125 11C15.125 13.2773 13.2773 15.125 11 15.125C8.68398 15.125 6.875 13.2773 6.875 11C6.875 8.68398 8.68398 6.875 11 6.875C13.2773 6.875 15.125 8.68398 15.125 11ZM11 8.25C9.4832 8.25 8.25 9.4832 8.25 11C8.25 12.5168 9.4832 13.75 11 13.75C12.5168 13.75 13.75 12.5168 13.75 11C13.75 9.4832 12.5168 8.25 11 8.25ZM11 0C11.3781 0 11.6875 0.307828 11.6875 0.6875V2.77836C15.6965 3.10879 18.8891 6.30352 19.2199 10.3125H21.3125C21.6906 10.3125 22 10.6219 22 11C22 11.3781 21.6906 11.6875 21.3125 11.6875H19.2199C18.8891 15.6965 15.6965 18.8891 11.6875 19.2199V21.3125C11.6875 21.6906 11.3781 22 11 22C10.6219 22 10.3125 21.6906 10.3125 21.3125V19.2199C6.30352 18.8891 3.10879 15.6965 2.77836 11.6875H0.6875C0.307828 11.6875 0 11.3781 0 11C0 10.6219 0.307828 10.3125 0.6875 10.3125H2.77836C3.10879 6.30352 6.30352 3.10879 10.3125 2.77836V0.6875C10.3125 0.307828 10.6219 0 11 0ZM4.125 11C4.125 14.7984 7.20156 17.875 11 17.875C14.7984 17.875 17.875 14.7984 17.875 11C17.875 7.20156 14.7984 4.125 11 4.125C7.20156 4.125 4.125 7.20156 4.125 11Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const CommandLight = ({ color = "#a0a0a0" }) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.69022 13.8046C6.87865 14.1054 7.27801 14.2093 7.59299 14.0398C7.59299 14.0398 7.59581 14.0398 7.59581 14.0371L13.0209 10.9937C13.0209 10.9937 13.0237 10.9937 13.0237 10.991C13.3387 10.8078 13.4456 10.4113 13.2599 10.0996L8.5717 2.20557C8.38609 1.89112 7.97267 1.78448 7.64924 1.96494L2.24104 5.0028C1.92324 5.18053 1.81074 5.57427 1.98792 5.88599C1.98792 5.88872 1.99074 5.88872 1.99074 5.89146L6.68741 13.8019C6.68741 13.8046 6.69022 13.8046 6.69022 13.8074V13.8046ZM5.91682 14.2531C5.91119 14.2449 5.90838 14.2367 5.90276 14.2285L1.21452 6.33716C1.2089 6.32895 1.20608 6.32075 1.20046 6.31255C0.781414 5.58795 1.04015 4.66647 1.78262 4.24812L7.2077 1.2048C7.95579 0.783709 8.91481 1.03253 9.34792 1.7626L14.0446 9.67305C14.4749 10.3977 14.2218 11.3219 13.4821 11.7457C13.4765 11.7484 13.4681 11.7539 13.4624 11.7566L8.05422 14.7917C8.0486 14.7945 8.04016 14.7999 8.03454 14.8027C7.29207 15.2101 6.35274 14.9667 5.91682 14.2558V14.2531ZM10.1157 14.6441L11.0494 14.1218C11.0747 14.1246 11.1 14.1273 11.1253 14.1273H17.4251C17.7991 14.1273 18.1 13.8347 18.1 13.4711V4.28093C18.1 3.91726 17.7991 3.62469 17.4251 3.62469H11.491L10.9763 2.75517C11.0241 2.7497 11.0747 2.7497 11.1253 2.7497H17.4251C18.2941 2.7497 19 3.43602 19 4.28093V13.4683C19 14.3132 18.2941 14.9995 17.4251 14.9995H11.1253C10.74 14.9995 10.3885 14.8656 10.1157 14.6441Z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>
);

export const Money = () => (
  <svg
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25.5"
      r="24"
      fill="#7AB889"
      fillOpacity="0.64"
      stroke="#2E5738"
      strokeWidth="2"
    />
    <path
      d="M25 45C30.0391 45 34.8718 42.9982 38.435 39.435C41.9982 35.8718 44 31.0391 44 26C44 20.9609 41.9982 16.1282 38.435 12.565C34.8718 9.00178 30.0391 7 25 7C19.9609 7 15.1282 9.00178 11.565 12.565C8.00178 16.1282 6 20.9609 6 26C6 31.0391 8.00178 35.8718 11.565 39.435C15.1282 42.9982 19.9609 45 25 45ZM26.5437 16.9156V17.9695C27.2637 18.0586 27.9836 18.259 28.6961 18.4594C28.8371 18.4965 28.9707 18.5336 29.1117 18.5781C29.9652 18.8156 30.4699 19.6988 30.2324 20.5523C29.9949 21.4059 29.1117 21.9031 28.2582 21.673C28.1395 21.6434 28.0281 21.6062 27.9094 21.5766C27.3898 21.4281 26.8703 21.2871 26.3434 21.1832C25.3637 20.9977 24.2281 21.0867 23.3152 21.4801C22.4988 21.8363 21.8234 22.6973 22.7512 23.291C23.4785 23.7586 24.3691 23.9961 25.2152 24.2262C25.3934 24.2707 25.5641 24.3227 25.7348 24.3672C26.8926 24.6938 28.3695 25.1168 29.4754 25.8738C30.9152 26.8609 31.5906 28.4641 31.2715 30.1859C30.9672 31.8484 29.8094 32.9395 28.4215 33.5035C27.8426 33.741 27.2117 33.8895 26.5512 33.9637V35.0918C26.5512 35.975 25.8313 36.6949 24.948 36.6949C24.0648 36.6949 23.3449 35.975 23.3449 35.0918V33.8004C22.2687 33.5555 21.2148 33.2141 20.1684 32.8727C19.3297 32.598 18.8695 31.6852 19.1516 30.8465C19.4336 30.0078 20.3391 29.5477 21.1777 29.8297C21.3633 29.8891 21.5488 29.9559 21.7344 30.0152C22.573 30.2973 23.434 30.5867 24.2949 30.7277C25.5566 30.9133 26.566 30.802 27.2266 30.5348C28.1172 30.1785 28.5402 29.1172 27.6645 28.5234C26.9148 28.0113 25.9871 27.759 25.1039 27.5215C24.9332 27.477 24.7699 27.4324 24.5992 27.3805C23.4785 27.0613 22.0758 26.668 21.0219 25.9926C19.5746 25.0648 18.8398 23.5211 19.1516 21.8066C19.4484 20.1887 20.7102 19.1125 22.0461 18.5336C22.4543 18.3555 22.8922 18.2145 23.3449 18.1105V16.9156C23.3449 16.0324 24.0648 15.3125 24.948 15.3125C25.8313 15.3125 26.5512 16.0324 26.5512 16.9156H26.5437Z"
      fill="#2E5738"
    />
  </svg>
);

export const Waiter = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="60" height="60" rx="30" fill="#F2F2F2" />
    <path
      d="M29.9996 18.9168C30.6412 18.9168 31.2765 19.0397 31.8693 19.2784C32.4621 19.5171 33.0007 19.867 33.4543 20.3081C33.908 20.7492 34.2679 21.2728 34.5134 21.8491C34.759 22.4254 34.8853 23.0431 34.8853 23.6668C34.8853 24.2906 34.759 24.9083 34.5134 25.4846C34.2679 26.0609 33.908 26.5845 33.4543 27.0256C33.0007 27.4667 32.4621 27.8165 31.8693 28.0553C31.2765 28.294 30.6412 28.4168 29.9996 28.4168C29.358 28.4168 28.7227 28.294 28.1299 28.0553C27.5372 27.8165 26.9986 27.4667 26.5449 27.0256C26.0912 26.5845 25.7313 26.0609 25.4858 25.4846C25.2403 24.9083 25.1139 24.2906 25.1139 23.6668C25.1139 23.0431 25.2403 22.4254 25.4858 21.8491C25.7313 21.2728 26.0912 20.7492 26.5449 20.3081C26.9986 19.867 27.5372 19.5171 28.1299 19.2784C28.7227 19.0397 29.358 18.9168 29.9996 18.9168ZM23.4853 23.6668C23.4853 25.3465 24.1716 26.9574 25.3933 28.1452C26.615 29.3329 28.2719 30.0002 29.9996 30.0002C31.7273 30.0002 33.3842 29.3329 34.6059 28.1452C35.8276 26.9574 36.5139 25.3465 36.5139 23.6668C36.5139 21.9871 35.8276 20.3762 34.6059 19.1885C33.3842 18.0008 31.7273 17.3335 29.9996 17.3335C28.2719 17.3335 26.615 18.0008 25.3933 19.1885C24.1716 20.3762 23.4853 21.9871 23.4853 23.6668ZM28.371 32.3752C27.9232 32.3752 27.5568 32.7314 27.5568 33.1668C27.5568 33.6022 27.9232 33.9585 28.371 33.9585H28.8698L27.7654 37.1746L26.1318 33.7358C25.9842 33.4241 25.6483 33.241 25.3022 33.3004C21.4903 33.9832 18.5996 37.239 18.5996 41.1478C18.5996 41.989 19.3019 42.6668 20.162 42.6668H39.8372C40.7024 42.6668 41.3996 41.984 41.3996 41.1478C41.3996 37.239 38.5089 33.9882 34.6919 33.3004C34.3459 33.2361 34.01 33.4241 33.8624 33.7358L32.2338 37.1746L31.1294 33.9585H31.6282C32.076 33.9585 32.4425 33.6022 32.4425 33.1668C32.4425 32.7314 32.076 32.3752 31.6282 32.3752H29.9996H28.371ZM29.2617 40.3166L28.768 39.2726L29.9996 35.6705L31.2363 39.2726L30.7426 40.3166C30.4526 40.9301 29.5568 40.9301 29.2617 40.3166ZM27.7807 40.9796C27.7959 41.0142 27.8163 41.0489 27.8316 41.0835H20.2282C20.2587 38.2088 22.2384 35.7843 24.9459 35.0075L27.7807 40.9796ZM39.771 41.0835H32.1676C32.1829 41.0489 32.2033 41.0142 32.2185 40.9796L35.0533 35.0075C37.7608 35.7843 39.7405 38.2038 39.771 41.0835Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const Blocked = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3035 18.2746L3.72539 4.69648C2.26016 6.38516 1.375 8.58945 1.375 11C1.375 16.3152 5.68477 20.625 11 20.625C13.4105 20.625 15.6148 19.7398 17.3035 18.2746ZM18.2746 17.3035C19.7398 15.6148 20.625 13.4105 20.625 11C20.625 5.68477 16.3152 1.375 11 1.375C8.58945 1.375 6.38516 2.26016 4.69648 3.72539L18.2746 17.3035ZM0 11C0 8.08262 1.15893 5.28473 3.22183 3.22183C5.28473 1.15893 8.08262 0 11 0C13.9174 0 16.7153 1.15893 18.7782 3.22183C20.8411 5.28473 22 8.08262 22 11C22 13.9174 20.8411 16.7153 18.7782 18.7782C16.7153 20.8411 13.9174 22 11 22C8.08262 22 5.28473 20.8411 3.22183 18.7782C1.15893 16.7153 0 13.9174 0 11Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const WaiterLight = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.25C9.50653 1.25 10.0081 1.347 10.4761 1.53545C10.944 1.72391 11.3692 2.00013 11.7274 2.34835C12.0856 2.69657 12.3697 3.10997 12.5635 3.56494C12.7574 4.01991 12.8571 4.50754 12.8571 5C12.8571 5.49246 12.7574 5.98009 12.5635 6.43506C12.3697 6.89003 12.0856 7.30343 11.7274 7.65165C11.3692 7.99987 10.944 8.27609 10.4761 8.46455C10.0081 8.653 9.50653 8.75 9 8.75C8.49347 8.75 7.99191 8.653 7.52394 8.46455C7.05596 8.27609 6.63076 7.99987 6.27259 7.65165C5.91442 7.30343 5.6303 6.89003 5.43646 6.43506C5.24262 5.98009 5.14286 5.49246 5.14286 5C5.14286 4.50754 5.24262 4.01991 5.43646 3.56494C5.6303 3.10997 5.91442 2.69657 6.27259 2.34835C6.63076 2.00013 7.05596 1.72391 7.52394 1.53545C7.99191 1.347 8.49347 1.25 9 1.25ZM3.85714 5C3.85714 6.32608 4.39898 7.59785 5.36345 8.53553C6.32792 9.47322 7.63603 10 9 10C10.364 10 11.6721 9.47322 12.6365 8.53553C13.601 7.59785 14.1429 6.32608 14.1429 5C14.1429 3.67392 13.601 2.40215 12.6365 1.46447C11.6721 0.526784 10.364 0 9 0C7.63603 0 6.32792 0.526784 5.36345 1.46447C4.39898 2.40215 3.85714 3.67392 3.85714 5ZM7.71429 11.875C7.36071 11.875 7.07143 12.1562 7.07143 12.5C7.07143 12.8438 7.36071 13.125 7.71429 13.125H8.10804L7.23616 15.6641L5.94643 12.9492C5.82991 12.7031 5.56473 12.5586 5.29152 12.6055C2.28214 13.1445 0 15.7148 0 18.8008C0 19.4648 0.554464 20 1.23348 20H16.7665C17.4496 20 18 19.4609 18 18.8008C18 15.7148 15.7179 13.1484 12.7045 12.6055C12.4313 12.5547 12.1661 12.7031 12.0496 12.9492L10.7638 15.6641L9.89196 13.125H10.2857C10.6393 13.125 10.9286 12.8438 10.9286 12.5C10.9286 12.1562 10.6393 11.875 10.2857 11.875H9H7.71429ZM8.41741 18.1445L8.02768 17.3203L9 14.4766L9.97634 17.3203L9.58661 18.1445C9.35759 18.6289 8.65045 18.6289 8.41741 18.1445ZM7.24821 18.668C7.26027 18.6953 7.27634 18.7227 7.28839 18.75H1.28571C1.30982 16.4805 2.87277 14.5664 5.01027 13.9531L7.24821 18.668ZM16.7143 18.75H10.7116C10.7237 18.7227 10.7397 18.6953 10.7518 18.668L12.9897 13.9531C15.1272 14.5664 16.6902 16.4766 16.7143 18.75Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const CashRegister = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5625 1.125C9.87187 1.125 10.125 1.37812 10.125 1.6875V2.8125C10.125 3.12188 9.87187 3.375 9.5625 3.375H2.8125C2.50312 3.375 2.25 3.12188 2.25 2.8125V1.6875C2.25 1.37812 2.50312 1.125 2.8125 1.125H9.5625ZM2.8125 0C1.88086 0 1.125 0.755859 1.125 1.6875V2.8125C1.125 3.74414 1.88086 4.5 2.8125 4.5H5.625V5.625H3.07617C1.9582 5.625 1.00547 6.44766 0.847266 7.55508L0.0210938 13.3418C0.00703125 13.4473 0 13.5527 0 13.6582V15.75C0 16.991 1.00898 18 2.25 18H15.75C16.991 18 18 16.991 18 15.75V13.6582C18 13.5527 17.993 13.4438 17.9789 13.3418L17.1492 7.55508C16.991 6.44766 16.0418 5.625 14.9203 5.625H6.75V4.5H9.5625C10.4941 4.5 11.25 3.74414 11.25 2.8125V1.6875C11.25 0.755859 10.4941 0 9.5625 0H2.8125ZM1.125 15.75V14.625H16.875V15.75C16.875 16.3723 16.3723 16.875 15.75 16.875H2.25C1.62773 16.875 1.125 16.3723 1.125 15.75ZM16.0383 7.7168L16.8645 13.5H1.13555L1.96172 7.7168C2.04258 7.16133 2.51719 6.75 3.07617 6.75H14.9238C15.4828 6.75 15.9574 7.16133 16.0383 7.7168ZM3.9375 8.15625C3.71372 8.15625 3.49911 8.24514 3.34088 8.40338C3.18264 8.56161 3.09375 8.77622 3.09375 9C3.09375 9.22378 3.18264 9.43839 3.34088 9.59662C3.49911 9.75486 3.71372 9.84375 3.9375 9.84375C4.16128 9.84375 4.37589 9.75486 4.53412 9.59662C4.69236 9.43839 4.78125 9.22378 4.78125 9C4.78125 8.77622 4.69236 8.56161 4.53412 8.40338C4.37589 8.24514 4.16128 8.15625 3.9375 8.15625ZM6.46875 9C6.46875 9.22378 6.55764 9.43839 6.71588 9.59662C6.87411 9.75486 7.08872 9.84375 7.3125 9.84375C7.53628 9.84375 7.75089 9.75486 7.90912 9.59662C8.06736 9.43839 8.15625 9.22378 8.15625 9C8.15625 8.77622 8.06736 8.56161 7.90912 8.40338C7.75089 8.24514 7.53628 8.15625 7.3125 8.15625C7.08872 8.15625 6.87411 8.24514 6.71588 8.40338C6.55764 8.56161 6.46875 8.77622 6.46875 9ZM5.625 10.9688C5.40122 10.9688 5.18661 11.0576 5.02838 11.2159C4.87014 11.3741 4.78125 11.5887 4.78125 11.8125C4.78125 12.0363 4.87014 12.2509 5.02838 12.4091C5.18661 12.5674 5.40122 12.6562 5.625 12.6562C5.84878 12.6562 6.06339 12.5674 6.22162 12.4091C6.37986 12.2509 6.46875 12.0363 6.46875 11.8125C6.46875 11.5887 6.37986 11.3741 6.22162 11.2159C6.06339 11.0576 5.84878 10.9688 5.625 10.9688ZM9.84375 9C9.84375 9.22378 9.93264 9.43839 10.0909 9.59662C10.2491 9.75486 10.4637 9.84375 10.6875 9.84375C10.9113 9.84375 11.1259 9.75486 11.2841 9.59662C11.4424 9.43839 11.5312 9.22378 11.5312 9C11.5312 8.77622 11.4424 8.56161 11.2841 8.40338C11.1259 8.24514 10.9113 8.15625 10.6875 8.15625C10.4637 8.15625 10.2491 8.24514 10.0909 8.40338C9.93264 8.56161 9.84375 8.77622 9.84375 9ZM9 10.9688C8.77622 10.9688 8.56161 11.0576 8.40338 11.2159C8.24514 11.3741 8.15625 11.5887 8.15625 11.8125C8.15625 12.0363 8.24514 12.2509 8.40338 12.4091C8.56161 12.5674 8.77622 12.6562 9 12.6562C9.22378 12.6562 9.43839 12.5674 9.59662 12.4091C9.75486 12.2509 9.84375 12.0363 9.84375 11.8125C9.84375 11.5887 9.75486 11.3741 9.59662 11.2159C9.43839 11.0576 9.22378 10.9688 9 10.9688ZM13.2188 9C13.2188 9.1108 13.2406 9.22052 13.283 9.32289C13.3254 9.42526 13.3875 9.51827 13.4659 9.59662C13.5442 9.67497 13.6372 9.73712 13.7396 9.77952C13.842 9.82193 13.9517 9.84375 14.0625 9.84375C14.1733 9.84375 14.283 9.82193 14.3854 9.77952C14.4878 9.73712 14.5808 9.67497 14.6591 9.59662C14.7375 9.51827 14.7996 9.42526 14.842 9.32289C14.8844 9.22052 14.9062 9.1108 14.9062 9C14.9062 8.8892 14.8844 8.77948 14.842 8.67711C14.7996 8.57474 14.7375 8.48173 14.6591 8.40338C14.5808 8.32503 14.4878 8.26288 14.3854 8.22048C14.283 8.17807 14.1733 8.15625 14.0625 8.15625C13.9517 8.15625 13.842 8.17807 13.7396 8.22048C13.6372 8.26288 13.5442 8.32503 13.4659 8.40338C13.3875 8.48173 13.3254 8.57474 13.283 8.67711C13.2406 8.77948 13.2188 8.8892 13.2188 9ZM12.375 10.9688C12.1512 10.9688 11.9366 11.0576 11.7784 11.2159C11.6201 11.3741 11.5312 11.5887 11.5312 11.8125C11.5312 12.0363 11.6201 12.2509 11.7784 12.4091C11.9366 12.5674 12.1512 12.6562 12.375 12.6562C12.5988 12.6562 12.8134 12.5674 12.9716 12.4091C13.1299 12.2509 13.2188 12.0363 13.2188 11.8125C13.2188 11.5887 13.1299 11.3741 12.9716 11.2159C12.8134 11.0576 12.5988 10.9688 12.375 10.9688Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const PhoneLight = () => (
  <svg
    width="13"
    height="20"
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.6 1.25C1.88094 1.25 1.3 1.80859 1.3 2.5V17.5C1.3 18.1914 1.88094 18.75 2.6 18.75H10.4C11.1191 18.75 11.7 18.1914 11.7 17.5V2.5C11.7 1.80859 11.1191 1.25 10.4 1.25H2.6ZM0 2.5C0 1.12109 1.16594 0 2.6 0H10.4C11.8341 0 13 1.12109 13 2.5V17.5C13 18.8789 11.8341 20 10.4 20H2.6C1.16594 20 0 18.8789 0 17.5V2.5ZM5.2 15.625H7.8C8.1575 15.625 8.45 15.9062 8.45 16.25C8.45 16.5938 8.1575 16.875 7.8 16.875H5.2C4.8425 16.875 4.55 16.5938 4.55 16.25C4.55 15.9062 4.8425 15.625 5.2 15.625Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const PixLight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.06249 9.50525L8.06281 9.50557C8.06271 9.50547 8.0626 9.50536 8.06249 9.50525ZM8.06249 9.50525L8.06237 9.50513C8.06241 9.50517 8.06245 9.50521 8.06249 9.50525ZM10.4626 11.9055L10.4627 11.9056C10.8055 12.2481 11.2213 12.493 11.6747 12.6256L9.36566 14.9347C9.36566 14.9347 9.36565 14.9347 9.36565 14.9347C8.61162 15.6886 7.38915 15.6886 6.63522 14.9347L6.63522 14.9347L4.37323 12.6727C4.88306 12.5527 5.35155 12.2932 5.73064 11.9143L5.73073 11.9142L8.10108 9.54384L10.4626 11.9055Z"
      stroke="#A0A0A0"
    />
    <path
      d="M9.36559 1.06553L11.6745 3.37452C11.2212 3.50708 10.8053 3.75197 10.4626 4.09454L10.4625 4.09465L8.10084 6.45652L5.73062 4.08588L5.73051 4.08576C5.35144 3.70688 4.88298 3.44748 4.3732 3.3274L6.63509 1.06551L6.6351 1.0655C7.38902 0.311521 8.61146 0.311477 9.36557 1.06551C9.36558 1.06551 9.36558 1.06552 9.36559 1.06553ZM8.06218 6.49518C8.06234 6.49502 8.0625 6.49485 8.06267 6.49469L8.06218 6.49518Z"
      stroke="#A0A0A0"
    />
    <mask id="path-3-inside-1_2154_4546" fill="white">
      <path d="M15.2882 6.28132L13.4462 4.43934C13.4057 4.45558 13.3618 4.46572 13.3154 4.46572H12.4779C12.0449 4.46572 11.6211 4.64134 11.3151 4.94751L8.91535 7.34734C8.69078 7.57192 8.39568 7.68428 8.10087 7.68428C7.80577 7.68428 7.51089 7.57192 7.28639 7.34756L4.87756 4.93874C4.57161 4.6325 4.14776 4.45695 3.71478 4.45695H2.68499C2.64106 4.45695 2.60002 4.4466 2.56127 4.43201L0.711959 6.28132C-0.23732 7.2306 -0.23732 8.76957 0.711959 9.71885L2.56119 11.5681C2.60001 11.5535 2.64106 11.5431 2.68499 11.5431H3.71478C4.14776 11.5431 4.57161 11.3676 4.87756 11.0614L7.28616 8.65283C7.72152 8.21783 8.48043 8.21769 8.91535 8.65303L11.3151 11.0526C11.6211 11.3588 12.0449 11.5344 12.4779 11.5344H13.3154C13.3618 11.5344 13.4057 11.5446 13.4462 11.5608L15.2882 9.71884C16.2374 8.76956 16.2374 7.23059 15.2882 6.28131" />
    </mask>
    <path
      d="M13.4462 4.43934L14.1533 3.73223L13.6868 3.26573L13.0744 3.51104L13.4462 4.43934ZM11.3151 4.94751L12.0222 5.65461L12.0225 5.65437L11.3151 4.94751ZM8.91535 7.34734L9.62246 8.05445L9.62247 8.05444L8.91535 7.34734ZM7.28639 7.34756L6.57928 8.05467L6.57951 8.0549L7.28639 7.34756ZM4.87756 4.93874L4.17012 5.64552L4.17045 5.64585L4.87756 4.93874ZM2.56127 4.43201L2.91375 3.49619L2.3102 3.26886L1.85416 3.7249L2.56127 4.43201ZM0.711959 6.28132L1.41907 6.98843L1.41907 6.98843L0.711959 6.28132ZM0.711959 9.71885L1.41907 9.01175L1.41907 9.01175L0.711959 9.71885ZM2.56119 11.5681L1.85409 12.2752L2.30978 12.7309L2.91302 12.5042L2.56119 11.5681ZM4.87756 11.0614L4.17045 10.3543L4.1702 10.3546L4.87756 11.0614ZM7.28616 8.65283L6.57935 7.94543L6.57906 7.94572L7.28616 8.65283ZM8.91535 8.65303L8.2079 9.3598L8.20827 9.36016L8.91535 8.65303ZM11.3151 11.0526L12.0225 10.3458L12.0222 10.3455L11.3151 11.0526ZM13.4462 11.5608L13.0741 12.489L13.6867 12.7346L14.1533 12.2679L13.4462 11.5608ZM15.2882 9.71884L15.9953 10.4259L15.9953 10.4259L15.2882 9.71884ZM15.9953 5.57421L14.1533 3.73223L12.7391 5.14645L14.5811 6.98843L15.9953 5.57421ZM13.0744 3.51104C13.1318 3.48806 13.2142 3.46572 13.3154 3.46572V5.46572C13.5093 5.46572 13.6796 5.4231 13.8181 5.36764L13.0744 3.51104ZM13.3154 3.46572H12.4779V5.46572H13.3154V3.46572ZM12.4779 3.46572C11.7797 3.46572 11.1013 3.74673 10.6078 4.24066L12.0225 5.65437C12.1408 5.53596 12.3102 5.46572 12.4779 5.46572V3.46572ZM10.608 4.24042L8.20824 6.64025L9.62247 8.05444L12.0222 5.65461L10.608 4.24042ZM8.20824 6.64024C8.17924 6.66924 8.14205 6.68428 8.10087 6.68428V8.68428C8.64931 8.68428 9.20231 8.4746 9.62246 8.05445L8.20824 6.64024ZM8.10087 6.68428C8.05938 6.68428 8.02228 6.66922 7.99326 6.64023L6.57951 8.0549C6.99951 8.47463 7.55216 8.68428 8.10087 8.68428V6.68428ZM7.99349 6.64045L5.58467 4.23164L4.17045 5.64585L6.57928 8.05467L7.99349 6.64045ZM5.585 4.23197C5.09131 3.73782 4.4129 3.45695 3.71478 3.45695V5.45695C3.88261 5.45695 4.0519 5.52718 4.17012 5.64552L5.585 4.23197ZM3.71478 3.45695H2.68499V5.45695H3.71478V3.45695ZM2.68499 3.45695C2.79983 3.45695 2.8824 3.48438 2.91375 3.49619L2.20879 5.36783C2.31764 5.40882 2.4823 5.45695 2.68499 5.45695V3.45695ZM1.85416 3.7249L0.00485129 5.57421L1.41907 6.98843L3.26838 5.13911L1.85416 3.7249ZM0.0048519 5.57421C-1.33495 6.91402 -1.33495 9.08616 0.0048519 10.426L1.41907 9.01175C0.860312 8.45299 0.860312 7.54718 1.41907 6.98843L0.0048519 5.57421ZM0.00485129 10.426L1.85409 12.2752L3.2683 10.861L1.41907 9.01175L0.00485129 10.426ZM2.91302 12.5042C2.8823 12.5157 2.79985 12.5431 2.68499 12.5431V10.5431C2.48227 10.5431 2.31773 10.5913 2.20937 10.632L2.91302 12.5042ZM2.68499 12.5431H3.71478V10.5431H2.68499V12.5431ZM3.71478 12.5431C4.41289 12.5431 5.09126 12.2623 5.58492 11.7683L4.1702 10.3546C4.05195 10.4729 3.88262 10.5431 3.71478 10.5431V12.5431ZM5.58467 11.7685L7.99327 9.35993L6.57906 7.94572L4.17045 10.3543L5.58467 11.7685ZM7.99298 9.36023C8.00326 9.34995 8.03798 9.32655 8.1009 9.32655C8.16378 9.32656 8.19803 9.34991 8.2079 9.3598L9.6228 7.94627C8.79696 7.11963 7.40484 7.12062 6.57935 7.94543L7.99298 9.36023ZM8.20827 9.36016L10.608 11.7598L12.0222 10.3455L9.62244 7.9459L8.20827 9.36016ZM10.6078 11.7595C11.1013 12.2534 11.7797 12.5344 12.4779 12.5344V10.5344C12.3102 10.5344 12.1408 10.4642 12.0225 10.3458L10.6078 11.7595ZM12.4779 12.5344H13.3154V10.5344H12.4779V12.5344ZM13.3154 12.5344C13.2143 12.5344 13.1319 12.5122 13.0741 12.489L13.8184 10.6326C13.6795 10.577 13.5092 10.5344 13.3154 10.5344V12.5344ZM14.1533 12.2679L15.9953 10.4259L14.5811 9.01173L12.7391 10.8537L14.1533 12.2679ZM15.9953 10.4259C17.335 9.08613 17.335 6.91403 15.9953 5.57423L14.5811 6.98839C15.1398 7.54715 15.1398 8.453 14.5811 9.01176L15.9953 10.4259Z"
      fill="#A0A0A0"
      mask="url(#path-3-inside-1_2154_4546)"
    />
  </svg>
);

export const PixLightGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.06249 9.50525L8.06281 9.50557C8.06271 9.50547 8.0626 9.50536 8.06249 9.50525ZM8.06249 9.50525L8.06237 9.50513C8.06241 9.50517 8.06245 9.50521 8.06249 9.50525ZM10.4626 11.9055L10.4627 11.9056C10.8055 12.2481 11.2213 12.493 11.6747 12.6256L9.36566 14.9347C9.36566 14.9347 9.36565 14.9347 9.36565 14.9347C8.61162 15.6886 7.38915 15.6886 6.63522 14.9347L6.63522 14.9347L4.37323 12.6727C4.88306 12.5527 5.35155 12.2932 5.73064 11.9143L5.73073 11.9142L8.10108 9.54384L10.4626 11.9055Z"
      stroke="#3D734A"
    />
    <path
      d="M9.36559 1.06553L11.6745 3.37452C11.2212 3.50708 10.8053 3.75197 10.4626 4.09454L10.4625 4.09465L8.10084 6.45652L5.73062 4.08588L5.73051 4.08576C5.35144 3.70688 4.88298 3.44748 4.3732 3.3274L6.63509 1.06551L6.6351 1.0655C7.38902 0.311521 8.61146 0.311477 9.36557 1.06551C9.36558 1.06551 9.36558 1.06552 9.36559 1.06553ZM8.06218 6.49518C8.06234 6.49502 8.0625 6.49485 8.06267 6.49469L8.06218 6.49518Z"
      stroke="#3D734A"
    />
    <mask id="path-3-inside-1_2154_1385" fill="white">
      <path d="M15.2882 6.28132L13.4462 4.43934C13.4057 4.45558 13.3618 4.46572 13.3154 4.46572H12.4779C12.0449 4.46572 11.6211 4.64134 11.3151 4.94751L8.91535 7.34734C8.69078 7.57192 8.39568 7.68428 8.10087 7.68428C7.80577 7.68428 7.51089 7.57192 7.28639 7.34756L4.87756 4.93874C4.57161 4.6325 4.14776 4.45695 3.71478 4.45695H2.68499C2.64106 4.45695 2.60002 4.4466 2.56127 4.43201L0.711959 6.28132C-0.23732 7.2306 -0.23732 8.76957 0.711959 9.71885L2.56119 11.5681C2.60001 11.5535 2.64106 11.5431 2.68499 11.5431H3.71478C4.14776 11.5431 4.57161 11.3676 4.87756 11.0614L7.28616 8.65283C7.72152 8.21783 8.48043 8.21769 8.91535 8.65303L11.3151 11.0526C11.6211 11.3588 12.0449 11.5344 12.4779 11.5344H13.3154C13.3618 11.5344 13.4057 11.5446 13.4462 11.5608L15.2882 9.71884C16.2374 8.76956 16.2374 7.23059 15.2882 6.28131" />
    </mask>
    <path
      d="M13.4462 4.43934L14.1533 3.73223L13.6868 3.26573L13.0744 3.51104L13.4462 4.43934ZM11.3151 4.94751L12.0222 5.65461L12.0225 5.65437L11.3151 4.94751ZM8.91535 7.34734L9.62246 8.05445L9.62247 8.05444L8.91535 7.34734ZM7.28639 7.34756L6.57928 8.05467L6.57951 8.0549L7.28639 7.34756ZM4.87756 4.93874L4.17012 5.64552L4.17045 5.64585L4.87756 4.93874ZM2.56127 4.43201L2.91375 3.49619L2.3102 3.26886L1.85416 3.7249L2.56127 4.43201ZM0.711959 6.28132L1.41907 6.98843L1.41907 6.98843L0.711959 6.28132ZM0.711959 9.71885L1.41907 9.01175L1.41907 9.01175L0.711959 9.71885ZM2.56119 11.5681L1.85409 12.2752L2.30978 12.7309L2.91302 12.5042L2.56119 11.5681ZM4.87756 11.0614L4.17045 10.3543L4.1702 10.3546L4.87756 11.0614ZM7.28616 8.65283L6.57935 7.94543L6.57906 7.94572L7.28616 8.65283ZM8.91535 8.65303L8.2079 9.3598L8.20827 9.36016L8.91535 8.65303ZM11.3151 11.0526L12.0225 10.3458L12.0222 10.3455L11.3151 11.0526ZM13.4462 11.5608L13.0741 12.489L13.6867 12.7346L14.1533 12.2679L13.4462 11.5608ZM15.2882 9.71884L15.9953 10.4259L15.9953 10.4259L15.2882 9.71884ZM15.9953 5.57421L14.1533 3.73223L12.7391 5.14645L14.5811 6.98843L15.9953 5.57421ZM13.0744 3.51104C13.1318 3.48806 13.2142 3.46572 13.3154 3.46572V5.46572C13.5093 5.46572 13.6796 5.4231 13.8181 5.36764L13.0744 3.51104ZM13.3154 3.46572H12.4779V5.46572H13.3154V3.46572ZM12.4779 3.46572C11.7797 3.46572 11.1013 3.74673 10.6078 4.24066L12.0225 5.65437C12.1408 5.53596 12.3102 5.46572 12.4779 5.46572V3.46572ZM10.608 4.24042L8.20824 6.64025L9.62247 8.05444L12.0222 5.65461L10.608 4.24042ZM8.20824 6.64024C8.17924 6.66924 8.14205 6.68428 8.10087 6.68428V8.68428C8.64931 8.68428 9.20231 8.4746 9.62246 8.05445L8.20824 6.64024ZM8.10087 6.68428C8.05938 6.68428 8.02228 6.66922 7.99326 6.64023L6.57951 8.0549C6.99951 8.47463 7.55216 8.68428 8.10087 8.68428V6.68428ZM7.99349 6.64045L5.58467 4.23164L4.17045 5.64585L6.57928 8.05467L7.99349 6.64045ZM5.585 4.23197C5.09131 3.73782 4.4129 3.45695 3.71478 3.45695V5.45695C3.88261 5.45695 4.0519 5.52718 4.17012 5.64552L5.585 4.23197ZM3.71478 3.45695H2.68499V5.45695H3.71478V3.45695ZM2.68499 3.45695C2.79983 3.45695 2.8824 3.48438 2.91375 3.49619L2.20879 5.36783C2.31764 5.40882 2.4823 5.45695 2.68499 5.45695V3.45695ZM1.85416 3.7249L0.00485129 5.57421L1.41907 6.98843L3.26838 5.13911L1.85416 3.7249ZM0.0048519 5.57421C-1.33495 6.91402 -1.33495 9.08616 0.0048519 10.426L1.41907 9.01175C0.860312 8.45299 0.860312 7.54718 1.41907 6.98843L0.0048519 5.57421ZM0.00485129 10.426L1.85409 12.2752L3.2683 10.861L1.41907 9.01175L0.00485129 10.426ZM2.91302 12.5042C2.8823 12.5157 2.79985 12.5431 2.68499 12.5431V10.5431C2.48227 10.5431 2.31773 10.5913 2.20937 10.632L2.91302 12.5042ZM2.68499 12.5431H3.71478V10.5431H2.68499V12.5431ZM3.71478 12.5431C4.41289 12.5431 5.09126 12.2623 5.58492 11.7683L4.1702 10.3546C4.05195 10.4729 3.88262 10.5431 3.71478 10.5431V12.5431ZM5.58467 11.7685L7.99327 9.35993L6.57906 7.94572L4.17045 10.3543L5.58467 11.7685ZM7.99298 9.36023C8.00326 9.34995 8.03798 9.32655 8.1009 9.32655C8.16378 9.32656 8.19803 9.34991 8.2079 9.3598L9.6228 7.94627C8.79696 7.11963 7.40484 7.12062 6.57935 7.94543L7.99298 9.36023ZM8.20827 9.36016L10.608 11.7598L12.0222 10.3455L9.62244 7.9459L8.20827 9.36016ZM10.6078 11.7595C11.1013 12.2534 11.7797 12.5344 12.4779 12.5344V10.5344C12.3102 10.5344 12.1408 10.4642 12.0225 10.3458L10.6078 11.7595ZM12.4779 12.5344H13.3154V10.5344H12.4779V12.5344ZM13.3154 12.5344C13.2143 12.5344 13.1319 12.5122 13.0741 12.489L13.8184 10.6326C13.6795 10.577 13.5092 10.5344 13.3154 10.5344V12.5344ZM14.1533 12.2679L15.9953 10.4259L14.5811 9.01173L12.7391 10.8537L14.1533 12.2679ZM15.9953 10.4259C17.335 9.08613 17.335 6.91403 15.9953 5.57423L14.5811 6.98839C15.1398 7.54715 15.1398 8.453 14.5811 9.01176L15.9953 10.4259Z"
      fill="#3D734A"
      mask="url(#path-3-inside-1_2154_1385)"
    />
  </svg>
);

export const CheckCircle2 = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#3D734A" fillOpacity="0.15" />
    <path
      d="M41.6381 22.3614C42.1206 22.8433 42.1206 23.6226 41.6381 24.0993L28.0876 37.6386C27.6051 38.1205 26.8249 38.1205 26.3476 37.6386L19.3619 30.6665C18.8794 30.1846 18.8794 29.4053 19.3619 28.9285C19.8443 28.4518 20.6245 28.4467 21.1019 28.9285L27.2099 35.0292L39.893 22.3614C40.3755 21.8795 41.1557 21.8795 41.633 22.3614H41.6381Z"
      fill="#3D734A"
    />
  </svg>
);

export const Reload = () => (
  <svg
    width="20"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.0697 2.28271V8.28271H7.0697"
      stroke="#a0a0a0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5797 13.2827C4.2281 15.123 5.45704 16.7028 7.08136 17.784C8.70568 18.8652 10.6374 19.3893 12.5854 19.2771C14.5335 19.165 16.3923 18.4228 17.8818 17.1624C19.3714 15.902 20.411 14.1916 20.8439 12.289C21.2769 10.3864 21.0798 8.39462 20.2823 6.61376C19.4849 4.83291 18.1302 3.35946 16.4225 2.41543C14.7148 1.4714 12.7466 1.10793 10.8144 1.37978C8.88215 1.65163 7.09061 2.54408 5.7097 3.92266L1.0697 8.28266"
      stroke="#a0a0a0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserCircle = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#E6E6E6" />
    <path
      d="M28.3431 19.9504C28.3431 19.5023 28.2566 19.0585 28.0886 18.6445C27.9206 18.2305 27.6744 17.8543 27.364 17.5374C27.0535 17.2205 26.685 16.9691 26.2795 16.7977C25.8739 16.6262 25.4392 16.5379 25.0002 16.5379C24.5612 16.5379 24.1265 16.6262 23.7209 16.7977C23.3154 16.9691 22.9469 17.2205 22.6364 17.5374C22.326 17.8543 22.0798 18.2305 21.9118 18.6445C21.7438 19.0585 21.6573 19.5023 21.6573 19.9504C21.6573 20.3985 21.7438 20.8423 21.9118 21.2563C22.0798 21.6703 22.326 22.0465 22.6364 22.3634C22.9469 22.6803 23.3154 22.9316 23.7209 23.1031C24.1265 23.2746 24.5612 23.3629 25.0002 23.3629C25.4392 23.3629 25.8739 23.2746 26.2795 23.1031C26.685 22.9316 27.0535 22.6803 27.364 22.3634C27.6744 22.0465 27.9206 21.6703 28.0886 21.2563C28.2566 20.8423 28.3431 20.3985 28.3431 19.9504ZM20.5431 19.9504C20.5431 18.7437 21.0126 17.5863 21.8485 16.7331C22.6844 15.8798 23.8181 15.4004 25.0002 15.4004C26.1823 15.4004 27.316 15.8798 28.1519 16.7331C28.9877 17.5863 29.4573 18.7437 29.4573 19.9504C29.4573 21.1571 28.9877 22.3144 28.1519 23.1677C27.316 24.021 26.1823 24.5004 25.0002 24.5004C23.8181 24.5004 22.6844 24.021 21.8485 23.1677C21.0126 22.3144 20.5431 21.1571 20.5431 19.9504ZM18.3145 32.4629H31.6859C31.6441 29.6298 29.3807 27.3441 26.5915 27.3441H23.4089C20.6231 27.3441 18.3597 29.6298 18.3145 32.4629ZM17.2002 32.5446C17.2002 29.0433 19.9789 26.2066 23.4089 26.2066H26.5915C30.0214 26.2066 32.8002 29.0433 32.8002 32.5446C32.8002 33.1276 32.3371 33.6004 31.766 33.6004H18.2344C17.6633 33.6004 17.2002 33.1276 17.2002 32.5446Z"
      fill="#848484"
      fillOpacity="0.75"
    />
  </svg>
);

export const Coin = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3496 8.99961C16.3496 7.05027 15.5752 5.18077 14.1968 3.80237C12.8185 2.42398 10.9489 1.64961 8.99961 1.64961C7.05027 1.64961 5.18077 2.42398 3.80237 3.80237C2.42398 5.18077 1.64961 7.05027 1.64961 8.99961C1.64961 10.9489 2.42398 12.8185 3.80237 14.1968C5.18077 15.5752 7.05027 16.3496 8.99961 16.3496C10.9489 16.3496 12.8185 15.5752 14.1968 14.1968C15.5752 12.8185 16.3496 10.9489 16.3496 8.99961ZM0.599609 8.99961C0.599609 6.77179 1.48461 4.63522 3.05991 3.05991C4.63522 1.48461 6.77179 0.599609 8.99961 0.599609C11.2274 0.599609 13.364 1.48461 14.9393 3.05991C16.5146 4.63522 17.3996 6.77179 17.3996 8.99961C17.3996 11.2274 16.5146 13.364 14.9393 14.9393C13.364 16.5146 11.2274 17.3996 8.99961 17.3996C6.77179 17.3996 4.63522 16.5146 3.05991 14.9393C1.48461 13.364 0.599609 11.2274 0.599609 8.99961ZM9.52461 4.53711V5.2918C9.96758 5.32461 10.3974 5.44273 10.824 5.56414C10.8732 5.57727 10.9257 5.59367 10.9749 5.6068C11.2538 5.68555 11.4179 5.9743 11.3424 6.2532C11.267 6.53211 10.9749 6.69617 10.696 6.6207C10.6173 6.59773 10.5385 6.57477 10.4598 6.5518C10.2137 6.47961 9.96102 6.40742 9.70836 6.37133C9.08164 6.27945 8.50742 6.3582 8.0907 6.53867C7.66742 6.72242 7.48039 6.96852 7.44102 7.17852C7.38195 7.50008 7.50992 7.71992 7.7757 7.89055C8.12352 8.11367 8.64523 8.26133 9.27851 8.4418L9.28836 8.44508C9.86914 8.60914 10.5648 8.8093 11.0701 9.15711C11.6935 9.58367 11.9823 10.2662 11.8445 11.011C11.7132 11.7198 11.2243 12.1923 10.6041 12.4416C10.2793 12.5729 9.9118 12.6484 9.51805 12.668V13.4621C9.51805 13.7509 9.2818 13.9871 8.99305 13.9871C8.7043 13.9871 8.46805 13.7509 8.46805 13.4621V12.6123C8.20227 12.5696 7.75273 12.4416 7.40492 12.3366C7.17851 12.2677 6.95211 12.1955 6.7257 12.1234C6.45008 12.0315 6.30242 11.7362 6.39102 11.4605C6.47961 11.1849 6.7782 11.0373 7.05383 11.1259C7.27039 11.198 7.48695 11.267 7.7068 11.3326C8.0743 11.4441 8.45164 11.5491 8.62883 11.5754C9.27851 11.6705 9.82648 11.618 10.2038 11.4638C10.5713 11.3162 10.7551 11.093 10.8043 10.8174C10.8666 10.4729 10.7551 10.2137 10.4696 10.0168C10.0759 9.74773 9.59023 9.6132 9.12758 9.48523C9.05211 9.46555 8.97336 9.44258 8.90117 9.42289C8.34008 9.26539 7.68711 9.07836 7.20477 8.76992C6.93898 8.5993 6.68961 8.37289 6.53211 8.05789C6.37133 7.73633 6.32867 7.37539 6.40086 6.98164C6.52555 6.30242 7.05711 5.82992 7.66742 5.56742C7.91023 5.46242 8.1793 5.38367 8.46477 5.33445V4.53055C8.46477 4.2418 8.70102 4.00555 8.98977 4.00555C9.27851 4.00555 9.51477 4.2418 9.51477 4.53055L9.52461 4.53711Z"
      fill="#A0A0A0"
    />
  </svg>
);

export const GiftBlur = () => (
  <svg
    width="214"
    height="214"
    viewBox="0 0 214 214"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_6598_9764)">
      <rect
        x="57"
        y="57"
        width="100"
        height="100"
        rx="50"
        fill="white"
        fillOpacity="0.67"
      />
    </g>
    <rect x="57" y="57" width="100" height="100" rx="50" fill="#3D734A" />
    <path
      d="M101.137 90.2419L104.252 95.5413H104.136H97.6908C95.7124 95.5413 94.11 93.939 94.11 91.9606C94.11 89.9823 95.7124 88.3799 97.6908 88.3799H97.8877C99.2215 88.3799 100.466 89.0871 101.137 90.2419ZM89.8132 91.9606C89.8132 93.2497 90.1265 94.4671 90.6725 95.5413H86.9486C85.3641 95.5413 84.084 96.8215 84.084 98.4059V104.135C84.084 105.72 85.3641 107 86.9486 107H127.053C128.637 107 129.917 105.72 129.917 104.135V98.4059C129.917 96.8215 128.637 95.5413 127.053 95.5413H123.329C123.875 94.4671 124.188 93.2497 124.188 91.9606C124.188 87.61 120.661 84.083 116.311 84.083H116.114C113.258 84.083 110.608 85.5959 109.158 88.0576L107.001 91.7368L104.843 88.0666C103.393 85.5959 100.743 84.083 97.8877 84.083H97.6908C93.3402 84.083 89.8132 87.61 89.8132 91.9606ZM119.891 91.9606C119.891 93.939 118.289 95.5413 116.311 95.5413H109.865H109.749L112.864 90.2419C113.544 89.0871 114.78 88.3799 116.114 88.3799H116.311C118.289 88.3799 119.891 89.9823 119.891 91.9606ZM86.9486 109.864V125.619C86.9486 127.992 88.8732 129.916 91.2454 129.916H104.136V109.864H86.9486ZM109.865 129.916H122.756C125.128 129.916 127.053 127.992 127.053 125.619V109.864H109.865V129.916Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_6598_9764"
        x="0.799999"
        y="0.799999"
        width="212.4"
        height="212.4"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="28.1"
          result="effect1_foregroundBlur_6598_9764"
        />
      </filter>
    </defs>
  </svg>
);

export const UserSquare = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 30C0 15.8579 0 8.7868 4.3934 4.3934C8.7868 0 15.8579 0 30 0H40C54.1421 0 61.2132 0 65.6066 4.3934C70 8.7868 70 15.8579 70 30V40C70 54.1421 70 61.2132 65.6066 65.6066C61.2132 70 54.1421 70 40 70H30C15.8579 70 8.7868 70 4.3934 65.6066C0 61.2132 0 54.1421 0 40V30Z"
      fill="#3D734A"
      fillOpacity="0.1"
    />
    <path
      d="M39.2575 29.0248C39.2575 28.3871 39.1345 27.7556 38.8954 27.1664C38.6564 26.5772 38.3059 26.0419 37.8642 25.5909C37.4225 25.14 36.898 24.7823 36.3209 24.5382C35.7437 24.2942 35.1251 24.1686 34.5004 24.1686C33.8757 24.1686 33.2571 24.2942 32.6799 24.5382C32.1027 24.7823 31.5783 25.14 31.1366 25.5909C30.6948 26.0419 30.3444 26.5772 30.1054 27.1664C29.8663 27.7556 29.7432 28.3871 29.7432 29.0248C29.7432 29.6625 29.8663 30.294 30.1054 30.8832C30.3444 31.4724 30.6948 32.0077 31.1366 32.4587C31.5783 32.9096 32.1027 33.2673 32.6799 33.5114C33.2571 33.7554 33.8757 33.8811 34.5004 33.8811C35.1251 33.8811 35.7437 33.7554 36.3209 33.5114C36.898 33.2673 37.4225 32.9096 37.8642 32.4587C38.3059 32.0077 38.6564 31.4724 38.8954 30.8832C39.1345 30.294 39.2575 29.6625 39.2575 29.0248ZM28.1575 29.0248C28.1575 27.3075 28.8258 25.6606 30.0153 24.4463C31.2048 23.232 32.8182 22.5498 34.5004 22.5498C36.1826 22.5498 37.796 23.232 38.9855 24.4463C40.175 25.6606 40.8432 27.3075 40.8432 29.0248C40.8432 30.7421 40.175 32.389 38.9855 33.6033C37.796 34.8176 36.1826 35.4998 34.5004 35.4998C32.8182 35.4998 31.2048 34.8176 30.0153 33.6033C28.8258 32.389 28.1575 30.7421 28.1575 29.0248ZM24.9861 46.8311H44.0147C43.9552 42.7994 40.7342 39.5467 36.765 39.5467H32.2358C28.2715 39.5467 25.0505 42.7994 24.9861 46.8311ZM23.4004 46.9474C23.4004 41.9647 27.3548 37.9279 32.2358 37.9279H36.765C41.646 37.9279 45.6004 41.9647 45.6004 46.9474C45.6004 47.777 44.9413 48.4498 44.1286 48.4498H24.8721C24.0595 48.4498 23.4004 47.777 23.4004 46.9474Z"
      fill="#3D734A"
    />
  </svg>
);
